/*******************************************************************************
 * operations.js - Grid Operations and Event Handlers
 * 
 * This module contains all the Syncfusion grid event handlers and operations
 * referenced by the Razor template via operations.* in HTML attributes.
 * 
 * Note: Uses window.* references for dependencies that are set up by index.js
 ******************************************************************************/

// Use window references for all dependencies (set up by index.js before this loads)
const { ELEMENT_IDS, STORAGE_KEYS, API_ENDPOINTS } = window;
const { getElement, getGrid, showElement, hideElement, showDialog, hideDialog } = window;
const { logToServer, CheckIfConnectedToXero, tenantNotConnected } = window;

// State variables are stored on window for cross-module access

const operations = {
    onGetBills: function (callback) {
        $('#listReportBug').attr('disabled', 'disabled');

        var gridEl = document.getElementById("Grid");
        if (!gridEl || !gridEl.ej2_instances) {
            console.error('Grid not found or not initialized');
            return;
        }
        var grid = gridEl.ej2_instances[0];
        grid.showSpinner();

        let payload = {
            page: 1,
        }

        if (CheckIfConnectedToXero()) {
            var ajax = new ej.base.Ajax({
                url: API_ENDPOINTS.FILTER_BILLS,
                type: 'POST',
                data: JSON.stringify(payload),
                contentType: 'application/json',
                accept: 'application/json'
            })
            ajax.send()
            ajax.onSuccess = function (data) {
                var cDataSource = []
                var obj = JSON.parse(data)
                window.newDataRecord = obj.invoices;
                if (obj.isError) {
                    operations.errorHandling(obj)
                    grid.hideSpinner();
                    return
                }

                for (var i = 0; i < obj.invoices.length; i++) {

                    var dataSourceItems = {
                        amountDue: obj.invoices[i].amountDue,
                        amountPaid: obj.invoices[i].amountPaid,
                        amountDueEditable: obj.invoices[i].amountDueEditable,
                        amountCredited: obj.invoices[i].amountCredited,
                        contact: obj.invoices[i].contact,
                        contactName: obj.invoices[i].contactName,
                        date: new Date(obj.invoices[i].date),
                        plannedDate: new Date(obj.invoices[i].plannedDate),
                        dueDate: new Date(obj.invoices[i].dueDate),
                        emailAddress: obj.invoices[i].emailAddress,
                        hasEmailAddress: obj.invoices[i].hasEmailAddress,
                        invoiceID: obj.invoices[i].invoiceID,
                        invoiceNumber: obj.invoices[i].invoiceNumber,
                        paymentDate: obj.invoices[i].paymentDate,
                        reference: obj.invoices[i].reference,
                        sendDate: obj.invoices[i].sendDate,
                        status: obj.invoices[i].status,
                        sentToContact: obj.invoices[i].sentToContact,
                        hasBankDetails: obj.invoices[i].hasBankDetails,
                        CreditNoteID: obj.invoices[i].creditNoteID,
                        ListOfCreditNote: obj.invoices[i].listOfCreditNote,
                        Total: obj.invoices[i].total,
                        ListOfPayments: obj.invoices[i].listOfPayments
                    };

                    cDataSource.push(dataSourceItems)
                }


                grid.dataSource = cDataSource;
                grid.hideSpinner();
                
                // Hide global spinner
                var spinnerGlobal = document.getElementById("spinnerGlobal");
                if (spinnerGlobal) spinnerGlobal.style.visibility = "hidden";
                
                var totalEl = document.getElementById("total");
                var selectedBillsEl = document.getElementById("selectedBills");
                if (totalEl) totalEl.innerHTML = 0;
                if (selectedBillsEl) selectedBillsEl.innerHTML = 0;
                grid.clearCellSelection();
                grid.clearRowSelection();
                grid.clearSelection();
                if (grid.selectionModule) {
                    grid.selectionModule.deSelectedData = [];
                    grid.selectionModule.persistSelectedData = [];
                }

                // Update grid selection
                //updateSelectionBasedOnLocalStorage();

                $('#listReportBug').removeAttr('disabled');
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
            ajax.onFailure = function(e) {
                console.error('Failed to load bills:', e);
                grid.hideSpinner();
                var spinnerGlobal = document.getElementById("spinnerGlobal");
                if (spinnerGlobal) spinnerGlobal.style.visibility = "hidden";
            }
        }
        else {
            grid.hideSpinner();
            var spinnerGlobal = document.getElementById("spinnerGlobal");
            if (spinnerGlobal) spinnerGlobal.style.visibility = "hidden";
            tenantNotConnected();
        }
    },
    onFilterBillsSelected: function () {

        if (CheckIfConnectedToXero()) {
            var tranasctionType = "ExportDataFormat"
            $.ajax({
                url: API_ENDPOINTS.FILTER_BILLS_SELECTED + tranasctionType,
                type: 'GET',
                async: false,
                contentType: 'application/json',
                accept: 'application/json',
                success: (result) => {
                    objSelectedBills = JSON.parse(result)
                },
                error: (error) => {
                    console.log(error)
                }
            })
        }
        else
            tenantNotConnected()


    },
    onActionBegin: function (args) {
        // Check if the request type and column name areis filtered and Discontinued respectively
        if (args.requestType === "filterbeforeopen" && args.columnName === "plannedDate") {
            // Assign custom data source to the filter module data source
            // args.filterModel.options.dataSource = [{ Discontinued: true }, { Discontinued: false }];
            args.filterModel.options.dataSource = args.filterModel.options.dataSource.dataSource.json.filter(i => i.plannedDate.getFullYear() !== 1970)
            // Remove filtered field except custom data source field
            //args.filterModel.options.filteredColumns = args.filterModel.options.filteredColumns.filter(function (col) {
            //    if (col.field == "Discontinued") {
            //        return true;
            //    }
            //    return false;
            //});
        }
    },
    onGridDataBound: function (args) {
        if (args.data) {
            var hasEmail = args.data.hasEmailAddress;
            var hasBankDetails = args.data.hasBankDetails;
            var warningCell = args.row.querySelector('td[aria-colindex="1"]');
            
            if (warningCell) {
                if (!hasEmail || !hasBankDetails) {
                    var tooltip = '';
                    if (!hasEmail && !hasBankDetails) {
                        tooltip = 'Missing email address and bank details - Click to add';
                    } else if (!hasEmail) {
                        tooltip = 'Missing email address - Click to add';
                    } else {
                        tooltip = 'Missing bank details - Click to add';
                    }
                    
                    var billData = JSON.stringify(args.data).replace(/'/g, "\\'").replace(/"/g, '&quot;');
                    warningCell.innerHTML = '<div class="warning-indicator" title="' + tooltip + '" onclick="event.stopPropagation(); operations.onWarningIconClick(' + "'" + billData + "'" + ')"><span class="e-icons e-warning warning-icon"></span></div>';
                } else {
                    warningCell.innerHTML = '';
                }
            }
        }
    },
    
    onWarningIconClick: function (billDataStr) {
        try {
            var billData = JSON.parse(billDataStr.replace(/&quot;/g, '"'));
            if (typeof window.openMissingDataModal === 'function') {
                window.openMissingDataModal(billData);
            } else {
                console.error('openMissingDataModal function not found');
            }
        } catch (e) {
            console.error('Error parsing bill data:', e);
        }
    },
    onFilterBillStatus: function (args) {
        let dateRange = document.getElementById("invDateRangeFilter").ej2_instances[0]

        var grid = document.getElementById("Grid").ej2_instances[0]
        grid.showSpinner()

        let payload = {
            status: args.value,
            startDate: new Date(dateRange.startValue),
            endDate: new Date(dateRange.endValue)
        }

        if (CheckIfConnectedToXero()) {
            var ajax = new ej.base.Ajax({
                url: API_ENDPOINTS.FILTER_BILLS,
                type: 'POST',
                data: JSON.stringify(payload),
                contentType: 'application/json',
                accept: 'application/json'
            })
            ajax.send()
            ajax.onSuccess = function (data) {
                var obj = JSON.parse(data)
                if (obj.isError) {
                    operations.errorHandling(obj)
                    return
                }
                grid.dataSource = obj.invoices
                grid.hideSpinner()
            }
        }
        else
            tenantNotConnected()

    },
    onRadioChange: function (args) {
        console.log(args);
        bankOptionSelected = args.value;
        if (args.value == "DBS Bank") {
            document.getElementById("txtCompanyId").style.visibility = "visible";
            document.getElementById("txtCompanyId").style.display = "block";
            document.getElementById("btnCompanyId").style.visibility = "visible";
            document.getElementById("btnCompanyId").style.display = "block";
            document.getElementById("txtCompanyIdContainer").style.visibility = "visible";
            document.getElementById("txtCompanyIdContainer").style.display = "block";
        }
        else {
            document.getElementById("txtCompanyId").style.visibility = "hidden";
            document.getElementById("txtCompanyId").style.display = "none";
            document.getElementById("btnCompanyId").style.visibility = "hidden";
            document.getElementById("btnCompanyId").style.display = "none";
            document.getElementById("txtCompanyIdContainer").style.visibility = "hidden";
            document.getElementById("txtCompanyIdContainer").style.display = "none";
        }
    
    },
    onToolbarClick: function (args) {

        if (args.item.id === 'UpdateReference') {
            //var grid = document.getElementById("Grid").ej2_instances[0]
            //var records = grid.getSelectedRecords();
            //for (var i = 0; i < records.length; i++) {
            //    grid.updateCell(grid.getRowIndexByPrimaryKey(records[i].invoiceID), "invoiceNumber", "testUpdate1");
            //}
            //grid.editModule.batchSave()
            promptUpdateRef()
        }

        if (args.item.id === 'Export') {

            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            var promptDialogMoreInfoABA;
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomRightRadius = "10px";
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";
            /*            document.getElementById("progressStatus").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnBacs").style.visibility = "hidden";
            document.getElementById("apcaId").style.visibility = "hidden";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("chcbxIdAggregated").style.visibility = "hidden";
            document.getElementById("chcbxIdAggregated").style.display = "none";
            document.getElementById("sumInvoicesPerContact").style.display = "none";
            document.getElementById("btnUserChoice").style.visibility = "hidden";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            document.getElementById("bankOption").style.visibility = "hidden";
            document.getElementById("bankOption").style.display = "none";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                btnPromptOkayTransactionDate2
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0]
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0]
            grid.showSpinner()

            if (window.isSharedView) {
                var sharedSelected = grid.getSelectedRecords();
                if (sharedSelected.length === 0) {
                    grid.hideSpinner();
                    var dialog = document.getElementById("dialog").ej2_instances[0];
                    document.getElementById("message").innerHTML = "* Please select bills to export. <br/><br/>";
                    dialog.show();
                    return;
                }
                promptTransactionDate();
                document.getElementById("btnPromptOkayTransactionDate").onclick = function() {
                    if (dateTransaction.value === null) return;
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0];
                    dialog.hide();
                    grid.hideSpinner();
                    var td = dateTransaction.value;
                    var formattedDate = (td.getMonth()+1) + '/' + td.getDate() + '/' + td.getFullYear();
                    window.initiateSharedExport(sharedSelected, formattedDate);
                };
                return;
            }

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices

            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();

                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "";

                if (selectedInvoices.length === 0) {
                    message += "* Please select bills to export. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                grid.hideSpinner()

                dialog.firstClose = function (args) {
                    console.log('Icon x is clicked' ,args)
                }
         

            } else {
                promptTransactionDate();
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {
                    if (dateTransaction.value === null)
                        return


                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    dialog.hide()

                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0]
                    document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoices.length} bills in Xero to populate bank account in ABA file`

                    var dlgHeader = document.getElementById("promptDialog_dialog-header")
                    dlgHeader.classList.add("prompt-dlg-header-template")

                    var dlgContent = document.getElementById("promptDialog_dialog-content")
                    dlgContent.classList.add("dlg-content-template")

                    document.getElementById("errorContentBank").style.display = "none";

                    document.getElementById("txtBatchReferenceNo").style.display = "none";
                    //document.getElementById("messageBatchReferenceNo").style.display = "none";
                    //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''

                    document.getElementById("txtBacsServiceUserNo").style.display = "none";
                    //document.getElementById("messageBacsServiceUserNo").style.display = "none";
                    //document.getElementById("errorContentBacsServiceUserNo").innerHTML = ''

                    //document.getElementById("txtNarrativeUserChoice").style.display = "none";
                    //document.getElementById("messageNarrativeUserChoice").style.display = "none";
                    //document.getElementById("errorNarrativeUserChoice").innerHTML = ''

                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("btnInfoParticulars").style.visibility = "hidden";
                    //document.getElementById("messageAuthorityNumber").style.display = "none";
                    //document.getElementById("messageAuthorityNumber").innerHTML = '';
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtBatchReferenceNoContainer").style.display = "none";
                    document.getElementById("txtCompanyId").style.display = "none";
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").value = "";
                    document.getElementById("txtapcaId").value = "";
                    document.getElementById("txtLodgementReferenceFrom").style.display = "none";
                    document.getElementById("txtLodgementReferenceFrom").value = "";
                    document.getElementById("messageLodgementFrom").style.display = "none";
                    document.getElementById("errorLodgementFrom").innerHTML = ''
                    document.getElementById("btnInfoFrom").style.visibility = "hidden";
                    document.getElementById("btnInfoTo").style.visibility = "hidden";
                    var bankDropDown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0]

                    document.getElementById("errorContentBank").innerHTML = ''
                    promptDialog.show()
                    /*        document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting Bank Account...</span>";*/
                    document.getElementById("progressStatuss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus2").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                    document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                 
                    document.getElementById("spinner1").style.visibility = "visible";
                    document.getElementById("btnOkay").style.visibility = "visible";
                    const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkay");
                    btnPromptOkayTransactionDateEnable.disabled = true;

                    document.getElementById("messageBank").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").hide();

                    document.getElementById("messageBank").style.display = "none";
                    document.getElementById("messageBankDeUserId").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'none');

                    document.getElementById("messageBankMp").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();

       
                    document.getElementById("messageBankMp").style.display = "none";
                    document.getElementById("messageBankDeUserIdMp").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');
                    var count = 25;
                    var intervalBank = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(intervalBank);
                            return;
                        }
                        count += 1;
                    }, 100);


                    $.ajax({
                        url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                        type: 'GET',
                        headers: {
                            'Accept': 'application/json; charset=utf-8'
                        },
                        success: (result) => {
                            if (result.isError) {
                                operations.errorHandling(result)
                                return
                            }
                            else {

                                if (result.bankAccounts.length > 0) {
                                    document.getElementById("spinner1").style.visibility = "hidden";
                                    btnPromptOkayTransactionDateEnable.disabled = false;
                                    document.getElementById("btnOkay").style.display = "initial";
                                    document.getElementById("messageBank").style.display = "initial";
                                    var bankname = bankAccountName;
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'flex');
                                    document.getElementById("btnOkay").style.visibility = "visible";
                                    document.getElementById("messageBank").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceFrom").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceFrom").style.visibility = "visible";
                                    document.getElementById("btnInfoFrom").style.visibility = "visible";

                                    var showApcaId = bankAccountName.includes("Bendigo") || 
                                        (typeof window.isUseBpayChecked === 'function' && window.isUseBpayChecked());
                                    if (showApcaId) {
                                        document.getElementById("apcaId").style.visibility = "visible";
                                        document.getElementById("apcaId").style.display = "initial";
                                        document.getElementById("messageapcaId").style.display = "initial";
                                        document.getElementById("messageapcaId").innerHTML = '';
                                        document.getElementById("txtapcaId").style.visibility = "visible";
                                        document.getElementById("txtapcaId").style.display = "initial";
                                    }
                                    else {
                                        document.getElementById("apcaId").style.visibility = "hidden";
                                        document.getElementById("apcaId").style.display = "none";
                                        document.getElementById("messageapcaId").style.display = "none";
                                        document.getElementById("messageapcaId").style.visibility = "hidden";
                                    }

                                    if (showLodgementReference) {
                                        document.getElementById("txtLodgementReferenceTo").style.display = "initial";
                                        document.getElementById("txtLodgementReferenceTo").style.visibility = "visible";
                                      
                                       
                                        document.getElementById("btnInfoTo").style.visibility = "visible";
                                    }
                                    
                                    // Show BPAY checkboxes for AU region
                                    if (typeof countryCode !== 'undefined' && countryCode === "AU") {
                                        document.getElementById("bpayCheckboxRow").style.display = "block";
                                        document.getElementById("useBpayCheckboxContainer").style.display = "block";
                                        document.getElementById("useNabBpayCheckboxContainer").style.display = "block";
                                        // Reset CBA BPAY checkbox and fields
                                        var chkUseBpay = document.getElementById("chkUseBpay");
                                        if (chkUseBpay && chkUseBpay.ej2_instances && chkUseBpay.ej2_instances[0]) {
                                            chkUseBpay.ej2_instances[0].checked = false;
                                        }
                                        document.getElementById("bpayInfoContainer").style.display = "none";
                                        // Reset NAB BPAY checkbox and fields
                                        var chkUseNabBpay = document.getElementById("chkUseNabBpay");
                                        if (chkUseNabBpay && chkUseNabBpay.ej2_instances && chkUseNabBpay.ej2_instances[0]) {
                                            chkUseNabBpay.ej2_instances[0].checked = false;
                                        }
                                        document.getElementById("nabBpayFieldsContainer").style.display = "none";
                                    } else {
                                        document.getElementById("bpayCheckboxRow").style.display = "none";
                                        document.getElementById("useBpayCheckboxContainer").style.display = "none";
                                        document.getElementById("bpayInfoContainer").style.display = "none";
                                        document.getElementById("useNabBpayCheckboxContainer").style.display = "none";
                                        document.getElementById("nabBpayFieldsContainer").style.display = "none";
                                    }
                                    //document.getElementById("btnInfoFrom").onclick = function (e) {
                                    //    promptDialogMoreInfoABA = document.getElementById("promptDialogMoreInfoABA").ej2_instances[0]
                                    //    document.getElementById("promptDialogMoreInfoABA").style.maxHeight = '';

                                    //    var dlgHeader = document.getElementById("promptDialogMoreInfoABA_dialog-header")
                                    //    dlgHeader.classList.add("prompt-dlg-header-template")
                                    //    var dlgContent = document.getElementById("promptDialogMoreInfoABA_dialog-content")
                                    //    dlgContent.classList.add("dlg-content-template")

                                    //    promptDialogMoreInfoABA.show();
                                    //}
                                    //document.getElementById("btnMoreInfoABACancel").onclick = function (e) {
                                    //    promptDialogMoreInfoABA.hide();
                                    //}
                                    //document.getElementById("btnInfoTo").onclick = function (e) {

                                    //}
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").show();
                                    bankDropDown.dataSource = result.bankAccounts
                                }
                                else
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                            }
                        },
                        error: (error) => {
                            document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
                        }
                    })

                    document.getElementById("btnOkay").onclick = function (e) {
                        document.getElementById("spinner1").style.visibility = "visible";
                       // document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                        if (bankAccount === null || bankAccount.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountName == null || bankAccountName.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account name'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        }
                        else {
                            document.getElementById("messageBank").style.display = "none";
                            document.getElementById("messageBank").innerHTML = ''
                        }
                        
                        // Check if BPAY export is selected (AU region only)
                        if (typeof window.isUseBpayChecked === 'function' && window.isUseBpayChecked()) {
                            // Call CBA BPAY export
                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                            var apcaIdValue = document.getElementById("txtapcaId").value || "301500";
                            var exportToBpay = {
                                bankAccountNumber: bankAccount,
                                bankAccountName: bankAccountName,
                                bankAccountCode: bankAccountCode,
                                bankAccountID: bankAccountID,
                                invoices: selectedInvoices,
                                lodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                transactionDate: formatDate(dateTransaction.value),
                                sumInvoicesPerContact: document.getElementById("sumInvoicesPerContact").ej2_instances[0].checked,
                                ApcaID: apcaIdValue
                            };
                            
                            fetch(API_ENDPOINTS.EXPORT_CBA_BPAY, {
                                body: JSON.stringify(exportToBpay),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                }
                            }).then(response => {
                                  const contentType = response.headers.get('content-type');
                                  if (contentType && contentType.includes('application/json')) {
                                      return response.json().then(data => {
                                          if (data.isError || data.IsError) {
                                              throw new Error(data.message || data.Message || 'Error exporting BPAY file');
                                          }
                                          return data;
                                      });
                                  }
                                  return response.blob();
                              })
                              .then(response => {
                                  document.getElementById("spinner1").style.visibility = "hidden";
                                  if (response instanceof Blob) {
                                      const blob = new Blob([response], { type: 'text/plain' });
                                      const downloadUrl = URL.createObjectURL(blob);
                                      const a = document.createElement("a");
                                      a.href = downloadUrl;
                                      a.download = "bpay_batch_" + new Date().toISOString().slice(0,10).replace(/-/g,'') + ".aba";
                                      document.body.appendChild(a);
                                      a.click();
                                      document.body.removeChild(a);
                                      URL.revokeObjectURL(downloadUrl);
                                      
                                      var promptDialog = document.getElementById("promptDialog").ej2_instances[0];
                                      promptDialog.hide();
                                      grid.hideSpinner();
                                      
                                      var dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0];
                                      document.getElementById("messageAfterExport").innerHTML = "Please ensure the BPAY ABA file can be successfully imported in your banking portal (e.g. CommBiz > File Transfer > Import Payment File > Direct Entry), and then proceed to 'Mark as Paid'";
                                      var dlgHeader = document.getElementById("dialogAfterExport_dialog-header");
                                      var dlgContent = document.getElementById("dialogAfterExport_dialog-content");
                                      dlgHeader.classList.add("prompt-dlg-header-template");
                                      dlgContent.classList.add("dlg-content-template");
                                      dialogAfterExport.show();
                                      
                                      document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                          dialogAfterExport.hide();
                                      };
                                  }
                              })
                              .catch(error => {
                                  document.getElementById("spinner1").style.visibility = "hidden";
                                  console.error('BPAY export error:', error);
                                  alert('Error exporting BPAY file: ' + error.message);
                              });
                            return;
                        }

                        // Check if NAB BPAY export is selected (AU region only)
                        else if (typeof window.isUseNabBpayChecked === 'function' && window.isUseNabBpayChecked()) {
                            var nabUserId = document.getElementById("txtNabBpayUserId").value;
                            var nabShortName = document.getElementById("txtNabCustomerShortName").value;
                            if (!nabUserId || nabUserId.trim() === '') {
                                alert('NAB User ID is required for NAB BPAY export.');
                                document.getElementById("spinner1").style.visibility = "hidden";
                                return;
                            }
                            if (!nabShortName || nabShortName.trim() === '') {
                                alert('NAB Customer Short Name is required for NAB BPAY export.');
                                document.getElementById("spinner1").style.visibility = "hidden";
                                return;
                            }
                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                            var apcaIdValue = document.getElementById("txtapcaId").value || "301500";
                            var exportToNabBpay = {
                                bankAccountNumber: bankAccount,
                                bankAccountName: bankAccountName,
                                bankAccountCode: bankAccountCode,
                                bankAccountID: bankAccountID,
                                invoices: selectedInvoices,
                                lodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                transactionDate: formatDate(dateTransaction.value),
                                sumInvoicesPerContact: false,
                                ApcaID: apcaIdValue,
                                nabBpayUserId: nabUserId,
                                nabCustomerShortName: nabShortName
                            };

                            fetch(API_ENDPOINTS.EXPORT_NAB_BPAY, {
                                body: JSON.stringify(exportToNabBpay),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                }
                            }).then(response => {
                                  if (!response.ok) {
                                      const contentType = response.headers.get('content-type');
                                      if (contentType && contentType.includes('application/json')) {
                                          return response.json().then(data => {
                                              throw new Error(data.message || data.Message || 'Error exporting NAB BPAY file (HTTP ' + response.status + ')');
                                          });
                                      }
                                      throw new Error('Error exporting NAB BPAY file (HTTP ' + response.status + ')');
                                  }
                                  const contentType = response.headers.get('content-type');
                                  if (contentType && contentType.includes('application/json')) {
                                      return response.json().then(data => {
                                          if (data.isError || data.IsError) {
                                              throw new Error(data.message || data.Message || 'Error exporting NAB BPAY file');
                                          }
                                          return data;
                                      });
                                  }
                                  return response.blob();
                              })
                              .then(response => {
                                  document.getElementById("spinner1").style.visibility = "hidden";
                                  if (response instanceof Blob) {
                                      const blob = new Blob([response], { type: 'text/plain' });
                                      const downloadUrl = URL.createObjectURL(blob);
                                      const a = document.createElement("a");
                                      a.href = downloadUrl;
                                      a.download = "nab_bpay_batch_" + new Date().toISOString().slice(0,10).replace(/-/g,'') + ".bpb";
                                      document.body.appendChild(a);
                                      a.click();
                                      document.body.removeChild(a);
                                      URL.revokeObjectURL(downloadUrl);

                                      var promptDialog = document.getElementById("promptDialog").ej2_instances[0];
                                      promptDialog.hide();
                                      grid.hideSpinner();

                                      var dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0];
                                      document.getElementById("messageAfterExport").innerHTML = "Please ensure the NAB BPAY file can be successfully imported in NAB Connect, and then proceed to 'Mark as Paid'";
                                      var dlgHeader = document.getElementById("dialogAfterExport_dialog-header");
                                      var dlgContent = document.getElementById("dialogAfterExport_dialog-content");
                                      dlgHeader.classList.add("prompt-dlg-header-template");
                                      dlgContent.classList.add("dlg-content-template");
                                      dialogAfterExport.show();

                                      document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                          dialogAfterExport.hide();
                                      };
                                  }
                              })
                              .catch(error => {
                                  document.getElementById("spinner1").style.visibility = "hidden";
                                  console.error('NAB BPAY export error:', error);
                                  alert('Error exporting NAB BPAY file: ' + error.message);
                              });
                            return;
                        }
                     
                        //document.getElementById("messageBank").style.display = "block";
                        //document.getElementById("messageBank").innerHTML = 'No bank account code'
                        //if (bankAccount === null || bankAccountName == null || bankAccount.length === 0 || bankAccountName.length === 0)
                        //    return

                        //var dialogProgress1 = document.getElementById("prompProgressDialog").ej2_instances[0]

                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                        dlgHeader.classList.add("prompt-dlg-header-template")
                        dlgContent.classList.add("dlg-content-template")

                        //dialogProgress1.show()

                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                        //var count = 50;
                        //var exportIntervalStart = setInterval(function () {

                        //    if (count <= 65) {
                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                        //    } else {
                        //        clearInterval(exportIntervalStart);
                        //        return;
                        //    }
                        //    count += 1;
                        //}, 100);

                        let errorCount = 0;
                        //promptDialog.hide()

                        var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                        var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                        var ApcaID = document.getElementById("txtapcaId").value;

                        if (bankAccountName.includes("Bendigo"))
                        {
                            if (ApcaID.length == 0 || ApcaID == null) {
                                document.getElementById("messageapcaId").style.display = "block";
                                document.getElementById("messageapcaId").style.visibility = "visible";
                                document.getElementById("messageapcaId").innerHTML = 'Apca ID is required'
                                document.getElementById("spinner1").style.visibility = "hidden";
                                return
                            }
                            else {
                                document.getElementById("messageapcaId").style.display = "none";
                                document.getElementById("messageapcaId").innerHTML = ''
                            }
                        }
                        if (LodgementReferenceNumberFrom.length == 0 || LodgementReferenceNumberFrom == null) {

                            document.getElementById("messageLodgementFrom").style.display = "block";
                            document.getElementById("messageLodgementFrom").innerHTML = 'Lodgement Reference From is required'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        }
                        else {
                            document.getElementById("messageLodgementFrom").style.display = "none";
                            document.getElementById("messageLodgementFrom").innerHTML = ''
                        }




                        isFormatChecking = true;
                        let exportToABA = {
                            bankAccountNumber: bankAccount,
                            bankAccountName: bankAccountName,
                            bankAccountCode: bankAccountCode,
                            bankAccountID: bankAccountID,
                            errorCount: errorCount,
                            invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            hasLodgementReference: showLodgementReference,
                            LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                            LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                            ApcaID: ApcaID,
                            TransactionDate: formatDate(dateTransaction.value)
                        }
                        if (CheckIfConnectedToXero()) {
                            fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT_CHECK, {
                                body: JSON.stringify(exportToABA),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                },
                            }).then(response => response.json())
                                .then(response => {
                                    if (response.result == false) {
                                        var dialog = document.getElementById("promptDialogABA").ej2_instances[0]
                                        document.getElementById("promptDialogABA").style.maxHeight = ""
                                        if (response.error.length > 0)
                                            selectedInvoiceWithNoBankDetails = response.error

                                        var fileFormat = "ABA";
                                        var titleFormat = "";

                                        switch (countryCode) {
                                            case 'NZ':
                                                fileFormat = "a CSV";
                                                titleFormat = "CSV"
                                                break;
                                            case 'AU':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'CA':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'GB':
                                                fileFormat = "a BACS";
                                                titleFormat = "BACS"
                                                $("#progressStatus3 > div").text("Export BatchPay File");
                                                break;
                                        }

                                        var errorlist = "";
                                        document.getElementById("errorlist").innerHTML = "";
                                        let list = document.getElementById("errorlist");
                                        for (let i = 0; i < response.error.length; i++) {
                                            //errorlist += response.error[i].error + "\n";
                                           //errorCount++;
                                            let li = document.createElement('li');
                                            li.innerText = response.error[i].error;
                                            list.appendChild(li);
                                        }


                                        errorCount = response.countIssue
                                        document.getElementById("fileFormat").innerHTML = titleFormat;
                                        document.getElementById("prompt").innerHTML = "You are about to generate a BatchPay file containing " + response.countInvoice + " bills. The file however contains " + response.countIssue + " errors.";
                                        var dlgHeader = document.getElementById("promptDialogABA_dialog-header")
                                        var dlgContent = document.getElementById("promptDialogABA_dialog-content")

                                        dlgHeader.classList.add("error-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")



                                        //dialogProgress1.hide()
                                        document.getElementById("spinnerError").style.visibility = "visible";
                                        document.getElementById("btnShowIssues").style.visibility = "hidden";
                                        document.getElementById("btnABAOkay").style.visibility = "visible";
                                        const btnABAOkayEnabled = document.getElementById("btnABAOkay");
                                        btnABAOkayEnabled.disabled = true;

                                        dialog.show()

                                        var count = 65;
                                        var exportIntervalEnd = setInterval(function () {

                                            if (count <= 75) {
                                                document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                            } else {

                                                document.getElementById("btnShowIssues").style.visibility = "visible";
                                                var countResponseWithNoBankDetails = response.error.filter(i => i.hasBankDetails == false).length;
                                                if (selectedInvoices.length === countResponseWithNoBankDetails) {
                                                    //document.getElementById("btnABAOkay").style.display = "none";
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = true;
                                                } else {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = false;
                                                }

                                                clearInterval(exportIntervalEnd);
                                                return;
                                            }
                                            count += 1;
                                        }, 100);
                                        document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                        document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                                        document.getElementById("progressStatus3").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                    /*    document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                        grid.hideSpinner()
                                        promptDialog.hide()



                                        document.getElementById("btnABAOkay").onclick = function (e) {
                                            document.getElementById("spinnerError").style.visibility = "visible";
                                            //document.getElementById("spinnerErrorExportFile").style.visibility = "visible";
                                            document.getElementById("btnABAOkay").setAttribute("disabled", true);
                                            document.getElementById("btnShowIssues").setAttribute("disabled", true);
                                            var count = 75;
                                            var exportToAbbaInterval = setInterval(function () {

                                                if (count <= 100) {
                                                    document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                                } else {
                                                    document.getElementById("btnABAOkay").removeAttribute("disabled");
                                                    document.getElementById("btnShowIssues").removeAttribute("disabled");
                                                    clearInterval(exportToAbbaInterval);
                                                    return;
                                                }
                                                count += 1;
                                            }, 200);
                                                document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                                document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay From</div>";
                                                document.getElementById("progressStatus3").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                     /*       document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                            var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                                            selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID && i.hasBankDetails == false))

                                            let exportToABA2 = {
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                ApcaID: ApcaID,
                                                TransactionDate: formatDate(dateTransaction.value)
                                            }

                                            fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT, {
                                                body: JSON.stringify(exportToABA2),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = "batch_payments_export.aba"
                                                    document.body.appendChild(a)

                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()

                                                    //document.getElementById("step1").ej2_instances[0].disabled = true

                                                })

                                        }
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialogAfterExport.hide()
                                            dialog.hide()
                                        }

                                        document.getElementById("btnABACancel").onclick = function (e) {
                                            dialog.hide()
                                            grid.hideSpinner()
                                        }

                                        document.getElementById("btnShowIssues").onclick = function (e) {

                                            //var blob = new Blob([errorlist], { type: "text/plain;charset=utf-8" });
                                            //const downloadUrl = URL.createObjectURL(blob)
                                            //const a = document.createElement("a")
                                            //a.href = downloadUrl
                                            //a.download = "errors_batch_payments_export.aba"
                                            //document.body.appendChild(a)
                                            //a.click()
                                            //grid.hideSpinner()
                                            dialogViewErrorList = document.getElementById("dialogViewErrorList").ej2_instances[0]
                                            //document.getElementById("errorlist").innerHTML = errorlist
                                            var x = errorlist;
                                            //let list = document.getElementById("errorlist");

                                            //for (i = 0; i < errorlist.length; ++i) {
                                            //    let li = document.createElement('li');
                                            //    li.innerText = errorlist[i];
                                            //    list.appendChild(li);
                                            //}

                                            var dlgHeader = document.getElementById("dialogViewErrorList_dialog-header")
                                            var dlgContent = document.getElementById("dialogViewErrorList_dialog-content")

                                            dlgHeader.classList.add("error-dlg-header-template")
                                            dlgContent.classList.add("dlg-content-template")

                                            dialogViewErrorList.show()

                                           
                                        }
                                        document.getElementById("btnViewErrorList").onclick = function (e) {
                                            dialogViewErrorList.hide()
                                            //dialog.hide()
                                        }
                                    } else if (response.result == true) {
                                        //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]

                                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")
                                        grid.hideSpinner()
                                        promptDialog.hide()
                                        fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT, {
                                            body: JSON.stringify(exportToABA),
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json; charset=utf-8'
                                            },
                                        }).then(response => response.blob())
                                            .then(response => {
                                                document.getElementById("spinner1").style.visibility = "hidden";
                                                const blob = new Blob([response], { type: 'text/plain' })
                                                const downloadUrl = URL.createObjectURL(blob)
                                                const a = document.createElement("a")
                                                a.href = downloadUrl
                                                a.download = "batch_payments_export.aba"
                                                document.body.appendChild(a)
                                                a.click()
                                                grid.hideSpinner()
                                                dialogProgress.hide()
                                                window.disabledGridEditing = false

                                                var messageAfterExport = "";
                                                messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                dlgHeader.classList.add("prompt-dlg-header-template")
                                                dlgContent.classList.add("dlg-content-template")
                                                promptDialog.hide()
                                                dialogAfterExport.show()
                                                grid.hideSpinner()
                                                //document.getElementById("step1").ej2_instances[0].disabled = true
                                            })

                                    }
                                })
                            document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                dialogAfterExport.hide()
                                dialog.hide()
                            }
                        }
                        else {
                            tenantNotConnected()
                            dialogProgress.hide()
                        }
                    }
                    document.getElementById("btnCancel").onclick = function (e) {
                        promptDialog.hide()
                        grid.hideSpinner()
                    }
                }
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    grid.hideSpinner()
                    dialog.hide()
                }
            }
        }

        // BPAY Export Handler
        if (args.item.id === 'ExportNabBpay') {
            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            
            // Set dialog styling
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            
            // Set progress indicators
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BPAY File</div>";
            
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            
            // Hide ABA-specific fields (APCA ID is shown via onUseBpayChange)
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("bankOption").style.visibility = "hidden";
            document.getElementById("bankOption").style.display = "none";
            document.getElementById("txtCompanyIdContainer").style.display = "none";
            document.getElementById("chcbxIdAggregated").style.visibility = "hidden";
            document.getElementById("chcbxIdAggregated").style.display = "none";
            
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0];
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0];
            grid.showSpinner();

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices;
            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();

                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord;
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "* Please select bills to export. <br/><br/>";
                var dialog = document.getElementById("dialog").ej2_instances[0];
                document.getElementById("message").innerHTML = message;
                var dlgHeader = document.getElementById("dialog_dialog-header");
                var dlgContent = document.getElementById("dialog_dialog-content");
                dlgHeader.classList.add("error-dlg-header-template");
                dlgContent.classList.add("dlg-content-template");
                dialog.show();
                grid.hideSpinner();
            } else {
                promptTransactionDate();
                $("#promptInfoDialogTransactionDate_title .e-icon-settings").text("Export BPAY File");
                
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {
                    if (dateTransaction.value === null) return;
                    
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0];
                    dialog.hide();
                    
                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0];
                    document.getElementById("prompt").innerHTML = `Please confirm you'd like to export ${selectedInvoices.length} bills to BPAY ABA file`;
                    
                    var dlgHeader = document.getElementById("promptDialog_dialog-header");
                    dlgHeader.classList.add("prompt-dlg-header-template");
                    var dlgContent = document.getElementById("promptDialog_dialog-content");
                    dlgContent.classList.add("dlg-content-template");
                    
                    // Show/hide fields for BPAY
                    document.getElementById("txtBatchReferenceNoContainer").style.display = "block";
                    document.getElementById("txtBacsServiceUserNo").parentElement.parentElement.style.display = "none";
                    document.getElementById("txtapcaId").parentElement.parentElement.parentElement.style.display = "block";
                    document.getElementById("txtParticulars").parentElement.parentElement.style.display = "none";
                    
                    promptDialog.show();
                    
                    document.getElementById("btnCancel").onclick = () => {
                        promptDialog.hide();
                        grid.hideSpinner();
                    };
                    
                    document.getElementById("btnOkay").onclick = async () => {
                        var bankAccountDropdown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0];
                        var selectedBankAccount = bankAccountDropdown.value;
                        var selectedBankAccountName = bankAccountDropdown.text;
                        
                        if (!selectedBankAccount) {
                            document.getElementById("messageBank").style.visibility = "visible";
                            return;
                        }
                        document.getElementById("messageBank").style.visibility = "hidden";
                        
                        var lodgementReferenceFrom = document.getElementById("txtLodgementReferenceFrom").value;
                        var lodgementReferenceTo = document.getElementById("txtLodgementReferenceTo").value;
                        var batchReferenceNo = document.getElementById("txtBatchReferenceNo").value;
                        
                        var apcaIdValue = document.getElementById("txtapcaId").value || "301500";
                        var payload = {
                            BankAccountName: selectedBankAccountName,
                            BankAccountNumber: selectedBankAccount,
                            TransactionDate: dateTransaction.value.toLocaleDateString('en-AU'),
                            Invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            sumInvoicesPerContact: true,
                            LodgementReferenceNumberFrom: lodgementReferenceFrom,
                            LodgementReferenceNumberTo: lodgementReferenceTo,
                            BatchReferenceNo: batchReferenceNo,
                            ApcaID: apcaIdValue
                        };
                        
                        document.getElementById("spinner1").style.visibility = "visible";
                        
                        try {
                            const response = await fetch(API_ENDPOINTS.EXPORT_CBA_BPAY, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(payload)
                            });
                            
                            if (response.ok) {
                                const contentType = response.headers.get('content-type');
                                if (contentType && contentType.includes('application/json')) {
                                    const result = await response.json();
                                    if (result.IsError) {
                                        alert(result.Message);
                                    }
                                } else {
                                    const blob = await response.blob();
                                    const url = window.URL.createObjectURL(blob);
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.download = 'bpay_batch_' + new Date().toISOString().slice(0,10).replace(/-/g,'') + '.aba';
                                    document.body.appendChild(a);
                                    a.click();
                                    window.URL.revokeObjectURL(url);
                                    a.remove();
                                    
                                    promptDialog.hide();
                                    grid.hideSpinner();
                                    
                                    var dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0];
                                    document.getElementById("afterExportPrompt").innerHTML = "BPAY ABA file has been exported successfully. Import it into your banking portal (e.g. CommBiz > File Transfer > Import Payment File > Direct Entry).";
                                    dialogAfterExport.show();
                                }
                            } else {
                                const errorResult = await response.json();
                                alert('Export failed: ' + (errorResult.Message || 'Unknown error'));
                            }
                        } catch (error) {
                            console.error('BPAY export error:', error);
                            alert('Export failed: ' + error.message);
                        } finally {
                            document.getElementById("spinner1").style.visibility = "hidden";
                        }
                    };
                };
                
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0];
                    grid.hideSpinner();
                    dialog.hide();
                };
            }
        }

        if (args.item.id === 'ExportKundupei') {

            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            var promptDialogMoreInfoABA;
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomRightRadius = "10px";
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";
            /*            document.getElementById("progressStatus").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnBacs").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.display = "none";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("apcaId").innerHTML = '';
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("chcbxIdAggregated").style.visibility = "hidden";
            document.getElementById("chcbxIdAggregated").style.display = "none";
            document.getElementById("btnUserChoice").style.visibility = "hidden";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            document.getElementById("bankOption").style.visibility = "hidden";
            document.getElementById("bankOption").style.display = "none";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                btnPromptOkayTransactionDate2
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0]
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0]
            grid.showSpinner()

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices

            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();

                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "";

                if (selectedInvoices.length === 0) {
                    message += "* Please select bills to export. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                grid.hideSpinner()
            } else {
                promptTransactionDate();
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {
                    if (dateTransaction.value === null)
                        return


                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    dialog.hide()

                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0]
                    document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoices.length} bills in Xero to populate bank account in ABA file`

                    var dlgHeader = document.getElementById("promptDialog_dialog-header")
                    dlgHeader.classList.add("prompt-dlg-header-template")

                    var dlgContent = document.getElementById("promptDialog_dialog-content")
                    dlgContent.classList.add("dlg-content-template")

                    document.getElementById("errorContentBank").style.display = "none";

                    document.getElementById("txtBatchReferenceNo").style.display = "none";
                    //document.getElementById("messageBatchReferenceNo").style.display = "none";
                    //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''

                    document.getElementById("txtBacsServiceUserNo").style.display = "none";
                    //document.getElementById("messageBacsServiceUserNo").style.display = "none";
                    //document.getElementById("errorContentBacsServiceUserNo").innerHTML = ''

                    //document.getElementById("txtNarrativeUserChoice").style.display = "none";
                    //document.getElementById("messageNarrativeUserChoice").style.display = "none";
                    //document.getElementById("errorNarrativeUserChoice").innerHTML = ''
                    //document.getElementById("messageAuthorityNumber").style.display = "none";
                    //document.getElementById("messageAuthorityNumber").innerHTML = '';
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtCompanyId").style.display = "none";
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").value = "";
                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("txtLodgementReferenceFrom").style.display = "none";
                    document.getElementById("txtLodgementReferenceFrom").value = "";
                    document.getElementById("messageLodgementFrom").style.display = "none";
                    document.getElementById("errorLodgementFrom").innerHTML = ''
                    document.getElementById("btnInfoFrom").style.visibility = "hidden";
                    document.getElementById("btnInfoTo").style.visibility = "hidden";
                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("btnInfoParticulars").style.visibility = "hidden";
                    var bankDropDown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0]

                    document.getElementById("errorContentBank").innerHTML = ''
                    promptDialog.show()
                    /*        document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting Bank Account...</span>";*/
                    document.getElementById("progressStatuss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus2").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                    document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";


                    document.getElementById("spinner1").style.visibility = "visible";
                    document.getElementById("btnOkay").style.visibility = "visible";
                    const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkay");
                    btnPromptOkayTransactionDateEnable.disabled = true;

                    document.getElementById("messageBank").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").hide();

                    document.getElementById("messageBank").style.display = "none";
                    document.getElementById("messageBankDeUserId").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'none');

                    document.getElementById("messageBankMp").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();


                    document.getElementById("messageBankMp").style.display = "none";
                    document.getElementById("messageBankDeUserIdMp").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');
                    var count = 25;
                    var intervalBank = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(intervalBank);
                            return;
                        }
                        count += 1;
                    }, 100);


                    $.ajax({
                        url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                        type: 'GET',
                        headers: {
                            'Accept': 'application/json; charset=utf-8'
                        },
                        success: (result) => {
                            if (result.isError) {
                                operations.errorHandling(result)
                                return
                            }
                            else {

                                if (result.bankAccounts.length > 0) {
                                    document.getElementById("spinner1").style.visibility = "hidden";
                                    btnPromptOkayTransactionDateEnable.disabled = false;
                                    document.getElementById("btnOkay").style.display = "initial";
                                    document.getElementById("messageBank").style.display = "initial";
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'flex');
                                    document.getElementById("btnOkay").style.visibility = "visible";
                                    document.getElementById("messageBank").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceFrom").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceFrom").style.visibility = "visible";
                                    document.getElementById("btnInfoFrom").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceTo").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceTo").style.visibility = "visible";
                                    document.getElementById("btnInfoTo").style.visibility = "visible";
                                    //if (showLodgementReference) {
                                      
                                    //}
                                    //document.getElementById("btnInfoFrom").onclick = function (e) {
                                    //    promptDialogMoreInfoABA = document.getElementById("promptDialogMoreInfoABA").ej2_instances[0]
                                    //    document.getElementById("promptDialogMoreInfoABA").style.maxHeight = '';

                                    //    var dlgHeader = document.getElementById("promptDialogMoreInfoABA_dialog-header")
                                    //    dlgHeader.classList.add("prompt-dlg-header-template")
                                    //    var dlgContent = document.getElementById("promptDialogMoreInfoABA_dialog-content")
                                    //    dlgContent.classList.add("dlg-content-template")

                                    //    promptDialogMoreInfoABA.show();
                                    //}
                                    //document.getElementById("btnMoreInfoABACancel").onclick = function (e) {
                                    //    promptDialogMoreInfoABA.hide();
                                    //}
                                    //document.getElementById("btnInfoTo").onclick = function (e) {

                                    //}
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").show();
                                    bankDropDown.dataSource = result.bankAccounts
                                }
                                else
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                            }
                        },
                        error: (error) => {
                            document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
                        }
                    })

                    document.getElementById("btnOkay").onclick = function (e) {
                        document.getElementById("spinner1").style.visibility = "visible";

                        if (bankAccount === null || bankAccount.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountName == null || bankAccountName.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account name'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else {
                            document.getElementById("messageBank").style.display = "none";
                            document.getElementById("messageBank").innerHTML = ''
                        }

                        //document.getElementById("messageBank").style.display = "block";
                        //document.getElementById("messageBank").innerHTML = 'No bank account code'
                        //if (bankAccount === null || bankAccountName == null || bankAccount.length === 0 || bankAccountName.length === 0)
                        //    return

                        //var dialogProgress1 = document.getElementById("prompProgressDialog").ej2_instances[0]

                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                        dlgHeader.classList.add("prompt-dlg-header-template")
                        dlgContent.classList.add("dlg-content-template")

                        //dialogProgress1.show()

                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                        //var count = 50;
                        //var exportIntervalStart = setInterval(function () {

                        //    if (count <= 65) {
                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                        //    } else {
                        //        clearInterval(exportIntervalStart);
                        //        return;
                        //    }
                        //    count += 1;
                        //}, 100);

                        let errorCount = 0;
                        //promptDialog.hide()

                        var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                        var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;

                        if (LodgementReferenceNumberFrom.length == 0 || LodgementReferenceNumberFrom == null) {

                            document.getElementById("messageLodgementFrom").style.display = "block";
                            document.getElementById("messageLodgementFrom").innerHTML = 'Lodgement Reference From is required'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        }
                        else {
                            document.getElementById("messageLodgementFrom").style.display = "none";
                            document.getElementById("messageLodgementFrom").innerHTML = ''
                        }
                        isFormatChecking = true;
                        let exportToABA = {
                            bankAccountNumber: bankAccount,
                            bankAccountName: bankAccountName,
                            bankAccountCode: bankAccountCode,
                            bankAccountID: bankAccountID,
                            errorCount: errorCount,
                            invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            hasLodgementReference: showLodgementReference,
                            LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                            LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                            TransactionDate: formatDate(dateTransaction.value)
                        }
                        if (CheckIfConnectedToXero()) {
                            fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT_CHECK, {
                                body: JSON.stringify(exportToABA),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                },
                            }).then(response => response.json())
                                .then(response => {
                                    if (response.result == false) {
                                        var dialog = document.getElementById("promptDialogABA").ej2_instances[0]
                                        document.getElementById("promptDialogABA").style.maxHeight = ""
                                        if (response.error.length > 0)
                                            selectedInvoiceWithNoBankDetails = response.error

                                        var fileFormat = "ABA";
                                        var titleFormat = "";

                                        switch (countryCode) {
                                            case 'NZ':
                                                fileFormat = "a CSV";
                                                titleFormat = "CSV"
                                                break;
                                            case 'AU':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'CA':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'GB':
                                                fileFormat = "a BACS";
                                                titleFormat = "BACS"
                                                $("#progressStatus3 > div").text("Export BatchPay File");
                                                break;
                                        }

                                        var errorlist = "";
                                        document.getElementById("errorlist").innerHTML = "";
                                        let list = document.getElementById("errorlist");
                                        for (let i = 0; i < response.error.length; i++) {
                                            //errorlist += response.error[i].error + "\n";
                                            //errorCount++;
                                            let li = document.createElement('li');
                                            li.innerText = response.error[i].error;
                                            list.appendChild(li);
                                        }
                                        errorCount = response.countIssue
                                        document.getElementById("fileFormat").innerHTML = titleFormat;
                                        document.getElementById("prompt").innerHTML = "You are about to generate a BatchPay file containing " + response.countInvoice + " bills. The file however contains " + response.countIssue + " errors.";
                                        var dlgHeader = document.getElementById("promptDialogABA_dialog-header")
                                        var dlgContent = document.getElementById("promptDialogABA_dialog-content")

                                        dlgHeader.classList.add("error-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")



                                        //dialogProgress1.hide()
                                        document.getElementById("spinnerError").style.visibility = "visible";
                                        document.getElementById("btnShowIssues").style.visibility = "hidden";
                                        document.getElementById("btnABAOkay").style.visibility = "visible";
                                        const btnABAOkayEnabled = document.getElementById("btnABAOkay");
                                        btnABAOkayEnabled.disabled = true;

                                        dialog.show()

                                        var count = 65;
                                        var exportIntervalEnd = setInterval(function () {

                                            if (count <= 75) {
                                                document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                            } else {

                                                document.getElementById("btnShowIssues").style.visibility = "visible";
                                                var countResponseWithNoBankDetails = response.error.filter(i => i.hasBankDetails == false).length;
                                                if (selectedInvoices.length === countResponseWithNoBankDetails) {
                                                    //document.getElementById("btnABAOkay").style.display = "none";
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = true;
                                                } else {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = false;
                                                }

                                                clearInterval(exportIntervalEnd);
                                                return;
                                            }
                                            count += 1;
                                        }, 100);
                                        document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                        document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                                        document.getElementById("progressStatus3").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                        /*    document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                        grid.hideSpinner()
                                        promptDialog.hide()



                                        document.getElementById("btnABAOkay").onclick = function (e) {
                                            document.getElementById("spinnerError").style.visibility = "visible";
                                            document.getElementById("btnABAOkay").setAttribute("disabled", true);
                                            document.getElementById("btnShowIssues").setAttribute("disabled", true);
                                            var count = 75;
                                            var exportToAbbaInterval = setInterval(function () {

                                                if (count <= 100) {
                                                    document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                                } else {
                                                    document.getElementById("btnABAOkay").removeAttribute("disabled");
                                                    document.getElementById("btnShowIssues").removeAttribute("disabled");
                                                    clearInterval(exportToAbbaInterval);
                                                    return;
                                                }
                                                count += 1;
                                            }, 200);
                                            document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                            document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay From</div>";
                                            document.getElementById("progressStatus3").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                            /*       document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                            var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;

                                            selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID && i.hasBankDetails == false))   

                                            let exportToABA2 = {
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value)
                                            }

                                            fetch(API_ENDPOINTS.EXPORT_KUNDUPEI, {
                                                body: JSON.stringify(exportToABA2),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    console.log(response.error);
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    let currentDate = new Date();
                                                    let day = String(currentDate.getDate()).padStart(2, '0');
                                                    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
                                                    let year = currentDate.getFullYear();
                                                    let filename = `aba${day}${month}${year}.aba`;
                                                    a.download = filename;
                                                    a.href = downloadUrl
                                                    a.download = `aba${day}${month}${year}.aba`
                                                    document.body.appendChild(a)
                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()

                                                   // document.getElementById("step1").ej2_instances[0].disabled = true

                                                })

                                        }
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialogAfterExport.hide()
                                            dialog.hide()
                                        }

                                        document.getElementById("btnABACancel").onclick = function (e) {
                                            dialog.hide()
                                            grid.hideSpinner()
                                        }

                                        document.getElementById("btnShowIssues").onclick = function (e) {

                                            //var blob = new Blob([errorlist], { type: "text/plain;charset=utf-8" });
                                            //const downloadUrl = URL.createObjectURL(blob)
                                            //const a = document.createElement("a")
                                            //a.href = downloadUrl
                                            //a.download = "errors_batch_payments_export.aba"
                                            //document.body.appendChild(a)
                                            //a.click()
                                            //grid.hideSpinner()
                                            dialogViewErrorList = document.getElementById("dialogViewErrorList").ej2_instances[0]
                                            //document.getElementById("errorlist").innerHTML = errorlist
                                            var x = errorlist;
                                            //let list = document.getElementById("errorlist");

                                            //for (i = 0; i < errorlist.length; ++i) {
                                            //    let li = document.createElement('li');
                                            //    li.innerText = errorlist[i];
                                            //    list.appendChild(li);
                                            //}

                                            var dlgHeader = document.getElementById("dialogViewErrorList_dialog-header")
                                            var dlgContent = document.getElementById("dialogViewErrorList_dialog-content")

                                            dlgHeader.classList.add("error-dlg-header-template")
                                            dlgContent.classList.add("dlg-content-template")

                                            dialogViewErrorList.show()


                                        }
                                        document.getElementById("btnViewErrorList").onclick = function (e) {
                                            dialogViewErrorList.hide()
                                            //dialog.hide()
                                        }
                                    } else if (response.result == true) {
                                        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]

                                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")
                                        grid.hideSpinner()
                                        promptDialog.hide()
                                        //dialogProgress.show()

                                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                                        //var count = 65;
                                        //var exportToAbbaInterval = setInterval(function () {

                                        //    if (count <= 100) {
                                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                                        //    } else {
                                        //        clearInterval(exportToAbbaInterval);
                                        //        return;
                                        //    }
                                        //    count += 1;
                                        //}, 100);

                                        fetch(API_ENDPOINTS.EXPORT_KUNDUPEI, {
                                            body: JSON.stringify(exportToABA),
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json; charset=utf-8'
                                            },
                                        }).then(response => response.blob())
                                            .then(response => {
                                                document.getElementById("spinner1").style.visibility = "hidden";
                                                const blob = new Blob([response], { type: 'text/plain' })
                                                const downloadUrl = URL.createObjectURL(blob)
                                                const a = document.createElement("a")
                                                let currentDate = new Date();
                                                let day = String(currentDate.getDate()).padStart(2, '0');
                                                let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
                                                let year = currentDate.getFullYear();
                                                let filename = `aba${day}${month}${year}.aba`;
                                                a.download = filename;
                                                a.href = downloadUrl
                                                a.download = `aba${day}${month}${year}.aba`
                                                document.body.appendChild(a)
                                                a.click()
                                                grid.hideSpinner()
                                                dialogProgress.hide()
                                                window.disabledGridEditing = false

                                                var messageAfterExport = "";
                                                messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                dlgHeader.classList.add("prompt-dlg-header-template")
                                                dlgContent.classList.add("dlg-content-template")
                                                promptDialog.hide()
                                                dialogAfterExport.show()
                                                grid.hideSpinner()
                                                //document.getElementById("step1").ej2_instances[0].disabled = true
                                            })

                                    }
                                })
                            document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                dialogAfterExport.hide()
                                dialog.hide()
                            }
                        }
                        else {
                            tenantNotConnected()
                            dialogProgress.hide()
                        }
                    }
                    document.getElementById("btnCancel").onclick = function (e) {
                        promptDialog.hide()
                        grid.hideSpinner()
                    }
                }
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    grid.hideSpinner()
                    dialog.hide()
                }
            }
        }


        if (args.item.id === 'ExportGiro') {

            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            var promptDialogMoreInfoABA;
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomRightRadius = "10px";
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";
            $("#promptInfoDialogTransactionDate_title .e-icon-settings").text("Export BatchPay File");
            /*            document.getElementById("progressStatus").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnBacs").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.display = "none";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("apcaId").innerHTML = '';
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("chcbxIdAggregated").style.visibility = "hidden";
            document.getElementById("chcbxIdAggregated").style.display = "none";
            document.getElementById("btnUserChoice").style.visibility = "hidden";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            document.getElementById("bankOption").style.visibility = "visible";
            document.getElementById("txtCompanyId").style.visibility = "hidden";
            document.getElementById("txtCompanyId").style.display = "none";
            document.getElementById("btnCompanyId").style.visibility = "hidden";
            document.getElementById("btnCompanyId").style.display = "none";
            document.getElementById("txtCompanyIdContainer").style.visibility = "hidden";
            document.getElementById("txtCompanyIdContainer").style.display = "none";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                btnPromptOkayTransactionDate2
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0]
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0]
            grid.showSpinner()

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices

            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();

                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "";

                if (selectedInvoices.length === 0) {
                    message += "* Please select bills to export. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                grid.hideSpinner()
            } else {
                promptTransactionDate();
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {
                    if (dateTransaction.value === null)
                        return


                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    dialog.hide()

                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0]
                    document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoices.length} bills in Xero to populate bank account in Giro fast file`

                    var dlgHeader = document.getElementById("promptDialog_dialog-header")
                    dlgHeader.classList.add("prompt-dlg-header-template")

                    var dlgContent = document.getElementById("promptDialog_dialog-content")
                    dlgContent.classList.add("dlg-content-template")

                    document.getElementById("errorContentBank").style.display = "none";

                    document.getElementById("txtBatchReferenceNo").style.display = "none";
                    //document.getElementById("messageBatchReferenceNo").style.display = "none";
                    //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''

                    document.getElementById("txtBacsServiceUserNo").style.display = "none";
                    //document.getElementById("messageBacsServiceUserNo").style.display = "none";
                    //document.getElementById("errorContentBacsServiceUserNo").innerHTML = ''

                    //document.getElementById("txtNarrativeUserChoice").style.display = "none";
                    //document.getElementById("messageNarrativeUserChoice").style.display = "none";
                    //document.getElementById("errorNarrativeUserChoice").innerHTML = ''
                    //document.getElementById("messageAuthorityNumber").style.display = "none";
                    //document.getElementById("messageAuthorityNumber").innerHTML = '';
                    document.getElementById("txtLodgementReferenceTo").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").value = "";
                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("txtLodgementReferenceFrom").style.display = "none";
                    document.getElementById("txtLodgementReferenceFrom").value = "";
                    document.getElementById("messageLodgementFrom").style.display = "none";
                    document.getElementById("errorLodgementFrom").innerHTML = ''
                    document.getElementById("btnInfoFrom").style.visibility = "hidden";
                    document.getElementById("btnInfoTo").style.visibility = "hidden";
                    document.getElementById("btnInfoParticulars").style.visibility = "hidden";
                    var bankDropDown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0]

                    document.getElementById("errorContentBank").innerHTML = ''
                    promptDialog.show()
                    /*        document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting Bank Account...</span>";*/
                    document.getElementById("progressStatuss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus2").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                    document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";


                    document.getElementById("spinner1").style.visibility = "visible";
                    document.getElementById("btnOkay").style.visibility = "visible";
                    const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkay");
                    btnPromptOkayTransactionDateEnable.disabled = true;

                    document.getElementById("messageBank").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").hide();

                    document.getElementById("messageBank").style.display = "none";
                    document.getElementById("messageBankDeUserId").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'none');

                    document.getElementById("messageBankMp").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();

                    document.getElementById("radioError").style.display = "none";
                    document.getElementById("radioError").style.visibility = "hidden";


                    document.getElementById("messageBankMp").style.display = "none";
                    document.getElementById("messageBankDeUserIdMp").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');
                    var count = 25;
                    var intervalBank = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(intervalBank);
                            return;
                        }
                        count += 1;
                    }, 100);


                    $.ajax({
                        url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                        type: 'GET',
                        headers: {
                            'Accept': 'application/json; charset=utf-8'
                        },
                        success: (result) => {
                            if (result.isError) {
                                operations.errorHandling(result)
                                return
                            }
                            else {

                                if (result.bankAccounts.length > 0) {
                                    document.getElementById("spinner1").style.visibility = "hidden";
                                    btnPromptOkayTransactionDateEnable.disabled = false;
                                    document.getElementById("btnOkay").style.display = "initial";
                                    document.getElementById("messageBank").style.display = "initial";
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'flex');
                                    document.getElementById("btnOkay").style.visibility = "visible";
                                    document.getElementById("messageBank").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceFrom").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceFrom").style.visibility = "visible";
                                    document.getElementById("btnInfoFrom").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceTo").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceTo").style.visibility = "visible";
                                    document.getElementById("txtBatchReferenceNo").style.display = "initial";
                                    document.getElementById("txtBatchReferenceNo").style.visibility = "visible";
                                    document.getElementById("btnInfoTo").style.visibility = "visible";
                                    document.getElementById("btnUserChoice").style.visibility = "visible";
                                    //if (showLodgementReference) {

                                    //}
                                    //document.getElementById("btnInfoFrom").onclick = function (e) {
                                    //    promptDialogMoreInfoABA = document.getElementById("promptDialogMoreInfoABA").ej2_instances[0]
                                    //    document.getElementById("promptDialogMoreInfoABA").style.maxHeight = '';

                                    //    var dlgHeader = document.getElementById("promptDialogMoreInfoABA_dialog-header")
                                    //    dlgHeader.classList.add("prompt-dlg-header-template")
                                    //    var dlgContent = document.getElementById("promptDialogMoreInfoABA_dialog-content")
                                    //    dlgContent.classList.add("dlg-content-template")

                                    //    promptDialogMoreInfoABA.show();
                                    //}
                                    //document.getElementById("btnMoreInfoABACancel").onclick = function (e) {
                                    //    promptDialogMoreInfoABA.hide();
                                    //}
                                    //document.getElementById("btnInfoTo").onclick = function (e) {

                                    //}
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").show();
                                    bankDropDown.dataSource = result.bankAccounts
                                }
                                else
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                            }
                        },
                        error: (error) => {
                            document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
                        }
                    })

                    document.getElementById("btnOkay").onclick = function (e) {
                        document.getElementById("spinner1").style.visibility = "visible";

                        if (bankAccount === null || bankAccount.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account'
                            document.getElementById("spinner1").style.visibility = "hidden";

                            return
                        } else if (bankAccountName == null || bankAccountName.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account name'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else {
                            document.getElementById("messageBank").style.display = "none";
                            document.getElementById("messageBank").innerHTML = ''
                        }

                        //document.getElementById("messageBank").style.display = "block";
                        //document.getElementById("messageBank").innerHTML = 'No bank account code'
                        //if (bankAccount === null || bankAccountName == null || bankAccount.length === 0 || bankAccountName.length === 0)
                        //    return

                        //var dialogProgress1 = document.getElementById("prompProgressDialog").ej2_instances[0]

                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                        dlgHeader.classList.add("prompt-dlg-header-template")
                        dlgContent.classList.add("dlg-content-template")

                        //dialogProgress1.show()

                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                        //var count = 50;
                        //var exportIntervalStart = setInterval(function () {

                        //    if (count <= 65) {
                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                        //    } else {
                        //        clearInterval(exportIntervalStart);
                        //        return;
                        //    }
                        //    count += 1;
                        //}, 100);

                        let errorCount = 0;
                        //promptDialog.hide()

                        var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                        var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                        var companyId = document.getElementById("txtCompanyId").value;
                        var txtBatchReferenceNo = document.getElementById("txtBatchReferenceNo").value;

                        if (bankOptionSelected == "DBS Bank") {
                            if (companyId.length == 0 || companyId == null) {
                                document.getElementById("companyIdRequired").style.display = "block";
                                document.getElementById("spinner1").style.visibility = "hidden";
                                return
                            }
                        }
                        if (LodgementReferenceNumberFrom.length == 0 || LodgementReferenceNumberFrom == null) {

                            document.getElementById("messageLodgementFrom").style.display = "block";
                            document.getElementById("messageLodgementFrom").innerHTML = 'Lodgement Reference From is required'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        }  
                        else {
                            document.getElementById("messageLodgementFrom").style.display = "none";
                            document.getElementById("messageLodgementFrom").innerHTML = ''
                        }
                        //if (bankOptionSelected.length === 0 || bankOptionSelected == null)

                        // Check if a radio button is selected
                        var selectedRadio = document.querySelector('input[name="bankSelection"]:checked');
                        var errorMessage = document.getElementById('radioError');

                        if (!selectedRadio) {
                            // Show the error message
                            errorMessage.style.display = 'block'; // Set the error message to visible
                            errorMessage.style.visibility = 'visible'; // Set the error message to visible
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return

                        } else {
                            // Hide the error message and proceed
                            errorMessage.style.display = 'none';
                        }

                        isFormatChecking = true;
                        let exportToABA = {
                            bankAccountNumber: bankAccount,
                            bankAccountName: bankAccountName,
                            bankAccountCode: bankAccountCode,
                            bankAccountID: bankAccountID,
                            errorCount: errorCount,
                            invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            hasLodgementReference: showLodgementReference,
                            LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                            LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                            TransactionDate: formatDate(dateTransaction.value),
                            BankOptionSelected: bankOptionSelected,
                            CompanyId: companyId,
                            BatchReferenceNo: txtBatchReferenceNo
                        }
                        if (CheckIfConnectedToXero()) {
                            fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT_CHECK, {
                                body: JSON.stringify(exportToABA),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                },
                            }).then(response => response.json())
                                .then(response => {
                                    if (response.result == false) {
                                        var dialog = document.getElementById("promptDialogABA").ej2_instances[0]
                                        document.getElementById("promptDialogABA").style.maxHeight = ""
                                        if (response.error.length > 0)
                                            selectedInvoiceWithNoBankDetails = response.error

                                        var fileFormat = "ABA";
                                        var titleFormat = "";

                                        switch (countryCode) {
                                            case 'NZ':
                                                fileFormat = "a CSV";
                                                titleFormat = "CSV"
                                                break;
                                            case 'AU':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'CA':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'GB':
                                                fileFormat = "a BACS";
                                                titleFormat = "BACS"
                                                $("#progressStatus3 > div").text("Export BatchPay File");
                                                break;
                                        }
                                        
                                        var errorlist = "";
                                        document.getElementById("errorlist").innerHTML = "";
                                        let list = document.getElementById("errorlist");
                                        for (let i = 0; i < response.error.length; i++) {
                                            //errorlist += response.error[i].error + "\n";
                                            //errorCount++;
                                            let li = document.createElement('li');
                                            li.innerText = response.error[i].error;
                                            list.appendChild(li);
                                        }

                                        errorCount = response.countIssue
                                        document.getElementById("fileFormat").innerHTML = titleFormat;
                                        document.getElementById("prompt").innerHTML = "You are about to generate a BatchPay file containing " + response.countInvoice + " bills. The file however contains " + response.countIssue + " errors.";
                                        var dlgHeader = document.getElementById("promptDialogABA_dialog-header")
                                        var dlgContent = document.getElementById("promptDialogABA_dialog-content")

                                        dlgHeader.classList.add("error-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")



                                        //dialogProgress1.hide()
                                        document.getElementById("spinnerError").style.visibility = "visible";
                                        document.getElementById("btnShowIssues").style.visibility = "hidden";
                                        document.getElementById("btnABAOkay").style.visibility = "visible";
                                        const btnABAOkayEnabled = document.getElementById("btnABAOkay");
                                        btnABAOkayEnabled.disabled = true;

                                        dialog.show()

                                        var count = 65;
                                        var exportIntervalEnd = setInterval(function () {

                                            if (count <= 75) {
                                                document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                            } else {

                                                document.getElementById("btnShowIssues").style.visibility = "visible";
                                                var countResponseWithNoBankDetails = response.error.filter(i => i.hasBankDetails == false).length;
                                                if (selectedInvoices.length === countResponseWithNoBankDetails) {
                                                    //document.getElementById("btnABAOkay").style.display = "none";
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = true;
                                                } else {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = false;
                                                }

                                                clearInterval(exportIntervalEnd);
                                                return;
                                            }
                                            count += 1;
                                        }, 100);
                                        document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                        document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                                        document.getElementById("progressStatus3").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                        /*    document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                        grid.hideSpinner()
                                        promptDialog.hide()



                                        document.getElementById("btnABAOkay").onclick = function (e) {
                                            document.getElementById("spinnerError").style.visibility = "visible";
                                            document.getElementById("btnABAOkay").setAttribute("disabled", true);
                                            document.getElementById("btnShowIssues").setAttribute("disabled", true);
                                            var count = 75;
                                            var exportToAbbaInterval = setInterval(function () {

                                                if (count <= 100) {
                                                    document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                                } else {
                                                    document.getElementById("btnABAOkay").removeAttribute("disabled");
                                                    document.getElementById("btnShowIssues").removeAttribute("disabled");
                                                    clearInterval(exportToAbbaInterval);
                                                    return;
                                                }
                                                count += 1;
                                            }, 200);
                                            document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                            document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay From</div>";
                                            document.getElementById("progressStatus3").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                            /*       document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                            var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;

                                            selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID && i.hasBankDetails == false))   

                                            let exportToABA2 = {
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                BankOptionSelected: bankOptionSelected
                                            }

                                            fetch(API_ENDPOINTS.EXPORT_GIRO, {
                                                body: JSON.stringify(exportToABA2),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = "batch_payments_export.txt"
                                                    document.body.appendChild(a)

                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()

                                                    // document.getElementById("step1").ej2_instances[0].disabled = true

                                                })

                                        }
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialogAfterExport.hide()
                                            dialog.hide()
                                        }

                                        document.getElementById("btnABACancel").onclick = function (e) {
                                            dialog.hide()
                                            grid.hideSpinner()
                                        }

                                        document.getElementById("btnShowIssues").onclick = function (e) {

                                            //var blob = new Blob([errorlist], { type: "text/plain;charset=utf-8" });
                                            //const downloadUrl = URL.createObjectURL(blob)
                                            //const a = document.createElement("a")
                                            //a.href = downloadUrl
                                            //a.download = "errors_batch_payments_export.aba"
                                            //document.body.appendChild(a)
                                            //a.click()
                                            //grid.hideSpinner()
                                            dialogViewErrorList = document.getElementById("dialogViewErrorList").ej2_instances[0]
                                            //document.getElementById("errorlist").innerHTML = errorlist
                                            var x = errorlist;
                                            //let list = document.getElementById("errorlist");

                                            //for (i = 0; i < errorlist.length; ++i) {
                                            //    let li = document.createElement('li');
                                            //    li.innerText = errorlist[i];
                                            //    list.appendChild(li);
                                            //}

                                            var dlgHeader = document.getElementById("dialogViewErrorList_dialog-header")
                                            var dlgContent = document.getElementById("dialogViewErrorList_dialog-content")

                                            dlgHeader.classList.add("error-dlg-header-template")
                                            dlgContent.classList.add("dlg-content-template")

                                            dialogViewErrorList.show()


                                        }
                                        document.getElementById("btnViewErrorList").onclick = function (e) {
                                            dialogViewErrorList.hide()
                                            //dialog.hide()
                                        }
                                    } else if (response.result == true) {
                                        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]

                                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")
                                        grid.hideSpinner()
                                        promptDialog.hide()
                                        //dialogProgress.show()

                                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                                        //var count = 65;
                                        //var exportToAbbaInterval = setInterval(function () {

                                        //    if (count <= 100) {
                                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                                        //    } else {
                                        //        clearInterval(exportToAbbaInterval);
                                        //        return;
                                        //    }
                                        //    count += 1;
                                        //}, 100);

                                        fetch(API_ENDPOINTS.EXPORT_GIRO, {
                                            body: JSON.stringify(exportToABA),
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json; charset=utf-8'
                                            },
                                        }).then(response => response.blob())
                                            .then(response => {
                                                document.getElementById("spinner1").style.visibility = "hidden";
                                                const blob = new Blob([response], { type: 'text/plain' })
                                                const downloadUrl = URL.createObjectURL(blob)
                                                const a = document.createElement("a")
                                                a.href = downloadUrl
                                                a.download = "batch_payments_export.txt"
                                                document.body.appendChild(a)
                                                a.click()
                                                grid.hideSpinner()
                                                dialogProgress.hide()
                                                window.disabledGridEditing = false

                                                var messageAfterExport = "";
                                                messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                dlgHeader.classList.add("prompt-dlg-header-template")
                                                dlgContent.classList.add("dlg-content-template")
                                                promptDialog.hide()
                                                dialogAfterExport.show()
                                                grid.hideSpinner()
                                                //document.getElementById("step1").ej2_instances[0].disabled = true
                                            })

                                    }
                                })
                            document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                dialogAfterExport.hide()
                                dialog.hide()
                            }
                        }
                        else {
                            tenantNotConnected()
                            dialogProgress.hide()
                        }
                    }
                    document.getElementById("btnCancel").onclick = function (e) {
                        promptDialog.hide()
                        grid.hideSpinner()
                    }
                }
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    grid.hideSpinner()
                    dialog.hide()
                }
            }
        }

        if (args.item.id === 'ExportCSV') {
            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            var promptDialogMoreInfoABA;
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogMoreInfoABA").style.borderBottomRightRadius = "10px";
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";
            /*            document.getElementById("progressStatus").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnBacs").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.visibility = "visible";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("apcaId").innerHTML = '';
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("chcbxIdAggregated").style.visibility = "visible";
            document.getElementById("chcbxIdAggregated").style.display = "Initial";
            document.getElementById("btnUserChoice").style.visibility = "hidden";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            document.getElementById("bankOption").style.visibility = "hidden";
            document.getElementById("bankOption").style.display = "none";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                btnPromptOkayTransactionDate2
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0]
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0]
            grid.showSpinner()

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices

            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();

                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "";

                if (selectedInvoices.length === 0) {
                    message += "* Please select bills to export. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                grid.hideSpinner()
            } else {
                promptTransactionDate();
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {
                    if (dateTransaction.value === null)
                        return
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    dialog.hide()

                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0]
                    document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoices.length} bills in Xero to populate bank account in ABA file`

                    var dlgHeader = document.getElementById("promptDialog_dialog-header")
                    dlgHeader.classList.add("prompt-dlg-header-template")

                    var dlgContent = document.getElementById("promptDialog_dialog-content")
                    dlgContent.classList.add("dlg-content-template")

                    document.getElementById("errorContentBank").style.display = "none";

                    document.getElementById("txtBatchReferenceNo").style.display = "none";
                    //document.getElementById("messageBatchReferenceNo").style.display = "none";
                    //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''

                    document.getElementById("txtBacsServiceUserNo").style.display = "none";
                    //document.getElementById("messageBacsServiceUserNo").style.display = "none";
                    //document.getElementById("errorContentBacsServiceUserNo").innerHTML = ''

                    //document.getElementById("txtNarrativeUserChoice").style.display = "none";
                    //document.getElementById("messageNarrativeUserChoice").style.display = "none";
                    //document.getElementById("errorNarrativeUserChoice").innerHTML = ''

                    //document.getElementById("sumInvoicesPerContact").style.display = "none";
                    document.getElementById("txtCompanyId").style.display = "none";
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").value = "";

                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("sumInvoicesPerContact").style.display = "initial";
                    //document.getElementById("txtAuthorityNumber").style.display = "none";
                    //document.getElementById("txtAuthorityNumber").value = "";
                    //document.getElementById('txtAuthorityNumber').maxLength = 7;

                    document.getElementById("txtLodgementReferenceFrom").style.display = "none";
                    document.getElementById("txtLodgementReferenceFrom").value = "";

                    document.getElementById('txtParticulars').maxLength = 12;
                    document.getElementById('txtLodgementReferenceFrom').maxLength = 12;
                    document.getElementById('txtLodgementReferenceTo').maxLength = 12;

                    //document.getElementById("messageAuthorityNumber").style.display = "none";
                    //document.getElementById("messageAuthorityNumber").innerHTML = '';
                    document.getElementById("messageLodgementFrom").style.display = "none";
                    document.getElementById("errorLodgementFrom").innerHTML = ''
                    document.getElementById("btnInfoFrom").style.visibility = "hidden";
                    document.getElementById("btnInfoTo").style.visibility = "hidden";
                    document.getElementById("btnInfoParticulars").style.visibility = "hidden";
                    var bankDropDown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0]

                    document.getElementById("errorContentBank").innerHTML = ''
                    promptDialog.show()
                    document.getElementById("progressStatuss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus2").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                    document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                    document.getElementById("spinner1").style.visibility = "visible";
                    document.getElementById("btnOkay").style.visibility = "visible";
                    const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkay");
                    btnPromptOkayTransactionDateEnable.disabled = true;

                    document.getElementById("messageBank").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").hide();

                    document.getElementById("messageBank").style.display = "none";
                    document.getElementById("messageBankDeUserId").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'none');

                    document.getElementById("messageBankMp").style.visibility = "hidden";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();
                    document.getElementById("messageBankMp").style.display = "none";
                    document.getElementById("messageBankDeUserIdMp").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');
                    var count = 25;
                    var intervalBank = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(intervalBank);
                            return;
                        }
                        count += 1;
                    }, 100);


                    $.ajax({
                        url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                        type: 'GET',
                        headers: {
                            'Accept': 'application/json; charset=utf-8'
                        },
                        success: (result) => {
                            if (result.isError) {
                                operations.errorHandling(result)
                                return
                            }
                            else {

                                if (result.bankAccounts.length > 0) {
                                    document.getElementById("spinner1").style.visibility = "hidden";
                                    btnPromptOkayTransactionDateEnable.disabled = false;
                                    document.getElementById("btnOkay").style.display = "initial";
                                    document.getElementById("messageBank").style.display = "initial";
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'flex');
                                    document.getElementById("btnOkay").style.visibility = "visible";
                                    document.getElementById("messageBank").style.visibility = "visible";
                                    //document.getElementById("txtAuthorityNumber").style.display = "initial";
                                    //document.getElementById("txtAuthorityNumber").style.visibility = "visible";
                                    //document.getElementById('txtAuthorityNumber').placeholder = 'Authority Number';
                                    document.getElementById("txtLodgementReferenceFrom").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceFrom").style.visibility = "visible";
                                    document.getElementById('txtLodgementReferenceFrom').placeholder = 'Reference';
                                    document.getElementById("btnInfoFrom").style.visibility = "visible";
                                    document.getElementById("txtLodgementReferenceTo").style.display = "initial";
                                    document.getElementById("txtLodgementReferenceTo").style.visibility = "visible";
                                    document.getElementById('txtLodgementReferenceTo').placeholder = 'Code';

                                    document.getElementById("txtParticulars").style.display = "initial";
                                    document.getElementById("txtParticulars").style.visibility = "visible";
                                    document.getElementById("btnInfoParticulars").style.visibility = "visible";
                                    document.getElementById("btnInfoTo").style.visibility = "visible";


                                    $("span[aria-owns='bankAccountTypesDropDown_options']").show();
                                    bankDropDown.dataSource = result.bankAccounts
                                }
                                else
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                            }
                        },
                        error: (error) => {
                            document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
                        }
                    })

                    document.getElementById("btnOkay").onclick = function (e) {
                        document.getElementById("spinner1").style.visibility = "visible";
                        if (bankAccount === null || bankAccount.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountName == null || bankAccountName.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account name'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else {
                            document.getElementById("messageBank").style.display = "none";
                            document.getElementById("messageBank").innerHTML = ''
                        }

                        //document.getElementById("messageBank").style.display = "block";
                        //document.getElementById("messageBank").innerHTML = 'No bank account code'
                        //if (bankAccount === null || bankAccountName == null || bankAccount.length === 0 || bankAccountName.length === 0)
                        //    return

                        //var dialogProgress1 = document.getElementById("prompProgressDialog").ej2_instances[0]

                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                        dlgHeader.classList.add("prompt-dlg-header-template")
                        dlgContent.classList.add("dlg-content-template")

                        let errorCount = 0;
                        //promptDialog.hide()
                        var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                        //var AuthorityNumber = document.getElementById("txtAuthorityNumber").value;
                        var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                        var Particulars = document.getElementById("txtParticulars").value;
                        var checkboxInstance = document.getElementById("sumInvoicesPerContact").ej2_instances[0];
                        chksumInvoicesPerContact = checkboxInstance.checked;
                      //if (
                      //      AuthorityNumber.length !== 7 || // must be exactly 7 digits
                      //      AuthorityNumber === "" ||
                      //      isNaN(AuthorityNumber)
                      //  ) {
                      //      document.getElementById("messageAuthorityNumber").style.display = "block";
                      //      document.getElementById("messageAuthorityNumber").innerHTML = 'Authority Number is required and must be 7 digits';
                      //      document.getElementById("spinner1").style.visibility = "hidden";
                      //      return;
                      //  } else {
                      //      document.getElementById("messageAuthorityNumber").style.display = "none";
                      //      document.getElementById("messageAuthorityNumber").innerHTML = '';
                      //  }

                        if (LodgementReferenceNumberFrom.length == 0 || LodgementReferenceNumberFrom == null) {

                            document.getElementById("messageLodgementFrom").style.display = "block";
                            document.getElementById("messageLodgementFrom").innerHTML = 'Reference is required'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        }
                        else {
                            document.getElementById("messageLodgementFrom").style.display = "none";
                            document.getElementById("messageLodgementFrom").innerHTML = ''
                        }

                        var westpacNZBankCode = ["03", "13", "14", "16", "17", "18", "19", "20", "21", "22", "23", "27"];
                        var anzBankCode = ["01", "04", "06", "11", "25"];
                        var bnzBankCode = ["02"];
                        var bankCode = bankAccount.substring(0, 2);
                        isDbb = (countryCode == "NZ" && westpacNZBankCode.includes(bankCode));
                        var isCSV = (countryCode === "NZ" && anzBankCode.includes(bankCode));
                        var isBNZ = (countryCode == "NZ" && bnzBankCode.includes(bankCode));

                        let exportToABA = {
                            bankAccountNumber: bankAccount,
                            bankAccountName: bankAccountName,
                            bankAccountCode: bankAccountCode,
                            bankAccountID: bankAccountID,
                            errorCount: errorCount,
                            invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            hasLodgementReference: showLodgementReference,
                            LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                            LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                            TransactionDate: formatDate(dateTransaction.value),
                            Particulars: Particulars,
                            IsDbbFormat: isDbb,
                            sumInvoicesPerContact: chksumInvoicesPerContact
                        }

                        if (CheckIfConnectedToXero()) {
                            fetch(API_ENDPOINTS.EXPORT_NZ_FORMAT_CHECK, {
                                body: JSON.stringify(exportToABA),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                },
                            }).then(response => response.json())
                                .then(response => {
                                    if (response.result == false) {
                                        var dialog = document.getElementById("promptDialogABA").ej2_instances[0]
                                        document.getElementById("promptDialogABA").style.maxHeight = ""
                                        if (response.error.length > 0)
                                            selectedInvoiceWithNoBankDetails = response.error
                                            //const errorInvoiceIds = response.error.map(errorItem => errorItem.invoiceId);
                                            //const filteredInvoices = selectedInvoices.filter(invoice => !errorInvoiceIds.includes(invoice.invoiceID));
                                            //selectedInvoices = filteredInvoices;

                                        var fileFormat = "ABA";
                                        var titleFormat = "";

                                        switch (countryCode) {
                                            case 'NZ':
                                                fileFormat = "a CSV";
                                                titleFormat = "CSV"
                                                break;
                                            case 'AU':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'CA':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'GB':
                                                fileFormat = "a BACS";
                                                titleFormat = "BACS"
                                                $("#progressStatus3 > div").text("Export BatchPay File");
                                                break;
                                        }

                                        var errorlist = "";
                                        let list = document.getElementById("errorlist");
                                        for (let i = 0; i < response.error.length; i++) {
                                            //errorlist += response.error[i].error + "\n";
                                            //errorCount++;
                                            let li = document.createElement('li');
                                            li.innerText = response.error[i].error;
                                            list.appendChild(li);
                                        }

                                        errorCount = response.countIssue

                                        document.getElementById("fileFormat").innerHTML = titleFormat;
                                        document.getElementById("prompt").innerHTML = "You are about to generate a BatchPay file containing " + response.countInvoice + " bills. The file however contains " + response.countIssue + " errors.";
                                        var dlgHeader = document.getElementById("promptDialogABA_dialog-header")
                                        var dlgContent = document.getElementById("promptDialogABA_dialog-content")

                                        dlgHeader.classList.add("error-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")



                                        //dialogProgress1.hide()
                                        document.getElementById("spinnerError").style.visibility = "visible";
                                        document.getElementById("btnShowIssues").style.visibility = "hidden";
                                        document.getElementById("btnABAOkay").style.visibility = "visible";
                                        const btnABAOkayEnabled = document.getElementById("btnABAOkay");
                                        btnABAOkayEnabled.disabled = true;

                                        dialog.show()

                                        var count = 65;
                                        var exportIntervalEnd = setInterval(function () {

                                            if (count <= 75) {
                                                document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                            } else {

                                                document.getElementById("btnShowIssues").style.visibility = "visible";
                                                var countResponseWithNoBankDetails = response.error.filter(i => i.hasBankDetails == false).length;
                                                if (selectedInvoices.length === countResponseWithNoBankDetails) {
                                                    //document.getElementById("btnABAOkay").style.display = "none";
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = true;
                                                } else {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = false;
                                                }

                                                clearInterval(exportIntervalEnd);
                                                return;
                                            }
                                            count += 1;
                                        }, 100);
                                        document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                        document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                                        document.getElementById("progressStatus3").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                        /*    document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/

                                        grid.hideSpinner()
                                        promptDialog.hide()



                                        document.getElementById("btnABAOkay").onclick = function (e) {
                                            document.getElementById("spinnerError").style.visibility = "visible";
                                            //document.getElementById("spinnerErrorExportFile").style.visibility = "visible";
                                            document.getElementById("btnABAOkay").setAttribute("disabled", true);
                                            document.getElementById("btnShowIssues").setAttribute("disabled", true);
                                            var count = 75;
                                            var exportToAbbaInterval = setInterval(function () {

                                                if (count <= 100) {
                                                    document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                                } else {
                                                    document.getElementById("btnABAOkay").removeAttribute("disabled");
                                                    document.getElementById("btnShowIssues").removeAttribute("disabled");
                                                    clearInterval(exportToAbbaInterval);
                                                    return;
                                                }
                                                count += 1;
                                            }, 200);
                                            document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                            document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay From</div>";
                                            document.getElementById("progressStatus3").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                            /*       document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to ABA...</span>";*/
                                            //var AuthorityNumber = document.getElementById("txtAuthorityNumber").value;
                                            var LodgementReferenceNumberTo = document.getElementById("txtLodgementReferenceTo").value;
                                            var LodgementReferenceNumberFrom = document.getElementById("txtLodgementReferenceFrom").value;
                                            var Particulars = document.getElementById("txtParticulars").value;

                                            selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID && i.hasBankDetails == false))   

                                         

                                            if (isCSV) {
                                            let exportToANZ = {
                                                companyName:orgName,
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                Particulars: Particulars,
                                                IsDbbFormat: isDbb,
                                                BankOptionSelected: bankOptionSelected
                                            }
                                            fetch(API_ENDPOINTS.EXPORT_NZ_CSV, {
                                                    body: JSON.stringify(exportToANZ),
                                                    method: 'POST',
                                                    headers: {
                                                        'Content-Type': 'application/json; charset=utf-8'
                                                    },
                                                }).then(response => response.blob())
                                                    .then(response => {
                                                        //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                        document.getElementById("spinner1").style.visibility = "hidden";
                                                        const blob = new Blob([response], { type: 'text/plain' })
                                                        const downloadUrl = URL.createObjectURL(blob)
                                                        const a = document.createElement("a")
                                                        a.href = downloadUrl
                                                        a.download = "batch_payments_export.csv";
                                                        isDbb = false;
                                                        document.body.appendChild(a)

                                                        //dialog.hide()
                                                        grid.hideSpinner()
                                                        a.click()
                                                        window.disabledGridEditing = false
                                                        var messageAfterExport = "";
                                                        messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                        dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                        document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                        var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                        var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                                        dlgContent.classList.add("dlg-content-template")
                                                        promptDialog.hide()
                                                        dialogAfterExport.show()
                                                        grid.hideSpinner()
                                                        //document.getElementById("step1").ej2_instances[0].disabled = true
                                                    })
                                            }
                                                //------------------------
                                            else if (isBNZ) {
                                                let exportToANZ = {
                                                    companyName: orgName,
                                                    bankAccountNumber: bankAccount,
                                                    bankAccountName: bankAccountName,
                                                    bankAccountCode: bankAccountCode,
                                                    bankAccountID: bankAccountID,
                                                    errorCount: errorCount,
                                                    invoices: selectedInvoices,
                                                    hasLodgementReference: showLodgementReference,
                                                    LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                    LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                    isinsertRecordDB: isinsertRecordDB,
                                                    TransactionDate: formatDate(dateTransaction.value),
                                                    Particulars: Particulars,
                                                    IsDbbFormat: isDbb,
                                                    BankOptionSelected: bankOptionSelected,
                                                    sumInvoicesPerContact: chksumInvoicesPerContact
                                                }
                                                fetch(API_ENDPOINTS.EXPORT_NZ_AFIV, {
                                                    body: JSON.stringify(exportToANZ),
                                                    method: 'POST',
                                                    headers: {
                                                        'Content-Type': 'application/json; charset=utf-8'
                                                    },
                                                }).then(response => response.blob())
                                                    .then(response => {
                                                        //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                        document.getElementById("spinner1").style.visibility = "hidden";
                                                        const blob = new Blob([response], { type: 'text/plain' })
                                                        const downloadUrl = URL.createObjectURL(blob)
                                                        const a = document.createElement("a")
                                                        a.href = downloadUrl
                                                        a.download = "batch_payments_export.afi";
                                                        isDbb = false;
                                                        document.body.appendChild(a)

                                                        //dialog.hide()
                                                        grid.hideSpinner()
                                                        a.click()
                                                        window.disabledGridEditing = false
                                                        var messageAfterExport = "";
                                                        messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                        dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                        document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                        var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                        var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                                        dlgContent.classList.add("dlg-content-template")
                                                        promptDialog.hide()
                                                        dialogAfterExport.show()
                                                        grid.hideSpinner()
                                                        //document.getElementById("step1").ej2_instances[0].disabled = true
                                                    })
                                            }
                                            //------------------------
                                            else {
                                                let exportToABA2 = {
                                                    bankAccountNumber: bankAccount,
                                                    bankAccountName: bankAccountName,
                                                    bankAccountCode: bankAccountCode,
                                                    bankAccountID: bankAccountID,
                                                    errorCount: errorCount,
                                                    invoices: selectedInvoices,
                                                    hasLodgementReference: showLodgementReference,
                                                    LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                    LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                    isinsertRecordDB: isinsertRecordDB,
                                                    TransactionDate: formatDate(dateTransaction.value),
                                                    Particulars: Particulars,
                                                    IsDbbFormat: isDbb
                                                }
                                                fetch(API_ENDPOINTS.EXPORT_NZ, {
                                                    body: JSON.stringify(exportToABA2),
                                                    method: 'POST',
                                                    headers: {
                                                        'Content-Type': 'application/json; charset=utf-8'
                                                    },
                                                }).then(response => response.blob())
                                                    .then(response => {
                                                        //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                        document.getElementById("spinner1").style.visibility = "hidden";
                                                        const blob = new Blob([response], { type: 'text/plain' })
                                                        const downloadUrl = URL.createObjectURL(blob)
                                                        const a = document.createElement("a")
                                                        a.href = downloadUrl
                                                        a.download = isDbb ? "batch_payments_export.dbb" : "batch_payments_export.MT9";
                                                        isDbb = false;
                                                        document.body.appendChild(a)

                                                        //dialog.hide()
                                                        grid.hideSpinner()
                                                        a.click()
                                                        window.disabledGridEditing = false
                                                        var messageAfterExport = "";
                                                        messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                        dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                        document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                        var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                        var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                                        dlgContent.classList.add("dlg-content-template")
                                                        promptDialog.hide()
                                                        dialogAfterExport.show()
                                                        grid.hideSpinner()
                                                        //document.getElementById("step1").ej2_instances[0].disabled = true
                                                    })
                                            }

                                        

                                        }
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialogAfterExport.hide()
                                            dialog.hide()
                                        }

                                        document.getElementById("btnABACancel").onclick = function (e) {
                                            dialog.hide()
                                            grid.hideSpinner()
                                        }

                                        document.getElementById("btnShowIssues").onclick = function (e) {

                                            //var blob = new Blob([errorlist], { type: "text/plain;charset=utf-8" });
                                            //const downloadUrl = URL.createObjectURL(blob)
                                            //const a = document.createElement("a")
                                            //a.href = downloadUrl
                                            //a.download = "errors_batch_payments_export.aba"
                                            //document.body.appendChild(a)
                                            //a.click()
                                            //grid.hideSpinner()
                                            dialogViewErrorList = document.getElementById("dialogViewErrorList").ej2_instances[0]
                                            //document.getElementById("errorlist").innerHTML = errorlist
                                            var x = errorlist;
                                            //let list = document.getElementById("errorlist");

                                            //for (i = 0; i < errorlist.length; ++i) {
                                            //    let li = document.createElement('li');
                                            //    li.innerText = errorlist[i];
                                            //    list.appendChild(li);
                                            //}

                                            var dlgHeader = document.getElementById("dialogViewErrorList_dialog-header")
                                            var dlgContent = document.getElementById("dialogViewErrorList_dialog-content")

                                            dlgHeader.classList.add("error-dlg-header-template")
                                            dlgContent.classList.add("dlg-content-template")

                                            dialogViewErrorList.show()


                                        }
                                        document.getElementById("btnViewErrorList").onclick = function (e) {
                                            dialogViewErrorList.hide()
                                            //dialog.hide()
                                        }
                                    }

                                    else if (response.result == true) {
                                        //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]

                                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")
                                        grid.hideSpinner()
                                        promptDialog.hide()
                                        //dialogProgress.show()

                                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                                        //var count = 65;
                                        //var exportToAbbaInterval = setInterval(function () {

                                        //    if (count <= 100) {
                                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                                        //    } else {
                                        //        clearInterval(exportToAbbaInterval);
                                        //        return;
                                        //    }
                                        //    count += 1;
                                        //}, 100);


                                        if (isCSV) {
                                            let exportToANZ = {
                                                companyName: orgName,
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                Particulars: Particulars,
                                                IsDbbFormat: isDbb,
                                                BankOptionSelected: bankOptionSelected
                                            }
                                            fetch(API_ENDPOINTS.EXPORT_NZ_CSV, {
                                                body: JSON.stringify(exportToANZ),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = "batch_payments_export.csv";
                                                    isDbb = false;
                                                    document.body.appendChild(a)

                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()
                                                    //document.getElementById("step1").ej2_instances[0].disabled = true
                                                })
                                        }
                                            //------------------------
                                        else if (isBNZ) {
                                            let exportToANZ = {
                                                companyName: orgName,
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                Particulars: Particulars,
                                                IsDbbFormat: isDbb,
                                                BankOptionSelected: bankOptionSelected,
                                                sumInvoicesPerContact: chksumInvoicesPerContact
                                            }
                                            fetch(API_ENDPOINTS.EXPORT_NZ_AFIV, {
                                                body: JSON.stringify(exportToANZ),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = "batch_payments_export.afi";
                                                    isDbb = false;
                                                    document.body.appendChild(a)

                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()
                                                    //document.getElementById("step1").ej2_instances[0].disabled = true
                                                })
                                        }
                                        //------------------------
                                        else {
                                            let exportToABA2 = {
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                hasLodgementReference: showLodgementReference,
                                                LodgementReferenceNumberTo: LodgementReferenceNumberTo,
                                                LodgementReferenceNumberFrom: LodgementReferenceNumberFrom,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                Particulars: Particulars,
                                                IsDbbFormat: isDbb
                                            }
                                            fetch(API_ENDPOINTS.EXPORT_NZ, {
                                                body: JSON.stringify(exportToABA2),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    //document.getElementById("spinnerErrorExportFile").style.visibility = "hidden";
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = isDbb ? "batch_payments_export.dbb" : "batch_payments_export.MT9";
                                                    isDbb = false;
                                                    document.body.appendChild(a)

                                                    //dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()
                                                    //document.getElementById("step1").ej2_instances[0].disabled = true
                                                })
                                        }

                                    }
                                })
                            document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                dialogAfterExport.hide()
                                dialog.hide()
                            }
                        }
                        else {
                            tenantNotConnected()
                            dialogProgress.hide()
                        }
                    }
                    document.getElementById("btnCancel").onclick = function (e) {
                        promptDialog.hide()
                        grid.hideSpinner()
                    }
                }
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    grid.hideSpinner()
                    dialog.hide()
                }
            }
        }
        if (args.item.id === "Makeabulkpayment") {
            var div = document.getElementById("wizardForm");
            if (div.style.display === "none") {
                div.style.display = "block";
            } else {
                div.style.display = "none";
            }
        }
        if (args.item.id === "MarkAsPaid") {
            var grid = document.getElementById("Grid").ej2_instances[0]

            if (window.isSharedView) {
                var sharedSelected = grid.getSelectedRecords();
                if (sharedSelected.length === 0) {
                    var dialog = document.getElementById("dialog").ej2_instances[0];
                    document.getElementById("message").innerHTML = "* Please select bills to mark as paid. <br/><br/>";
                    dialog.show();
                    return;
                }
                promptTransactionDate2();
                var dateTransaction2 = document.getElementById("dateTransaction2").ej2_instances[0];
                document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";
                document.getElementById("btnPromptOkayTransactionDate2").onclick = function() {
                    if (dateTransaction2.value === null) return;
                    var dialog = document.getElementById("promptInfoDialogTransactionDate2").ej2_instances[0];
                    dialog.hide();
                    var td = dateTransaction2.value;
                    var formattedDate = (td.getMonth()+1) + '/' + td.getDate() + '/' + td.getFullYear();
                    window.initiateSharedMarkAsPaid(sharedSelected, formattedDate, bankAccountCode, bankAccount, '', countryCode);
                };
                return;
            }

            document.getElementById("promptInfoDialogTransactionDate2").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate2").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate2").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate2").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog1").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog1").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog1").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog1").style.borderBottomRightRadius = "10px";
            document.getElementById("promptInfoDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("prompProgressDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("prompProgressDialog").style.borderTopRightRadius = "10px";
            document.getElementById("prompProgressDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("prompProgressDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogMarkAsPaid").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogMarkAsPaid").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogMarkAsPaid").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogMarkAsPaid").style.borderBottomRightRadius = "10px";

            document.getElementById("dialogMarkAsPaidViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogMarkAsPaidViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogMarkAsPaidViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogMarkAsPaidViewErrorList").style.borderBottomRightRadius = "10px";


            document.getElementById("dialogMarkAsPaidConfirmation").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogMarkAsPaidConfirmation").style.borderTopRightRadius = "10px";
            document.getElementById("dialogMarkAsPaidConfirmation").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogMarkAsPaidConfirmation").style.borderBottomRightRadius = "10px";
            document.getElementById("spinnerGlobal").style.visibility = "hidden";

            document.getElementById("spinnerMp").style.visibility = "visible";
            document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";

            const btnPromptOkayTransactionDate2Enable = document.getElementById("btnPromptOkayTransactionDate2");
            btnPromptOkayTransactionDate2Enable.disabled = true;
            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            var dateTransaction = document.getElementById("dateTransaction2").ej2_instances[0]
            grid.showSpinner();
            var message = ""
            let selectedInvoicesToMarkAsPaid = [];
            let filteredInvoices = [];
            let errorCount = 0;

            //// Convert existingSelection to a Map for quick lookups
            //const existingSelectionMap = new Map(existingSelection.map(record => [
            //    record.invoiceID, // Key is a combination of invoiceID and orgID
            //    true // Value can be true or anything to indicate existence
            //]));
            //// Filter window.newDataRecord based on existingSelection
            //const filteredNewDataRecord = window.newDataRecord.filter(record => {
            //    // Create the key for the current record
            //    const key = record.invoiceID;
            //    // Check if the key exists in the Map
            //    return existingSelectionMap.has(key);
            //});
            //var filteredSelection = filteredNewDataRecord.filter(function (item) {
            //    // Remove items that don't have an orgId or have an orgId matching the subscriptionID
            //    return  item.orgId == window.subscriptionID;
            //});

            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            // Iterate over each record in filteredNewDataRecord to add the isContactName property
            const updatedFilteredNewDataRecord = filteredNewDataRecord.map(record => {
                // Check if contact name is empty or null
                if (record.contact.name === "" || record.contact.name === null) {
                    record.isContactName = false;
                } else {
                    record.isContactName = true;
                }
                return record;
            });

            if (updatedFilteredNewDataRecord.length === 0) {
                selectedInvoicesToMarkAsPaid = this.getSelectedRecords();
            } else {
                selectedInvoicesToMarkAsPaid = updatedFilteredNewDataRecord
                    let exportToABA = {
                        bankAccountNumber: bankAccount,
                        bankAccountName: bankAccountName,
                        bankAccountCode: bankAccountCode,
                        bankAccountID: bankAccountID,
                        errorCount: errorCount,
                        invoices: selectedInvoicesToMarkAsPaid,
                        isinsertRecordDB: '',
                        hasLodgementReference: false,
                        LodgementReferenceNumberTo: '',
                        LodgementReferenceNumberFrom: '',
                        TransactionDate: formatDate(dateTransaction.value)
                    }

                    if (CheckIfConnectedToXero()) {
                        var response = $.ajax({
                            url: API_ENDPOINTS.MARK_PAID_FORMAT_CHECK,
                            type: 'POST',
                            data: JSON.stringify(exportToABA),
                            contentType: 'application/json; charset=utf-8',
                            async: false, // This makes the call synchronous
                            success: function (responseData) {
                                console.log(responseData);
                                if (responseData.result == false) {
                                    if (responseData.error.length > 0) {
                                        selectedInvoiceWithNoBankDetails = responseData.error;
                                        selectedInvoiceWithNoBankDetailsReportExport = responseData.error;
                                        filteredInvoices = selectedInvoicesToMarkAsPaid.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID));
                                        promptEmailAddressValidation(selectedInvoicesToMarkAsPaid, selectedInvoiceWithNoBankDetails);
                                    }
                                } else {
                                    filteredInvoices = selectedInvoicesToMarkAsPaid
                                }
                            },
                            error: function (xhr, status, error) {
                                console.error("Error occurred: " + error);
                            }
                        });
                    }
            }

            if (selectedInvoicesToMarkAsPaid.length === 0) {
                //grid.hideSpinner()
                if (selectedInvoicesToMarkAsPaid.length === 0) {
                    message += "* Please select bills to mark as paid. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message
                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")
                dialog.show()
                grid.hideSpinner()

            }
            else {
                if (selectedInvoicesToMarkAsPaid.filter(i => (i.hasEmailAddress == false && i.hasBankDetails == false) || (i.hasEmailAddress == true && i.hasBankDetails == false) || (i.isContactName == false)).length > 0) {

                    var NumOfInvoice;
                    var NumOfIssues;
                    document.getElementById("spinnerErrorMp").style.visibility = "visible";
                    document.getElementById("progressStatus10").style.display = "none";
                    document.getElementById("Prog10").style.display = "none";
                    document.getElementById("btnShowMarkAsPaidIssues").style.visibility = "hidden";
                    document.getElementById("btnMarkAsPaidOkay").style.visibility = "visible";
                    document.getElementById("btnShowMarkAsPaidIssues").style.display = "none";
                    document.getElementById("tooltipMp").style.display = "block";
                    const btnABAOkayEnabled = document.getElementById("btnMarkAsPaidOkay");
                    btnABAOkayEnabled.disabled = true;
                    var count = 0;
                    let myInterval = setInterval(function () {

                        if (count <= 20) {
                            document.getElementById('Prog10').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            document.getElementById("spinnerErrorMp").style.visibility = "hidden";
                            var CountInvoiceHasBankDeatils = selectedInvoicesToMarkAsPaid.filter(i => i.hasBankDetails == true).length
                            if (CountInvoiceHasBankDeatils > 0) {
                                document.getElementById("btnMarkAsPaidOkay").style.visibility = "visible";
                                document.getElementById("btnMarkAsPaidOkay").style.display = "initial";
                                document.getElementById("tooltipMp").style.display = "none";
                                document.getElementById("btnShowMarkAsPaidIssues").style.display = "initial";
                                document.getElementById("btnShowMarkAsPaidIssues").style.visibility = "visible";
                                btnABAOkayEnabled.disabled = false;
                            }
                            document.getElementById("btnShowMarkAsPaidIssues").style.display = "initial";
                            document.getElementById("btnShowMarkAsPaidIssues").style.visibility = "visible";
                            //btnABAOkayEnabled.disabled = true;
                            clearInterval(myInterval)
                            return;
                        }
                        count += 1;
                    }, 100);

                    document.getElementById("progressStatus10").innerHTML = "<span style='color:green;display:none'><b>Status:</b> Verifying Email Address...</span>";

                    document.getElementById("btnMarkAsPaidCancel").onclick = function (e) {
                        var dialog = document.getElementById("promptDialogMarkAsPaid").ej2_instances[0]
                        dialog.hide()
                    }


                    document.getElementById("btnMarkAsPaidOkay").onclick = () => {

                        var dialog = document.getElementById("promptDialogMarkAsPaid").ej2_instances[0]
                        dialog.hide()
                        promptTransactionDate2();
                        document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";

                        var count = 20;
                        let myInterval = setInterval(function () {

                            if (count <= 30) {
                                document.getElementById('Prog5').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            } else {
                                document.getElementById("spinnerMp").style.visibility = "hidden";
                                document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";
                                btnPromptOkayTransactionDate2Enable.disabled = false;
                                clearInterval(myInterval)
                                return;
                            }
                            count += 1;
                        }, 100);
                        document.getElementById("progressStatus5").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                        document.getElementById("progressStatus21").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                        document.getElementById("progressStatusOnlysss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                        /*   document.getElementById("progressStatus5").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/

                        document.getElementById("btnPromptOkayTransactionDate2").onclick = () => {

                            if (dateTransaction.value === null) {
                                return
                            }

                            var dialog = document.getElementById("promptInfoDialogTransactionDate2").ej2_instances[0]
                            dialog.hide()

                            var promptDialog1 = document.getElementById("promptDialog1").ej2_instances[0]
                            document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoicesToMarkAsPaid.filter(i => i.hasBankDetails == true).length} bills in Xero as PAID`

                            var dlgHeader = document.getElementById("promptDialog1_dialog-header")
                            dlgHeader.classList.add("prompt-dlg-header-template")

                            var dlgContent = document.getElementById("promptDialog1_dialog-content")
                            dlgContent.classList.add("dlg-content-template")
                            document.getElementById("spinnerMp1").style.visibility = "visible";

                            document.getElementById("btnOkayMarkAsPaid").style.visibility = "visible";
                            const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkayMarkAsPaid");
                            btnPromptOkayTransactionDateEnable.disabled = true;

                            document.getElementById("txtBatchReferenceNoMp").value = ""
                            //document.getElementById("txtBatchReferenceNo").style.display = "block";
                            //document.getElementById("messageBatchReferenceNo").style.display = "none";
                            //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''
                            document.getElementById("btnReferenceMp").style.display = "none";

                            document.getElementById("txtBacsServiceUserNoMp").value = ""
                            document.getElementById("txtBacsServiceUserNoMp").style.display = "none";
                            document.getElementById("messageBacsServiceUserNoMp").style.display = "none";
                            document.getElementById("errorContentBacsServiceUserNoMp").innerHTML = ''

                            document.getElementById("txtNarrativeUserChoiceMp").value = ""
                            document.getElementById("txtNarrativeUserChoiceMp").style.display = "none";
                            document.getElementById("messageNarrativeUserChoiceMp").style.display = "none";
                            document.getElementById("errorNarrativeUserChoiceMp").innerHTML = ''

                            var bankDropDownMp = document.getElementById("bankAccountTypesDropDownMp").ej2_instances[0]
                            document.getElementById("errorContentBankMp").innerHTML = ''
                            document.getElementById("btnOkay").style.visibility = "hidden";
                            document.getElementById("messageBankMp").style.visibility = "hidden";
                            document.getElementById("messageBankDeUserIdMp").style.visibility = "hidden";
                            document.getElementById("txtLodgementReferenceToMp").style.visibility = "hidden";
                            document.getElementById("txtLodgementReferenceFromMp").style.visibility = "hidden";
                            $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();
                            document.getElementById("counter").style.display = "None";
                            document.getElementById("counter").style.visibility = "hidden";
                            document.getElementById("txtLodgementReferenceToMp").style.display = "none";
                            document.getElementById("txtLodgementReferenceToMp").value = "";
                            document.getElementById("txtLodgementReferenceFromMp").style.display = "none";
                            document.getElementById("txtLodgementReferenceFromMp").value = "";

                            document.getElementById("btnOkay").style.display = "none";
                            document.getElementById("messageBankMp").style.display = "none";
                            document.getElementById("messageBankDeUserIdMp").style.display = "none";
                            //document.getElementById("txtBatchReferenceNo").style.display = "none";
                            $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');
                            promptDialog1.show()

                            var count = 30;
                            let myInterval = setInterval(function () {

                                if (count <= 50) {
                                    document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                    document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                } else {
                                    document.getElementById("btnOkay").removeAttribute("disabled");
                                    clearInterval(myInterval)
                                    return;
                                }
                                count += 1;
                            }, 100);

                            /*     document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b> Select Bank Account and Input Reference No...</span>";*/
                            document.getElementById("progressStatus5sss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                            document.getElementById("progressStatus21sss").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                            document.getElementById("progressStatusOnlyss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                            $.ajax({
                                url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                                type: 'GET',
                                headers: {
                                    'Accept': 'application/json; charset=utf-8'
                                },
                                success: (result) => {

                                    if (result.isError) {
                                        operations.errorHandling(result)
                                        return
                                    }
                                    else {

                                        if (result.bankAccounts.length > 0) {
                                            document.getElementById("spinnerMp1").style.visibility = "hidden";
                                            btnPromptOkayTransactionDateEnable.disabled = false;
                                            document.getElementById("btnOkay").style.display = "initial";
                                            document.getElementById("messageBankMp").style.display = "initial";
                                            document.getElementById("txtBatchReferenceNoMp").style.display = "initial";
                                            document.getElementById("btnReferenceMp").style.display = "initial";
                                            document.getElementById("btnReferenceMp").style.display = "initial";
                                            $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'flex');
                                            document.getElementById("btnOkay").style.visibility = "visible";
                                            document.getElementById("messageBankMp").style.visibility = "visible";
                                            document.getElementById("txtBatchReferenceNoMp").style.visibility = "visible";
                                            $("span[aria-owns='bankAccountTypesDropDownMp_options']").show();
                                            bankDropDownMp.dataSource = result.bankAccounts
                                        }
                                        else
                                            document.getElementById("errorContentBankMp").innerHTML = 'No bank account'
                                    }
                                },
                                error: (error) => {
                                    document.getElementById("errorContentBankMp").innerHTML = [error.statusText, error.responseText].join(' ')
                                }
                            })
                            document.getElementById("btnOkayMarkAsPaid").onclick = function (e) {
                                var grid = document.getElementById("Grid").ej2_instances[0];
                                var selectedRecords = selectedInvoicesToMarkAsPaid

                                totals = 0;
                                selectedRecords.forEach((item) => {
                                    totals += item.amountDueEditable;
                                });
                                if (countryCode == "GB") {
                                    document.getElementById("totals").innerHTML = "£" + totals.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                                }
                                else {
                                    document.getElementById("totals").innerHTML = "$" + totals.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

                                }
                                dialogMarkAsPaidConfirmation = document.getElementById("dialogMarkAsPaidConfirmation").ej2_instances[0]
                                var dlgHeader = document.getElementById("dialogMarkAsPaidConfirmation_dialog-header")
                                dlgHeader.classList.add("prompt-dlg-header-template")

                                var dlgContent = document.getElementById("dialogMarkAsPaidConfirmation_dialog-content")
                                dlgContent.classList.add("dlg-content-template")


                                dialogMarkAsPaidConfirmation.show()

                            }
                            document.getElementById("btnMarkAsPaidConfirmation").onclick = function (e) {
                                dialogMarkAsPaidConfirmation.hide()
                                document.getElementById("btnPromptOkayMarkAsPaid").style.visibility = "hidden";
                                document.getElementById("btnPromptOkayMarkAsPaid").style.display = "none";
                                if (bankAccount === null || bankAccount.length === 0) {
                                    document.getElementById("messageBankMp").style.display = "block";
                                    document.getElementById("messageBankMp").innerHTML = 'No bank account'
                                    return
                                } else if (bankAccountName == null || bankAccountName.length === 0) {
                                    document.getElementById("messageBankMp").style.display = "block";
                                    document.getElementById("messageBankMp").innerHTML = 'No bank account name'
                                    return
                                } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                                    document.getElementById("messageBankMp").style.display = "block";
                                    document.getElementById("messageBankMp").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                                    return
                                } else {
                                    document.getElementById("messageBankMp").style.display = "none";
                                    document.getElementById("messageBankMp").innerHTML = ''
                                }

                                var BatchReferenceNo = document.getElementById("txtBatchReferenceNoMp").value

                                if (BatchReferenceNo == null || BatchReferenceNo == "") {
                                    document.getElementById("messageBatchReferenceNoMp").style.display = "block";
                                    document.getElementById("messageBatchReferenceNoMp").innerHTML = 'No batch reference no'
                                    return
                                } else {
                                    document.getElementById("messageBatchReferenceNoMp").style.display = "none";
                                    document.getElementById("messageBatchReferenceNoMp").innerHTML = ''
                                    document.getElementById("counter").style.display = "None";
                                    document.getElementById("counter").style.visibility = "hidden";
                                }

                                var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]
                                var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                dlgHeader.classList.add("prompt-dlg-header-template")
                                dlgContent.classList.add("dlg-content-template")

                                dialogProgress.show()
                                document.getElementById("progressStatus5Mb").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                document.getElementById("progressStatus21Mb").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                                document.getElementById("progressStatusOnly").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                                /* document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b> Marking bills as paid...</span>";*/

                                var count = 50;
                                let myInterval = setInterval(function () {

                                    if (count <= 65) {
                                        // document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                    } else {
                                        clearInterval(myInterval)
                                        return;
                                    }
                                    count += 1;
                                }, 100);

                                promptDialog1.hide()

                                let chunkSize = 200;
                                let invoicesChunked
                                let sortedFilteredNewDataRecord = null;

                                if (filteredInvoices.length !== 0) {
                                    // Sort filteredInvoices by contactName if it's not empty
                                    sortedFilteredNewDataRecord = filteredInvoices.sort((a, b) => a.contactName.localeCompare(b.contactName));
                                } else {
                                    // Otherwise, sort selectedInvoicesToMarkAsPaid by contactName
                                    sortedFilteredNewDataRecord = selectedInvoicesToMarkAsPaid.sort((a, b) => a.contactName.localeCompare(b.contactName));
                                }

                                //const sortedFilteredNewDataRecord = filteredInvoices.sort((a, b) => a.contactName.localeCompare(b.contactName));

                                if (sortedFilteredNewDataRecord.length !== 0) {
                                    invoicesChunked = chunkArray(sortedFilteredNewDataRecord, chunkSize);
                                }
                                else {
                                    alert("No invoice can be process because all invoice have no bankDetails and emails");
                                    return;
                                    dialogProgress.hide();
                                }


                                //For debugging
                                // Assuming 'jsonString' is the JSON string you provided
                                //const jsonString = '[[{"amountDue":2500,"amountPaid":0,"amountDueEditable":2500,"amountCredited":0,"contact":{"contactStatus":0,"salesDefaultLineAmountType":0,"purchasesDefaultLineAmountType":0,"defaultCurrency":0,"contactID":"a1eaf3b8-91dd-4bcb-9393-aee19fe70189","mergedToContactID":null,"contactNumber":null,"accountNumber":null,"name":"SMART Agency","firstName":null,"lastName":null,"companyNumber":null,"emailAddress":null,"skypeUserName":null,"contactPersons":[],"bankAccountDetails":null,"taxNumber":null,"accountsReceivableTaxType":null,"accountsPayableTaxType":null,"addresses":[],"phones":[],"isSupplier":null,"isCustomer":null,"xeroNetworkKey":null,"salesDefaultAccountCode":null,"purchasesDefaultAccountCode":null,"salesTrackingCategories":null,"purchasesTrackingCategories":null,"trackingCategoryName":null,"trackingCategoryOption":null,"paymentTerms":null,"updatedDateUTC":null,"contactGroups":[],"website":null,"brandingTheme":null,"batchPayments":null,"discount":null,"balances":null,"attachments":null,"hasAttachments":null,"validationErrors":null,"hasValidationErrors":false,"statusAttributeString":null},"contactName":"SMART Agency","date":"2023-11-08T00:00:00.000Z","plannedDate":"1970-01-01T00:00:00.000Z","dueDate":"2023-11-18T00:00:00.000Z","emailAddress":"elgene@qualiticks.com","hasEmailAddress":true,"invoiceID":"5ba40d16-da3f-4c80-b4b6-f913f5cb3411","invoiceNumber":"SM0210","paymentDate":null,"reference":"","sendDate":null,"status":"Awaiting Payment","sentToContact":null,"CreditNoteID":"","ListOfCreditNote":null,"Total":2500,"ListOfPayments":null}]]';
                                // Deserialize the JSON string into a JavaScript object
                                //const invoicesTest = JSON.parse(jsonString);
                                logToServer('info', 'invoicesChunked2 javascript', invoicesChunked);
                                logToServer('info', 'selected invoices2 javascript', filteredInvoices);
                                document.getElementById("loadingProcess").style.visibility = "visible";
                                if (CheckIfConnectedToXero()) {
                                    //debugger;
                                    processInvoices(invoicesChunked, bankAccount, bankAccountCode, dateTransaction, BatchReferenceNo, countryCode, promptDialog1, dialogProgress)
                                        .then(() => {
                                            logToServer('info', 'window.markAsPaidResult2 javascript', window.markAsPaidResult);
                                            //FOR DEBUGGING
                                            //var test = "{\"invoices\":{\"result\":{\"_Payments\":[{\"status\":0,\"paymentType\":0,\"invoice\":{\"type\":0,\"lineAmountTypes\":0,\"currencyCode\":0,\"status\":0,\"contact\":{\"contactStatus\":0,\"salesDefaultLineAmountType\":0,\"purchasesDefaultLineAmountType\":0,\"defaultCurrency\":0,\"contactID\":\"a1eaf3b8-91dd-4bcb-9393-aee19fe70189\",\"mergedToContactID\":null,\"contactNumber\":null,\"accountNumber\":null,\"name\":\"SMART Agency\",\"firstName\":null,\"lastName\":null,\"companyNumber\":null,\"emailAddress\":null,\"skypeUserName\":null,\"contactPersons\":[],\"bankAccountDetails\":null,\"taxNumber\":null,\"accountsReceivableTaxType\":null,\"accountsPayableTaxType\":null,\"addresses\":[],\"phones\":[],\"isSupplier\":null,\"isCustomer\":null,\"xeroNetworkKey\":null,\"salesDefaultAccountCode\":null,\"purchasesDefaultAccountCode\":null,\"salesTrackingCategories\":null,\"purchasesTrackingCategories\":null,\"trackingCategoryName\":null,\"trackingCategoryOption\":null,\"paymentTerms\":null,\"updatedDateUTC\":null,\"contactGroups\":[],\"website\":null,\"brandingTheme\":null,\"batchPayments\":null,\"discount\":null,\"balances\":null,\"attachments\":null,\"hasAttachments\":null,\"validationErrors\":null,\"hasValidationErrors\":false,\"statusAttributeString\":null},\"lineItems\":[],\"date\":null,\"dueDate\":null,\"invoiceNumber\":null,\"reference\":null,\"brandingThemeID\":null,\"url\":null,\"currencyRate\":null,\"sentToContact\":null,\"expectedPaymentDate\":null,\"plannedPaymentDate\":null,\"cisDeduction\":null,\"cisRate\":null,\"subTotal\":null,\"totalTax\":null,\"total\":null,\"totalDiscount\":null,\"invoiceID\":\"49e4648f-8ad3-4f5d-973c-37a351831665\",\"repeatingInvoiceID\":null,\"hasAttachments\":null,\"isDiscounted\":false,\"payments\":[],\"prepayments\":[],\"overpayments\":[],\"amountDue\":null,\"amountPaid\":null,\"fullyPaidOnDate\":null,\"amountCredited\":null,\"updatedDateUTC\":null,\"creditNotes\":[],\"attachments\":null,\"hasErrors\":false,\"statusAttributeString\":null,\"validationErrors\":null,\"warnings\":null},\"creditNote\":null,\"prepayment\":null,\"overpayment\":null,\"invoiceNumber\":null,\"creditNoteNumber\":null,\"account\":{\"type\":1,\"status\":1,\"bankAccountType\":1,\"currencyCode\":108,\"class\":1,\"systemAccount\":0,\"code\":\"090\",\"name\":\"Business Bank Account\",\"accountID\":\"ac993f75-035b-433c-82e0-7b7a2d40802c\",\"bankAccountNumber\":\"1201020345678000\",\"description\":null,\"taxType\":\"NONE\",\"enablePaymentsToAccount\":false,\"showInExpenseClaims\":false,\"reportingCode\":\"ASS\",\"reportingCodeName\":\"Assets\",\"hasAttachments\":false,\"updatedDateUTC\":\"2023-11-24T09:51:19.577Z\",\"addToWatchlist\":false,\"validationErrors\":null},\"code\":\"test0955\",\"date\":\"2023-12-06T00:00:00\",\"currencyRate\":null,\"amount\":2000,\"bankAmount\":null,\"reference\":null,\"isReconciled\":null,\"updatedDateUTC\":null,\"paymentID\":\"df596051-b9eb-452b-9f6b-465cb3c48534\",\"batchPaymentID\":null,\"bankAccountNumber\":\"12-1234-12345-01\",\"particulars\":null,\"details\":\"Remittance not sent\",\"hasAccount\":null,\"hasValidationErrors\":null,\"statusAttributeString\":null,\"validationErrors\":null}]},\"id\":2845,\"exception\":null,\"status\":5,\"isCanceled\":false,\"isCompleted\":true,\"isCompletedSuccessfully\":true,\"creationOptions\":0,\"asyncState\":null,\"isFaulted\":false},\"message\":\"Success\",\"isError\":false}" 
                                            //const testResult = JSON.parse(test);
                                            //window.markAsPaidResult = testResult;
                                            console.log('All chunks processed successfully.');
                                            // Backend returns { Invoices: { _Payments: [...] } } - no .result level
                                            if (window.markAsPaidResult &&
                                                window.markAsPaidResult.invoices &&
                                                window.markAsPaidResult.invoices._Payments &&
                                                window.markAsPaidResult.invoices._Payments.length > 1) {
                                                document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #add1b5a6 !important;padding: 15px;border: 1px solid #94c19454;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 1px;margin-right: 8px;"> <span class="e-icons e-check" title="Success" style="color: #277d27;font-size: 12px;border: 1px solid;border-radius: 50%;padding: 2px;"></span></div> <div> <span style="color: #125525;font-size: 14px;"> Bills have been marked as paid successfully </span></div></div>';
                                            }
                                            else if (window.markAsPaidResult &&
                                                window.markAsPaidResult.invoices &&
                                                window.markAsPaidResult.invoices._Payments &&
                                                window.markAsPaidResult.invoices._Payments.length == 1) {
                                                document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #add1b5a6 !important;padding: 15px;border: 1px solid #94c19454;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 1px;margin-right: 8px;"> <span class="e-icons e-check" title="Success" style="color: #277d27;font-size: 12px;border: 1px solid;border-radius: 50%;padding: 2px;"></span></div> <div> <span style="color: #125525;font-size: 14px;"> Bill has been marked as paid successfully </span></div></div>';
                                            }
                                            else {
                                                // Use stored descriptive error message instead of generic "error occured"
                                                var errorMessage = window.lastMarkAsPaidError || "An error occurred while processing the payment";
                                                document.getElementById('SuccessStatus').innerHTML = window.getErrorDisplayHtml(errorMessage);
                                            }

                                        })
                                        .catch((error) => {
                                            //debugger
                                            console.error('An error occurred:', error);
                                            // Perform any error handling here
                                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                            // Clear Selected bills per organization
                                            var filteredSelection = existingSelection.filter(function (item) {
                                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                            });

                                            // Save the updated selection to localStorage
                                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                            //localStorage.setItem(STORAGE_KEYS.SELECTED_DATA_FOR_REMITTANCE, JSON.stringify(existingSelection));
                                        });

                                } else {
                                    dialogProgress.hide();
                                    tenantNotConnected()
                                }
                            }

                            document.getElementById("btnCancel").onclick = function (e) {
                                promptDialog1.hide()
                                //grid.hideSpinner()
                            }
                            document.getElementById("btnCancelMp").onclick = function (e) {
                                promptDialog1.hide()
                                grid.hideSpinner()
                            }
                            document.getElementById("btnPromptCancelConfirmation").onclick = function (e) {
                                dialogMarkAsPaidConfirmation.hide()
                                window.location = API_ENDPOINTS.HOME_INDEX
                                //grid.hideSpinner()
                            }
                        }

                        document.getElementById("btnPromptCancelTransactionDate2").onclick = () => {
                            var dialog = document.getElementById("promptInfoDialogTransactionDate2").ej2_instances[0]
                            dialog.hide()
                        }

                    }


                }
                else {
                    document.getElementById("spinnerMp").style.visibility = "visible";
                    document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";
                    const btnPromptOkayTransactionDate2Enable = document.getElementById("btnPromptOkayTransactionDate2");
                    btnPromptOkayTransactionDate2Enable.disabled = true;
                    promptTransactionDate2();

                    var count = 0;
                    let myInterval = setInterval(function () {

                        if (count <= 20) {
                            document.getElementById('Prog5').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            document.getElementById("spinnerMp").style.visibility = "hidden";
                            document.getElementById("btnPromptOkayTransactionDate2").style.visibility = "visible";
                            btnPromptOkayTransactionDate2Enable.disabled = false;
                            clearInterval(myInterval)
                            return;
                        }
                        count += 1;
                    }, 100);
                    document.getElementById("progressStatus5").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus21").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                    document.getElementById("progressStatusOnlysss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                    //document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -25px;white-space: normal;width: 90px;'>Exporting data to ABA</div>";
                    /*  document.getElementById("progressStatus5").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/

                    document.getElementById("btnPromptOkayTransactionDate2").onclick = () => {

                        if (dateTransaction.value === null) {

                            return
                        }
                        document.getElementById("spinnerMp1").style.visibility = "visible";
                        var dialog = document.getElementById("promptInfoDialogTransactionDate2").ej2_instances[0]
                        dialog.hide()

                        var promptDialog1 = document.getElementById("promptDialog1").ej2_instances[0]
                        document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${filteredInvoices.length} bills in Xero as PAID`

                        var dlgHeader = document.getElementById("promptDialog1_dialog-header")
                        dlgHeader.classList.add("prompt-dlg-header-template")

                        var dlgContent = document.getElementById("promptDialog1_dialog-content")
                        dlgContent.classList.add("dlg-content-template")

                        document.getElementById("txtBatchReferenceNoMp").value = ""
                        document.getElementById("txtBatchReferenceNoMp").style.display = "block";
                        //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''


                        var bankDropDown = document.getElementById("bankAccountTypesDropDownMp").ej2_instances[0]
                        document.getElementById("errorContentBankMp").innerHTML = ''

                        document.getElementById("btnOkayMarkAsPaid").style.visibility = "visible";
                        const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkayMarkAsPaid");
                        btnPromptOkayTransactionDateEnable.disabled = true;

                        document.getElementById("messageBankMp").style.visibility = "hidden";
                        document.getElementById("messageBankDeUserIdMp").style.visibility = "hidden";
                        document.getElementById("txtBatchReferenceNoMp").style.visibility = "hidden";
                        document.getElementById("txtLodgementReferenceToMp").style.visibility = "hidden";
                        document.getElementById("txtLodgementReferenceFromMp").style.visibility = "hidden";
                        document.getElementById("errorContentBatchReferenceNoMp").style.visibility = "hidden";
                        document.getElementById("messageBatchReferenceNoMp").style.visibility = "hidden";

                        document.getElementById("counter").style.display = "None";
                        document.getElementById("counter").style.visibility = "hidden";
                        $("span[aria-owns='bankAccountTypesDropDownMp_options']").hide();
                        document.getElementById("messageBankMp").style.display = "none";
                        document.getElementById("messageBankDeUserIdMp").style.display = "none";
                        document.getElementById("txtBatchReferenceNoMp").style.display = "none";
                        document.getElementById("btnReferenceMp").style.display = "none";
                        document.getElementById("errorContentBatchReferenceNoMp").style.display = "none";
                        document.getElementById("messageBatchReferenceNoMp").style.display = "none";
                        document.getElementById("txtLodgementReferenceToMp").style.display = "none";
                        document.getElementById("txtLodgementReferenceToMp").value = "";
                        document.getElementById("txtLodgementReferenceFromMp").style.display = "none";
                        document.getElementById("txtLodgementReferenceFromMp").value = "";
                        $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'none');

                        document.getElementById("txtBacsServiceUserNoMp").style.display = "none";
                        document.getElementById("messageBacsServiceUserNoMp").style.display = "none";
                        document.getElementById("txtBacsServiceUserNoMp").style.visibility = "hidden";
                        document.getElementById("messageBacsServiceUserNoMp").style.visibility = "hidden";
                        document.getElementById("errorContentBacsServiceUserNoMp").innerHTML = ''

                        document.getElementById("txtNarrativeUserChoiceMp").style.display = "none";
                        document.getElementById("messageNarrativeUserChoiceMp").style.display = "none";
                        document.getElementById("txtNarrativeUserChoiceMp").style.visibility = "hidden";
                        document.getElementById("messageNarrativeUserChoiceMp").style.visibility = "hidden";
                        document.getElementById("errorNarrativeUserChoiceMp").innerHTML = ''

                        document.getElementById("SuccessStatus").style.visibility = "hidden";
                        document.getElementById("SuccessStatus").style.display = "none";

                        promptDialog1.show()
                        var count = 20;
                        let myInterval = setInterval(function () {

                            if (count <= 30) {
                                document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            } else {
                                clearInterval(myInterval)
                                return;
                            }
                            count += 1;
                        }, 100);

                        /*      document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b> Select Bank Account and Input Reference No...</span>";*/
                        document.getElementById("progressStatus5sss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                        document.getElementById("progressStatus21sss").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                        document.getElementById("progressStatusOnlyss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                        /* document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -25px;white-space: normal;width: 90px;'>Exporting data to ABA</div>";*/
                        $.ajax({
                            url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                            type: 'GET',
                            headers: {
                                'Accept': 'application/json; charset=utf-8'
                            },
                            success: (result) => {

                                if (result.sessionTimeOut)
                                    window.location = API_ENDPOINTS.HOME_INDEX

                                if (result.IsError) {
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                                    return
                                }
                                else {

                                    if (result.bankAccounts.length > 0) {


                                        document.getElementById("spinnerMp1").style.visibility = "hidden";
                                        btnPromptOkayTransactionDateEnable.disabled = false;
                                        document.getElementById("btnOkayMarkAsPaid").style.display = "initial";
                                        document.getElementById("messageBankMp").style.display = "initial";
                                        document.getElementById("txtBatchReferenceNoMp").style.display = "initial";
                                        document.getElementById("btnReferenceMp").style.display = "initial";
                                        document.getElementById("errorContentBatchReferenceNoMp").style.display = "initial";
                                        document.getElementById("messageBatchReferenceNoMp").style.display = "initial";
                                        $("span[aria-owns='bankAccountTypesDropDownMp_options']").css('display', 'flex');
                                        document.getElementById("btnOkayMarkAsPaid").style.visibility = "visible";
                                        document.getElementById("messageBankMp").style.visibility = "visible";
                                        document.getElementById("txtBatchReferenceNoMp").style.visibility = "visible";
                                        document.getElementById("errorContentBatchReferenceNoMp").style.visibility = "visible";
                                        document.getElementById("messageBatchReferenceNoMp").style.visibility = "visible";



                                        $("span[aria-owns='bankAccountTypesDropDownMp_options']").show();
                                        bankDropDown.dataSource = result.bankAccounts
                                    }
                                    else
                                        document.getElementById("errorContentBankMp").innerHTML = 'No bank account'
                                }
                            },
                            error: (error) => {
                                document.getElementById("errorContentBankMp").innerHTML = [error.statusText, error.responseText].join(' ')
                            }
                        })
                        document.getElementById("btnOkayMarkAsPaid").onclick = function (e) {
                            var grid = document.getElementById("Grid").ej2_instances[0];
                            var selectedRecords = selectedInvoicesToMarkAsPaid
                            totals = 0;
                            selectedRecords.forEach((item) => {
                                totals += item.amountDueEditable;
                            });

                            if (countryCode == "GB") {
                                document.getElementById("totals").innerHTML = "£" + totals.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                            }
                            else {
                                document.getElementById("totals").innerHTML = "$" + totals.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                            }

                            dialogMarkAsPaidConfirmation = document.getElementById("dialogMarkAsPaidConfirmation").ej2_instances[0]
                            var dlgHeader = document.getElementById("dialogMarkAsPaidConfirmation_dialog-header")
                            dlgHeader.classList.add("prompt-dlg-header-template")

                            var dlgContent = document.getElementById("dialogMarkAsPaidConfirmation_dialog-content")
                            dlgContent.classList.add("dlg-content-template")


                            dialogMarkAsPaidConfirmation.show()

                        }
                        document.getElementById("btnMarkAsPaidConfirmation").onclick = function (e) {
                            dialogMarkAsPaidConfirmation.hide()
                            document.getElementById("btnPromptOkayMarkAsPaid").style.visibility = "hidden";
                            document.getElementById("btnPromptOkayMarkAsPaid").style.display = "none";

                            if (bankAccount === null || bankAccount.length === 0) {
                                document.getElementById("messageBankMp").style.display = "block";
                                document.getElementById("messageBankMp").innerHTML = 'No bank account'
                                return
                            } else if (bankAccountName == null || bankAccountName.length === 0) {
                                document.getElementById("messageBankMp").style.display = "block";
                                document.getElementById("messageBankMp").innerHTML = 'No bank account name'
                                return
                            } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                                document.getElementById("messageBankMp").style.display = "block";
                                document.getElementById("messageBankMp").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                                return
                            } else {
                                document.getElementById("messageBankMp").style.display = "none";
                                document.getElementById("messageBankMp").innerHTML = ''
                            }


                            var BatchReferenceNo = document.getElementById("txtBatchReferenceNoMp").value

                            if (BatchReferenceNo == "") {
                                document.getElementById("messageBatchReferenceNoMp").style.display = "Block";
                                return
                            }
                            var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]
                            var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                            var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                            dlgHeader.classList.add("prompt-dlg-header-template")
                            dlgContent.classList.add("dlg-content-template")

                            dialogProgress.show()
                            document.getElementById("progressStatus5Mb").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                            document.getElementById("progressStatus21Mb").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 200px;'>Bank & Reference</div>";
                            document.getElementById("progressStatusOnly").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -35px;white-space: normal;width: 90px;'>Update Xero</div>";
                            /*  document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Marking bills as paid...</span>";*/

                            var count = 30;
                            setInterval(function () {

                                if (count <= 50) {
                                    // document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                } else {
                                    return;
                                }
                                count += 1;
                            }, 100);

                            promptDialog1.hide()
                            let chunkSize = 200;
                            let invoicesChunked
                            let sortedFilteredNewDataRecord = null;

                            if (filteredInvoices.length !== 0) {
                                // Sort filteredInvoices by contactName if it's not empty
                                sortedFilteredNewDataRecord = filteredInvoices.sort((a, b) => a.contactName.localeCompare(b.contactName));
                            } else {
                                // Otherwise, sort selectedInvoicesToMarkAsPaid by contactName
                                sortedFilteredNewDataRecord = selectedInvoicesToMarkAsPaid.sort((a, b) => a.contactName.localeCompare(b.contactName));
                            }

                            if (sortedFilteredNewDataRecord.length !== 0) {
                                invoicesChunked = chunkArray(sortedFilteredNewDataRecord, chunkSize);
                            }
                            else {
                                alert("No invoice can be process because all invoice have no bankDetails and emails");
                                return;
                                dialogProgress.hide();
                            }


                            //For debugging
                            // Assuming 'jsonString' is the JSON string you provided
                            //const jsonString = '[[{"amountDue":2500,"amountPaid":0,"amountDueEditable":2500,"amountCredited":0,"contact":{"contactStatus":0,"salesDefaultLineAmountType":0,"purchasesDefaultLineAmountType":0,"defaultCurrency":0,"contactID":"a1eaf3b8-91dd-4bcb-9393-aee19fe70189","mergedToContactID":null,"contactNumber":null,"accountNumber":null,"name":"SMART Agency","firstName":null,"lastName":null,"companyNumber":null,"emailAddress":null,"skypeUserName":null,"contactPersons":[],"bankAccountDetails":null,"taxNumber":null,"accountsReceivableTaxType":null,"accountsPayableTaxType":null,"addresses":[],"phones":[],"isSupplier":null,"isCustomer":null,"xeroNetworkKey":null,"salesDefaultAccountCode":null,"purchasesDefaultAccountCode":null,"salesTrackingCategories":null,"purchasesTrackingCategories":null,"trackingCategoryName":null,"trackingCategoryOption":null,"paymentTerms":null,"updatedDateUTC":null,"contactGroups":[],"website":null,"brandingTheme":null,"batchPayments":null,"discount":null,"balances":null,"attachments":null,"hasAttachments":null,"validationErrors":null,"hasValidationErrors":false,"statusAttributeString":null},"contactName":"SMART Agency","date":"2023-11-08T00:00:00.000Z","plannedDate":"1970-01-01T00:00:00.000Z","dueDate":"2023-11-18T00:00:00.000Z","emailAddress":"elgene@qualiticks.com","hasEmailAddress":true,"invoiceID":"5ba40d16-da3f-4c80-b4b6-f913f5cb3411","invoiceNumber":"SM0210","paymentDate":null,"reference":"","sendDate":null,"status":"Awaiting Payment","sentToContact":null,"CreditNoteID":"","ListOfCreditNote":null,"Total":2500,"ListOfPayments":null}]]';
                            // Deserialize the JSON string into a JavaScript object
                            //const invoicesTest = JSON.parse(jsonString);
                            logToServer('info', 'invoicesChunked2 javascript', invoicesChunked);
                            logToServer('info', 'selected invoices2 javascript', filteredInvoices);
                            if (CheckIfConnectedToXero()) {
                                //debugger;
                                processInvoices(invoicesChunked, bankAccount, bankAccountCode, dateTransaction, BatchReferenceNo, countryCode, promptDialog1, dialogProgress)
                                    .then(() => {
                                        logToServer('info', 'window.markAsPaidResult2 javascript', window.markAsPaidResult);
                                        //FOR DEBUGGING
                                        //var test = "{\"invoices\":{\"result\":{\"_Payments\":[{\"status\":0,\"paymentType\":0,\"invoice\":{\"type\":0,\"lineAmountTypes\":0,\"currencyCode\":0,\"status\":0,\"contact\":{\"contactStatus\":0,\"salesDefaultLineAmountType\":0,\"purchasesDefaultLineAmountType\":0,\"defaultCurrency\":0,\"contactID\":\"a1eaf3b8-91dd-4bcb-9393-aee19fe70189\",\"mergedToContactID\":null,\"contactNumber\":null,\"accountNumber\":null,\"name\":\"SMART Agency\",\"firstName\":null,\"lastName\":null,\"companyNumber\":null,\"emailAddress\":null,\"skypeUserName\":null,\"contactPersons\":[],\"bankAccountDetails\":null,\"taxNumber\":null,\"accountsReceivableTaxType\":null,\"accountsPayableTaxType\":null,\"addresses\":[],\"phones\":[],\"isSupplier\":null,\"isCustomer\":null,\"xeroNetworkKey\":null,\"salesDefaultAccountCode\":null,\"purchasesDefaultAccountCode\":null,\"salesTrackingCategories\":null,\"purchasesTrackingCategories\":null,\"trackingCategoryName\":null,\"trackingCategoryOption\":null,\"paymentTerms\":null,\"updatedDateUTC\":null,\"contactGroups\":[],\"website\":null,\"brandingTheme\":null,\"batchPayments\":null,\"discount\":null,\"balances\":null,\"attachments\":null,\"hasAttachments\":null,\"validationErrors\":null,\"hasValidationErrors\":false,\"statusAttributeString\":null},\"lineItems\":[],\"date\":null,\"dueDate\":null,\"invoiceNumber\":null,\"reference\":null,\"brandingThemeID\":null,\"url\":null,\"currencyRate\":null,\"sentToContact\":null,\"expectedPaymentDate\":null,\"plannedPaymentDate\":null,\"cisDeduction\":null,\"cisRate\":null,\"subTotal\":null,\"totalTax\":null,\"total\":null,\"totalDiscount\":null,\"invoiceID\":\"49e4648f-8ad3-4f5d-973c-37a351831665\",\"repeatingInvoiceID\":null,\"hasAttachments\":null,\"isDiscounted\":false,\"payments\":[],\"prepayments\":[],\"overpayments\":[],\"amountDue\":null,\"amountPaid\":null,\"fullyPaidOnDate\":null,\"amountCredited\":null,\"updatedDateUTC\":null,\"creditNotes\":[],\"attachments\":null,\"hasErrors\":false,\"statusAttributeString\":null,\"validationErrors\":null,\"warnings\":null},\"creditNote\":null,\"prepayment\":null,\"overpayment\":null,\"invoiceNumber\":null,\"creditNoteNumber\":null,\"account\":{\"type\":1,\"status\":1,\"bankAccountType\":1,\"currencyCode\":108,\"class\":1,\"systemAccount\":0,\"code\":\"090\",\"name\":\"Business Bank Account\",\"accountID\":\"ac993f75-035b-433c-82e0-7b7a2d40802c\",\"bankAccountNumber\":\"1201020345678000\",\"description\":null,\"taxType\":\"NONE\",\"enablePaymentsToAccount\":false,\"showInExpenseClaims\":false,\"reportingCode\":\"ASS\",\"reportingCodeName\":\"Assets\",\"hasAttachments\":false,\"updatedDateUTC\":\"2023-11-24T09:51:19.577Z\",\"addToWatchlist\":false,\"validationErrors\":null},\"code\":\"test0955\",\"date\":\"2023-12-06T00:00:00\",\"currencyRate\":null,\"amount\":2000,\"bankAmount\":null,\"reference\":null,\"isReconciled\":null,\"updatedDateUTC\":null,\"paymentID\":\"df596051-b9eb-452b-9f6b-465cb3c48534\",\"batchPaymentID\":null,\"bankAccountNumber\":\"12-1234-12345-01\",\"particulars\":null,\"details\":\"Remittance not sent\",\"hasAccount\":null,\"hasValidationErrors\":null,\"statusAttributeString\":null,\"validationErrors\":null}]},\"id\":2845,\"exception\":null,\"status\":5,\"isCanceled\":false,\"isCompleted\":true,\"isCompletedSuccessfully\":true,\"creationOptions\":0,\"asyncState\":null,\"isFaulted\":false},\"message\":\"Success\",\"isError\":false}" 
                                        //const testResult = JSON.parse(test);
                                        //window.markAsPaidResult = testResult;
                                        console.log('All chunks processed successfully.');
                                        // Backend returns { Invoices: { _Payments: [...] } } - no .result level
                                        if (window.markAsPaidResult &&
                                            window.markAsPaidResult.invoices &&
                                            window.markAsPaidResult.invoices._Payments &&
                                            window.markAsPaidResult.invoices._Payments.length > 1) {
                                            document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #add1b5a6 !important;padding: 15px;border: 1px solid #94c19454;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 1px;margin-right: 8px;"> <span class="e-icons e-check" title="Success" style="color: #277d27;font-size: 12px;border: 1px solid;border-radius: 50%;padding: 2px;"></span></div> <div> <span style="color: #125525;font-size: 14px;"> Bills have been marked as paid successfully </span></div></div>';
                                        }
                                        else if (window.markAsPaidResult &&
                                            window.markAsPaidResult.invoices &&
                                            window.markAsPaidResult.invoices._Payments &&
                                            window.markAsPaidResult.invoices._Payments.length == 1) {
                                            document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #add1b5a6 !important;padding: 15px;border: 1px solid #94c19454;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 1px;margin-right: 8px;"> <span class="e-icons e-check" title="Success" style="color: #277d27;font-size: 12px;border: 1px solid;border-radius: 50%;padding: 2px;"></span></div> <div> <span style="color: #125525;font-size: 14px;"> Bill has been marked as paid successfully </span></div></div>';
                                        }
                                        else {
                                            // Use stored descriptive error message instead of generic "error occured"
                                            var errorMessage = window.lastMarkAsPaidError || "An error occurred while processing the payment";
                                            document.getElementById('SuccessStatus').innerHTML = window.getErrorDisplayHtml(errorMessage);
                                        }

                                    })
                                    .catch((error) => {
                                        //debugger
                                        console.error('An error occurred:', error);
                                        var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                        // Clear Selected bills per organization
                                        var filteredSelection = existingSelection.filter(function (item) {
                                            // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                            return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                        });

                                        // Save the updated selection to localStorage
                                        localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                        //localStorage.setItem(STORAGE_KEYS.SELECTED_DATA_FOR_REMITTANCE, JSON.stringify(existingSelection));
                                    });

                            } else {
                                dialogProgress.hide();
                                tenantNotConnected()
                            }

                        }
                        document.getElementById("btnCancelMp").onclick = function (e) {
                            promptDialog1.hide()
                            grid.hideSpinner()
                        }
                        document.getElementById("btnPromptCancelConfirmation").onclick = function (e) {
                            dialogMarkAsPaidConfirmation.hide()
                            window.location = API_ENDPOINTS.HOME_INDEX
                            //grid.hideSpinner()
                        }
                    }

                    document.getElementById("btnPromptCancelTransactionDate2").onclick = () => {
                        var dialog2 = document.getElementById("promptInfoDialogTransactionDate2").ej2_instances[0]
                        dialog2.hide()
                    }
                }
            }
            grid.hideSpinner();
        }

        if (args.item.id == "SendRemittances") {
            document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").style.borderBottomRightRadius = "10px";
            let selectedInvoices
            var selectedBillForRemittance = JSON.parse(localStorage.getItem("selectedDataForeRemittance")) || [];

            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = selectedBillForRemittance.filter(record => record.orgId === subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecordForRemmittance = newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));


            if (filteredNewDataRecordForRemmittance.length === 0) {
                selectedInvoices = this.getSelectedRecords();
            } else {
                debugger
                selectedInvoices = filteredNewDataRecordForRemmittance
                selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID))
                selectedInvoices = selectedInvoices.filter(invoice =>
                    markAsPaidResult.invoices.result._Payments.some(p => p.invoice.invoiceID === invoice.invoiceID)
                );
            }
            var countEmailAdd = selectedInvoices.filter(i => i.hasEmailAddress == true).length;

            if (countEmailAdd <= 0) {

                var message = "* No remittances to be sent. <br/><br/>"
                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                //grid.hideSpinner()

                return
            }

            var dialog = document.getElementById("promptInfoDialog").ej2_instances[0]
            document.getElementById("promptContent").innerHTML = "Do you want to send remittance advices?"

            var dlgHeader = document.getElementById("promptInfoDialog_dialog-header")
            dlgHeader.classList.add("prompt-dlg-header-template")

            var dlgContent = document.getElementById("promptInfoDialog_dialog-content")
            dlgContent.classList.add("dlg-content-template")
            document.getElementById("progressStatus4").style.display = "initial";
            document.getElementById("Prog4").style.display = "none";
            document.getElementById("btnPromptOkay").style.display = "initial";
            document.getElementById("btnPromptCancel").style.display = "initial";
            document.getElementById("spinnerSr").style.visibility = "visible";
            document.getElementById("btnPromptOkay").style.visibility = "visible";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkay");
            btnPromptOkayTransactionDateEnable.disabled = true;
            dialog.show()

            var count = 0;
            var myInterval = setInterval(function () {

                if (count <= 20) {
                    document.getElementById('Prog4').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinnerSr").style.visibility = "hidden";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    document.getElementById("btnPromptOkay").style.visibility = "visible";
                    clearInterval(myInterval)
                    return;
                }
                count += 1;
            }, 100);

            /*   document.getElementById("progressStatus4").innerHTML = "<span style='color:green;'><b>Status:</b> Sending Remmittance...</span>";*/
            document.getElementById("progressStatus4").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Sending Remittances</div>";
            document.getElementById("progressStatus4Step2").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -45px;white-space: normal;width: 90px;text-align: center;'>Remittances Status</div>";

            document.getElementById("btnPromptOkay").onclick = () => {
                document.getElementById("promptContent").innerHTML = ""
                document.getElementById("btnPromptOkay").style.display = "none"
                document.getElementById("btnPromptCancel").style.display = "none"
                var count = 20;
                var myInterval = setInterval(function () {

                    if (count <= 80) {
                        document.getElementById('Prog4').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                    } else {
                        clearInterval(myInterval)
                        return;
                    }
                    count += 1;

                }, 100);


                //FOR DEBUGGING
                //var test = "[{\"amountDue\":2500,\"amountPaid\":0,\"amountDueEditable\":2500,\"amountCredited\":0,\"contact\":{\"contactStatus\":0,\"salesDefaultLineAmountType\":0,\"purchasesDefaultLineAmountType\":0,\"defaultCurrency\":0,\"contactID\":\"a1eaf3b8-91dd-4bcb-9393-aee19fe70189\",\"mergedToContactID\":null,\"contactNumber\":null,\"accountNumber\":null,\"name\":\"SMART Agency\",\"firstName\":null,\"lastName\":null,\"companyNumber\":null,\"emailAddress\":null,\"skypeUserName\":null,\"contactPersons\":[],\"bankAccountDetails\":null,\"taxNumber\":null,\"accountsReceivableTaxType\":null,\"accountsPayableTaxType\":null,\"addresses\":[],\"phones\":[],\"isSupplier\":null,\"isCustomer\":null,\"xeroNetworkKey\":null,\"salesDefaultAccountCode\":null,\"purchasesDefaultAccountCode\":null,\"salesTrackingCategories\":null,\"purchasesTrackingCategories\":null,\"trackingCategoryName\":null,\"trackingCategoryOption\":null,\"paymentTerms\":null,\"updatedDateUTC\":null,\"contactGroups\":[],\"website\":null,\"brandingTheme\":null,\"batchPayments\":null,\"discount\":null,\"balances\":null,\"attachments\":null,\"hasAttachments\":null,\"validationErrors\":null,\"hasValidationErrors\":false,\"statusAttributeString\":null},\"contactName\":\"SMART Agency\",\"date\":\"2023-11-08T00:00:00.000Z\",\"plannedDate\":\"1970-01-01T00:00:00.000Z\",\"dueDate\":\"2023-11-18T00:00:00.000Z\",\"emailAddress\":\"elgene@qualiticks.com\",\"hasEmailAddress\":true,\"invoiceID\":\"5ba40d16-da3f-4c80-b4b6-f913f5cb3411\",\"invoiceNumber\":\"SM0210\",\"paymentDate\":null,\"reference\":\"\",\"sendDate\":null,\"status\":\"Awaiting Payment\",\"sentToContact\":null,\"CreditNoteID\":\"\",\"ListOfCreditNote\":null,\"Total\":2500,\"ListOfPayments\":null}]" 
                //const testResult = JSON.parse(test);
                //selectedInvoices = testResult;

                //var test2 = "{\"invoices\":{\"result\":{\"_Payments\":[{\"status\":0,\"paymentType\":0,\"invoice\":{\"type\":0,\"lineAmountTypes\":0,\"currencyCode\":0,\"status\":0,\"contact\":{\"contactStatus\":0,\"salesDefaultLineAmountType\":0,\"purchasesDefaultLineAmountType\":0,\"defaultCurrency\":0,\"contactID\":\"a1eaf3b8-91dd-4bcb-9393-aee19fe70189\",\"mergedToContactID\":null,\"contactNumber\":null,\"accountNumber\":null,\"name\":\"SMART Agency\",\"firstName\":null,\"lastName\":null,\"companyNumber\":null,\"emailAddress\":null,\"skypeUserName\":null,\"contactPersons\":[],\"bankAccountDetails\":null,\"taxNumber\":null,\"accountsReceivableTaxType\":null,\"accountsPayableTaxType\":null,\"addresses\":[],\"phones\":[],\"isSupplier\":null,\"isCustomer\":null,\"xeroNetworkKey\":null,\"salesDefaultAccountCode\":null,\"purchasesDefaultAccountCode\":null,\"salesTrackingCategories\":null,\"purchasesTrackingCategories\":null,\"trackingCategoryName\":null,\"trackingCategoryOption\":null,\"paymentTerms\":null,\"updatedDateUTC\":null,\"contactGroups\":[],\"website\":null,\"brandingTheme\":null,\"batchPayments\":null,\"discount\":null,\"balances\":null,\"attachments\":null,\"hasAttachments\":null,\"validationErrors\":null,\"hasValidationErrors\":false,\"statusAttributeString\":null},\"lineItems\":[],\"date\":null,\"dueDate\":null,\"invoiceNumber\":null,\"reference\":null,\"brandingThemeID\":null,\"url\":null,\"currencyRate\":null,\"sentToContact\":null,\"expectedPaymentDate\":null,\"plannedPaymentDate\":null,\"cisDeduction\":null,\"cisRate\":null,\"subTotal\":null,\"totalTax\":null,\"total\":null,\"totalDiscount\":null,\"invoiceID\":\"5ba40d16-da3f-4c80-b4b6-f913f5cb3411\",\"repeatingInvoiceID\":null,\"hasAttachments\":null,\"isDiscounted\":false,\"payments\":[],\"prepayments\":[],\"overpayments\":[],\"amountDue\":null,\"amountPaid\":null,\"fullyPaidOnDate\":null,\"amountCredited\":null,\"updatedDateUTC\":null,\"creditNotes\":[],\"attachments\":null,\"hasErrors\":false,\"statusAttributeString\":null,\"validationErrors\":null,\"warnings\":null},\"creditNote\":null,\"prepayment\":null,\"overpayment\":null,\"invoiceNumber\":null,\"creditNoteNumber\":null,\"account\":{\"type\":1,\"status\":1,\"bankAccountType\":1,\"currencyCode\":108,\"class\":1,\"systemAccount\":0,\"code\":\"090\",\"name\":\"Business Bank Account\",\"accountID\":\"ac993f75-035b-433c-82e0-7b7a2d40802c\",\"bankAccountNumber\":\"1201020345678000\",\"description\":null,\"taxType\":\"NONE\",\"enablePaymentsToAccount\":false,\"showInExpenseClaims\":false,\"reportingCode\":\"ASS\",\"reportingCodeName\":\"Assets\",\"hasAttachments\":false,\"updatedDateUTC\":\"2023-11-24T09:51:19.577Z\",\"addToWatchlist\":false,\"validationErrors\":null},\"code\":\"test\",\"date\":\"2023-12-06T00:00:00\",\"currencyRate\":null,\"amount\":2500,\"bankAmount\":null,\"reference\":null,\"isReconciled\":null,\"updatedDateUTC\":null,\"paymentID\":\"58ee4f27-a66d-4856-a066-8e99defa74f7\",\"batchPaymentID\":null,\"bankAccountNumber\":\"12-1234-12345-01\",\"particulars\":null,\"details\":\"Remittance not sent\",\"hasAccount\":null,\"hasValidationErrors\":null,\"statusAttributeString\":null,\"validationErrors\":null}]},\"id\":3018,\"exception\":null,\"status\":5,\"isCanceled\":false,\"isCompleted\":true,\"isCompletedSuccessfully\":true,\"creationOptions\":0,\"asyncState\":null,\"isFaulted\":false},\"message\":\"Success\",\"isError\":false}" 
                //const testResult2 = JSON.parse(test2);
                //markAsPaidResult = testResult2;
                //debugger
                operations.onSendRemittanceAdvice(selectedInvoices, markAsPaidResult)
            }

            document.getElementById("btnPromptCancel").onclick = () => {
                document.getElementById("promptInfoDialog").ej2_instances[0].hide()
                document.getElementById("prompProgressDialog").ej2_instances[0].hide()
                document.getElementById("Grid").ej2_instances[0].hideSpinner()
            }
        }

        if (args.item.id == "ExportBatchPaymentReport") {
            let selectedInvoices = [];
            
            // Get grid data for merging
            const grid = document.getElementById("Grid").ej2_instances[0];
            const gridData = grid.dataSource || [];
            
            // Create a map of grid data by invoiceID for quick lookup
            const gridDataMap = {};
            gridData.forEach(function(row) {
                if (row.invoiceID) {
                    gridDataMap[row.invoiceID] = row;
                }
            });
            
            // Primary path: Use window.markAsPaidResult directly (populated during processInvoices)
            if (window.markAsPaidResult && window.markAsPaidResult.invoices && window.markAsPaidResult.invoices._Payments && window.markAsPaidResult.invoices._Payments.length > 0) {
                // Build selectedInvoices from markAsPaidResult payments - this has the authoritative contact data
                const payments = window.markAsPaidResult.invoices._Payments;
                
                // Build selectedInvoices from payments, using grid data for additional fields
                payments.forEach(function(payment) {
                    if (payment.invoice && payment.invoice.invoiceID) {
                        const invoiceID = payment.invoice.invoiceID;
                        const gridRow = gridDataMap[invoiceID];
                        const paymentContact = payment.invoice.contact;
                        
                        // Skip invoices with no bank details for report export
                        if (selectedInvoiceWithNoBankDetailsReportExport.some(i => i.invoiceId === invoiceID)) {
                            return;
                        }
                        
                        // Determine best contact source: payment contact first, fall back to grid row contact
                        var effectiveContact = null;
                        var effectiveContactName = '';
                        
                        if (paymentContact && paymentContact.contactID && paymentContact.name) {
                            // Use payment contact (authoritative from Xero API)
                            effectiveContact = paymentContact;
                            effectiveContactName = paymentContact.name;
                        } else if (gridRow && gridRow.contact && gridRow.contact.contactID && gridRow.contact.name) {
                            // Fallback to grid row contact
                            effectiveContact = gridRow.contact;
                            effectiveContactName = gridRow.contact.name;
                        } else if (gridRow && gridRow.contactName) {
                            // Last resort: use grid contactName and build minimal contact
                            effectiveContact = { 
                                contactID: gridRow.contact ? gridRow.contact.contactID : null, 
                                name: gridRow.contactName 
                            };
                            effectiveContactName = gridRow.contactName;
                        }
                        
                        // Skip if still no valid contact
                        if (!effectiveContact || !effectiveContactName) {
                            console.warn('Skipping invoice with missing contact for report:', invoiceID);
                            return;
                        }
                        
                        // Build complete invoice object using grid data as primary source, payment as fallback
                        var invoiceData = {
                            invoiceID: invoiceID,
                            contact: effectiveContact,
                            contactName: effectiveContactName,
                            hasEmailAddress: gridRow ? gridRow.hasEmailAddress : false,
                            emailAddress: gridRow ? gridRow.emailAddress : (paymentContact ? paymentContact.emailAddress : '') || '',
                            invoiceNumber: gridRow ? gridRow.invoiceNumber : (payment.invoice.invoiceNumber || ''),
                            reference: gridRow ? gridRow.reference : (payment.invoice.reference || ''),
                            amountDue: gridRow ? gridRow.amountDue : (payment.invoice.amountDue || 0),
                            amountPaid: gridRow ? gridRow.amountPaid : (payment.amount || 0),
                            amountDueEditable: gridRow ? gridRow.amountDueEditable : (payment.amount || 0),
                            amountCredited: gridRow ? gridRow.amountCredited : 0,
                            Total: gridRow ? gridRow.Total : (payment.invoice.total || 0),
                            date: gridRow ? gridRow.date : null,
                            dueDate: gridRow ? gridRow.dueDate : null,
                            status: 'Paid'
                        };
                        
                        selectedInvoices.push(invoiceData);
                    }
                });
            } else {
                // Fallback: try grid selected records
                selectedInvoices = this.getSelectedRecords();
            }
            
            // Check if there are no records
            if (selectedInvoices.length === 0) {
                var message = "* Unable to process the request. No records found. <br/><br/>"
                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()

                return
            }

            let groupdInvoices = selectedInvoices.reduce((group, inv) => {

                let key = inv.contact.name;
                if (key != null) {
                    if (!group[key]) {
                        group[key] = [];
                    }
                    group[key].push(inv);
                    return group
                }
            }, {});

            operations.ExportBatchPaymentReport(groupdInvoices, window.markAsPaidResult);
            //operations.ExportBatchPaymentReportCSV(selectedInvoices, window.markAsPaidResult);
            //operations.onGetBills();
        }
        if (args.item.id === "ResendRemittances") {
            resendRemittances.openModal();
        }
        if (args.item.id === "ReRunReport") {
            reRunReport.openModal();
        }
        if (args.item.id === "Refresh") {

            if (window.disabledGridEditing)
                return

            window.location = "/Home/Index/"

        }
        if (args.item.id === "SortColumns") {
            document.getElementById("sort_dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("sort_dialog").style.borderTopRightRadius = "10px";
            document.getElementById("sort_dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("sort_dialog").style.borderBottomRightRadius = "10px";
            var gridSorting = document.getElementById("GridSorting").ej2_instances[0]
            //var dataGrid =  gridSorting.dataSource
            document.getElementById("sort_dialog").style.maxHeight = ""
            var dlgHeader = document.getElementById("sort_dialog_dialog-header")
            var dlgContent = document.getElementById("sort_dialog_dialog-content")

            dlgHeader.classList.add("prompt-dlg-header-template")
            dlgContent.classList.add("dlg-content-template")
            //var dialogSort = document.getElementById("modal_dialog").ej2_instances[0]
            dialogObj.cssClass = 'e-fixed';
            dialogObj.show()
        }
        if (args.item.id === "ClearSortColumns") {
            var gridSorting = document.getElementById("GridSorting").ej2_instances[0]
            //gridSorting.dataSource = []
            var grid = document.getElementById("Grid").ej2_instances[0]
            grid.clearSorting();
            OrderNoSelected = [];
            ColumnNameSelected = [];
        }
        if (args.item.id === 'ExportToBacs') {

            var isinsertRecordDB;
            var dialogAfterExport;
            var promptDialogABA;
            var dialogViewErrorList;
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderTopRightRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptInfoDialogTransactionDate").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialog").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialog").style.borderBottomRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderTopRightRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomLeftRadius = "10px";
            document.getElementById("promptDialogABA").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderTopRightRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogAfterExport").style.borderBottomRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderTopRightRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialogViewErrorList").style.borderBottomRightRadius = "10px";
            document.getElementById("dialog").style.borderTopLeftRadius = "10px";
            document.getElementById("dialog").style.borderTopRightRadius = "10px";
            document.getElementById("dialog").style.borderBottomLeftRadius = "10px";
            document.getElementById("dialog").style.borderBottomRightRadius = "10px";
            document.getElementById("progressStatus").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
            document.getElementById("progressStatus2s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
            document.getElementById("progressStatus3s").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";
            /*            document.getElementById("progressStatus").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting export date...</span>";*/
            document.getElementById("spinner").style.visibility = "visible";
            document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
            //document.getElementById("authorityNo").style.visibility = "hidden";
            //document.getElementById("authorityNo").style.display = "none";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("apcaId").innerHTML = '';
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("bankOption").style.visibility = "hidden";
            document.getElementById("bankOption").style.display = "none";
            const btnPromptOkayTransactionDateEnable = document.getElementById("btnPromptOkayTransactionDate");
            btnPromptOkayTransactionDateEnable.disabled = true;
            var count = 0;
            var intervalExport = setInterval(function () {
                btnPromptOkayTransactionDate2
                if (count <= 25) {
                    document.getElementById('Prog').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                } else {
                    document.getElementById("spinner").style.visibility = "hidden";
                    document.getElementById("btnPromptOkayTransactionDate").style.visibility = "visible";
                    btnPromptOkayTransactionDateEnable.disabled = false;
                    clearInterval(intervalExport);
                    return;
                }
                count += 1;
            }, 100);

            var grid = document.getElementById("Grid").ej2_instances[0]
            var dateTransaction = document.getElementById("dateTransaction").ej2_instances[0]
            grid.showSpinner()

            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
            // Filter existing selection to get only those records with orgID equal to subscriptionID
            const filteredExistingSelection = existingSelection.filter(record => record.orgId === window.subscriptionID);
            // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
            const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
            // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
            const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

            let selectedInvoices

            if (filteredNewDataRecord.length === 0) {
                selectedInvoices = this.getSelectedRecords();
                isinsertRecordDB = "0";
            } else {
                selectedInvoices = filteredNewDataRecord
                checkContactHasMoreThanOneInvoice(selectedInvoices);
                isinsertRecordDB = "1";
            }

            if (selectedInvoices.length === 0) {
                var message = "";

                if (selectedInvoices.length === 0) {
                    message += "* Please select bills to export. <br/><br/>"
                }

                var dialog = document.getElementById("dialog").ej2_instances[0]
                document.getElementById("message").innerHTML = message

                var dlgHeader = document.getElementById("dialog_dialog-header")
                var dlgContent = document.getElementById("dialog_dialog-content")

                dlgHeader.classList.add("error-dlg-header-template")
                dlgContent.classList.add("dlg-content-template")

                dialog.show()
                grid.hideSpinner()
            } else {

                promptTransactionDate();
                $("#promptInfoDialogTransactionDate_title .e-icon-settings").text("Export BatchPay File");
                document.getElementById("btnPromptOkayTransactionDate").onclick = () => {


                    if (dateTransaction.value === null)
                        return


                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    dialog.hide()

                    var promptDialog = document.getElementById("promptDialog").ej2_instances[0]
                    document.getElementById("prompt").innerHTML = `Please confirm you’d like to proceed updating ${selectedInvoices.length} bills in Xero to populate bank account in BACS file`

                    var dlgHeader = document.getElementById("promptDialog_dialog-header")
                    dlgHeader.classList.add("prompt-dlg-header-template")

                    var dlgContent = document.getElementById("promptDialog_dialog-content")
                    dlgContent.classList.add("dlg-content-template")

                    txtBacsServiceUserNo = ""
                    txtNarrativeUserChoice = ""
                    txtBatchReferenceNo = ""
                    chksumInvoicesPerContact = true
                    document.getElementById("txtBatchReferenceNo").value = ""
                   // document.getElementById("txtNarrativeUserChoice").value = ""
                    document.getElementById("txtBacsServiceUserNo").value = ""
                    //var checkboxInstance = document.getElementById("sumInvoicesPerContact").ej2_instances[0];
                    //checkboxInstance.checked = true;
                    //document.getElementById("txtBatchReferenceNo").style.display = "none";
                    //document.getElementById("messageBatchReferenceNo").style.display = "none";
                    //document.getElementById("errorContentBatchReferenceNo").innerHTML = ''
                    //document.getElementById("messageAuthorityNumber").style.display = "none";
                    //document.getElementById("messageAuthorityNumber").innerHTML = '';
                      document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtCompanyId").style.display = "none";
                    document.getElementById("txtCompanyIdContainer").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").style.display = "none";
                    document.getElementById("txtLodgementReferenceTo").value = "";
                    document.getElementById("txtLodgementReferenceFrom").style.display = "none";
                    document.getElementById("txtLodgementReferenceFrom").value = "";
                    document.getElementById("messageLodgementFrom").style.display = "none";
                    document.getElementById("messageLodgementFrom").value = "";
                    document.getElementById("txtParticulars").style.display = "none";
                    document.getElementById("txtParticulars").value = "";
                    document.getElementById("btnInfoFrom").style.visibility = "hidden";
                    document.getElementById("btnInfoTo").style.visibility = "hidden";
                    document.getElementById("btnInfoParticulars").style.visibility = "hidden";
                    var bankDropDown = document.getElementById("bankAccountTypesDropDown").ej2_instances[0]

                    document.getElementById("errorContentBank").innerHTML = ''
                    promptDialog.show()
                    document.getElementById("progressStatuss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                    document.getElementById("progressStatus2").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                    document.getElementById("progressStatus3ss").innerHTML = "<span style='background: #fff;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #c2c5c7;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

         /*           document.getElementById("progressStatus2").innerHTML = "<span style='color:green;'><b>Status:</b>  Selecting Bank Account...</span>";*/

                    document.getElementById("spinner1").style.visibility = "visible";
                    document.getElementById("btnOkay").style.visibility = "visible";
                    document.getElementById("btnBacs").style.visibility = "visible";
                    document.getElementById("btnUserChoice").style.visibility = "visible";
                    const btnPromptOkayTransactionDateEnable = document.getElementById("btnOkay");
                    btnPromptOkayTransactionDateEnable.disabled = true;

                    document.getElementById("btnOkay").style.display = "none";
                    document.getElementById("messageBank").style.display = "none";
                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'none');
                    var count = 25;
                    var intervalBank = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('Prog2').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('Prog2s').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(intervalBank);
                            return;
                        }
                        count += 1;
                    }, 100);


                    $.ajax({
                        url: API_ENDPOINTS.GET_BANK_ACCOUNT_TYPES,
                        type: 'GET',
                        headers: {
                            'Accept': 'application/json; charset=utf-8'
                        },
                        success: (result) => {
                            if (result.isError) {
                                operations.errorHandling(result)
                                return
                            }
                            else {

                                if (result.bankAccounts.length > 0) {
                                    document.getElementById("spinner1").style.visibility = "hidden";
                                    btnPromptOkayTransactionDateEnable.disabled = false;
                                    document.getElementById("btnOkay").style.display = "initial";
                                    document.getElementById("messageBank").style.display = "initial";
                                    $("span[aria-owns='bankAccountTypesDropDown_options']").css('display', 'flex');
                                    document.getElementById("btnOkay").style.visibility = "visible";
                                    document.getElementById("messageBank").style.visibility = "visible";

                                    //if (showLodgementReference) {
                                    //    document.getElementById("txtLodgementReferenceTo").style.display = "initial";
                                    //    document.getElementById("txtLodgementReferenceTo").style.visibility = "visible";
                                    //}

                                    $("span[aria-owns='bankAccountTypesDropDown_options']").show();
                                    bankDropDown.dataSource = result.bankAccounts
                                }
                                else
                                    document.getElementById("errorContentBank").innerHTML = 'No bank account'
                            }
                        },
                        error: (error) => {
                            document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
                        }
                    })

                    document.getElementById("btnOkay").onclick = function (e) {
                        document.getElementById("spinner1").style.visibility = "visible";
                        if (bankAccount === null || bankAccount.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountName == null || bankAccountName.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'No bank account name'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else if (bankAccountCode === null || bankAccountCode.length === 0) {
                            document.getElementById("messageBank").style.display = "block";
                            document.getElementById("messageBank").innerHTML = 'Missing Chart of Accounts code for Bank Account in Xero. Please see <a href="https://support.batchpay.com.au/portal/en/kb/articles/missing-chart-of-accounts-code-for-bank-account" target="_blank">KB</a> article.'
                            document.getElementById("spinner1").style.visibility = "hidden";
                            return
                        } else {
                            document.getElementById("messageBank").style.display = "none";
                            document.getElementById("messageBank").innerHTML = ''
                        }

                        txtBatchReferenceNo = document.getElementById("txtBatchReferenceNo").value

                        //if (txtBatchReferenceNo == null || txtBatchReferenceNo == "") {
                        //    document.getElementById("messageBatchReferenceNo").style.display = "block";
                        //    document.getElementById("messageBatchReferenceNo").innerHTML = 'No batch reference no'
                        //    return
                        //} else {
                        //    document.getElementById("messageBatchReferenceNo").style.display = "none";
                        //    document.getElementById("messageBatchReferenceNo").innerHTML = ''
                        //}


                        txtBacsServiceUserNo = document.getElementById("txtBacsServiceUserNo").value

                        //if (txtBacsServiceUserNo == null || txtBacsServiceUserNo == "") {
                        //    document.getElementById("messageBacsServiceUserNo").style.display = "block";
                        //    document.getElementById("messageBacsServiceUserNo").innerHTML = 'No bacs service user no'
                        //    return
                        //} else {
                        //    document.getElementById("messageBacsServiceUserNo").style.display = "none";
                        //    document.getElementById("messageBacsServiceUserNo").innerHTML = ''
                        //}

                        //txtNarrativeUserChoice = document.getElementById("txtNarrativeUserChoice").value

                        //if (txtNarrativeUserChoice == null || txtNarrativeUserChoice == "") {
                        //    document.getElementById("messageNarrativeUserChoice").style.display = "block";
                        //    document.getElementById("messageNarrativeUserChoice").innerHTML = 'No bacs service user no'
                        //    return
                        //} else {
                        //    document.getElementById("messageNarrativeUserChoice").style.display = "none";
                        //    document.getElementById("messageNarrativeUserChoice").innerHTML = ''
                        //}

                        //var checkboxInstance = document.getElementById("sumInvoicesPerContact").ej2_instances[0];
                        //chksumInvoicesPerContact = checkboxInstance.checked;

                        //document.getElementById("messageBank").style.display = "block";
                        //document.getElementById("messageBank").innerHTML = 'No bank account code'
                        //if (bankAccount === null || bankAccountName == null || bankAccount.length === 0 || bankAccountName.length === 0)
                        //    return

                       // var dialogProgress1 = document.getElementById("prompProgressDialog").ej2_instances[0]

                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                        dlgHeader.classList.add("prompt-dlg-header-template")
                        dlgContent.classList.add("dlg-content-template")

                        //dialogProgress1.show()

                        document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                        //var count = 50;
                        //var exportIntervalStart = setInterval(function () {

                        //    if (count <= 65) {
                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                        //    } else {
                        //        clearInterval(exportIntervalStart);
                        //        return;
                        //    }
                        //    count += 1;
                        //}, 100);

                        let errorCount = 0;
                        //promptDialog.hide()

                        //selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID))
                        isFormatChecking = true;
                        //var BatchReferenceNo = document.getElementById("txtBatchReferenceNo").value
                        let exportToABA = {
                            bankAccountNumber: bankAccount,
                            bankAccountName: bankAccountName,
                            bankAccountCode: bankAccountCode,
                            bankAccountID: bankAccountID,
                            errorCount: errorCount,
                            invoices: selectedInvoices,
                            isinsertRecordDB: isinsertRecordDB,
                            TransactionDate: formatDate(dateTransaction.value),
                            hasLodgementReference: showLodgementReference,
                            BatchReferenceNo: txtBatchReferenceNo,
                            BacsServiceUserNo: txtBacsServiceUserNo,
                            NarrativeUserChoice: txtNarrativeUserChoice,
                            sumInvoicesPerContact: chksumInvoicesPerContact
                        }
                        if (CheckIfConnectedToXero()) {
                            fetch(API_ENDPOINTS.EXPORT_ABA_FORMAT_CHECK, {
                                body: JSON.stringify(exportToABA),
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8'
                                },
                            }).then(response => response.json())
                                .then(response => {
                                    if (response.result == false) {
                                        var dialog = document.getElementById("promptDialogABA").ej2_instances[0]
                                        document.getElementById("promptDialogABA").style.maxHeight = ""
                                        if (response.error.length > 0)
                                            selectedInvoiceWithNoBankDetails = response.error

                                        var fileFormat = "ABA";
                                        var titleFormat = "";

                                        switch (countryCode) {
                                            case 'NZ':
                                                fileFormat = "a CSV";
                                                titleFormat = "CSV"
                                                break;
                                            case 'AU':
                                                fileFormat = "an ABA";
                                                titleFormat = "ABA"
                                                break;
                                            case 'GB':
                                                fileFormat = "a BACS";
                                                titleFormat = "BACS"
                                                break;
                                        }

                                        var errorlist = "";
                                        document.getElementById("errorlist").innerHTML = "";
                                        let list = document.getElementById("errorlist");
                                        for (let i = 0; i < response.error.length; i++) {
                                            //errorlist += response.error[i].error + "\n";
                                            //errorCount++;
                                            let li = document.createElement('li');
                                            li.innerText = response.error[i].error;
                                            list.appendChild(li);
                                        }

                                        errorCount = response.countIssue
                                        document.getElementById("fileFormat").innerHTML = titleFormat;
                                        document.getElementById("prompt").innerHTML = "You are about to generate a BatchPay file containing " + response.countInvoice + " bills. The file however contains " + response.countIssue + " errors.";
                                        var dlgHeader = document.getElementById("promptDialogABA_dialog-header")
                                        var dlgContent = document.getElementById("promptDialogABA_dialog-content")

                                        dlgHeader.classList.add("error-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")



                                        //dialogProgress1.hide()
                                        document.getElementById("btnShowIssues").style.visibility = "hidden";
                                        document.getElementById("btnABAOkay").style.visibility = "visible";
                                        document.getElementById("spinnerError").style.visibility = "visible";
                                        const btnABAOkayEnabled = document.getElementById("btnABAOkay");
                                        btnABAOkayEnabled.disabled = true;

                                        dialog.show()

                                        var count = 65;
                                        var exportIntervalEnd = setInterval(function () {

                                            if (count <= 75) {
                                                document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                            } else {

                                                document.getElementById("btnShowIssues").style.visibility = "visible";

                                                var countResponseWithNoBankDetails = response.error.filter(i => i.hasBankDetails == false).length;
                                                if (selectedInvoices.length === countResponseWithNoBankDetails) {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = true;
                                                } else {
                                                    document.getElementById("spinnerError").style.visibility = "hidden";
                                                    document.getElementById("btnABAOkay").style.display = "initial";
                                                    document.getElementById("btnABAOkay").style.visibility = "visible";
                                                    btnABAOkayEnabled.disabled = false;

                                                }

                                                clearInterval(exportIntervalEnd);
                                                return;
                                            }
                                            count += 1;
                                        }, 100);
                                        document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                        document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay from</div>";
                                        document.getElementById("progressStatus3").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";


                                        var buttonElement = document.getElementById("btnABAOkay");
                                        if (buttonElement) {
                                            buttonElement.textContent = "Export BatchPay File";
                                        }
                                 /*       document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to BACS...</span>";*/

                                        grid.hideSpinner()
                                        promptDialog.hide()


                                        document.getElementById("btnABAOkay").onclick = function (e) {
                                            document.getElementById("spinnerError").style.visibility = "visible";
                                            document.getElementById("btnABAOkay").setAttribute("disabled", true);
                                            document.getElementById("btnShowIssues").setAttribute("disabled", true);
                                            var count = 75;
                                            var exportToAbbaInterval = setInterval(function () {

                                                if (count <= 100) {
                                                    document.getElementById('Prog3').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                                } else {
                                                    document.getElementById("btnABAOkay").removeAttribute("disabled");
                                                    document.getElementById("btnShowIssues").removeAttribute("disabled");
                                                    clearInterval(exportToAbbaInterval);
                                                    return;
                                                }
                                                count += 1;
                                            }, 200);
                                            document.getElementById("progressStatusss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Select date</div>";
                                            document.getElementById("progressStatus2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -10px;white-space: normal;width: 90px;'>Pay From</div>";
                                            document.getElementById("progressStatus3").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -40px;white-space: normal;width: 90px;text-align: center;'>Export BatchPay File</div>";

                                            //document.getElementById("progressStatus3").innerHTML = "<span style='color:green;'><b>Status:</b>  Exporting data to BACS...</span>";

                                            selectedInvoices = selectedInvoices.filter(o => !selectedInvoiceWithNoBankDetails.some(i => i.invoiceId === o.invoiceID && i.hasBankDetails == false))   

                                            let exportToABA2 = {
                                                bankAccountNumber: bankAccount,
                                                bankAccountName: bankAccountName,
                                                bankAccountCode: bankAccountCode,
                                                bankAccountID: bankAccountID,
                                                errorCount: errorCount,
                                                invoices: selectedInvoices,
                                                isinsertRecordDB: isinsertRecordDB,
                                                TransactionDate: formatDate(dateTransaction.value),
                                                hasLodgementReference: showLodgementReference,
                                                BatchReferenceNo: txtBatchReferenceNo,
                                                BacsServiceUserNo: txtBacsServiceUserNo,
                                                NarrativeUserChoice: txtNarrativeUserChoice,
                                                sumInvoicesPerContact: chksumInvoicesPerContact
                                            }

                                            fetch(API_ENDPOINTS.EXPORT_BACS, {
                                                body: JSON.stringify(exportToABA2),
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json; charset=utf-8'
                                                },
                                            }).then(response => response.blob())
                                                .then(response => {
                                                    document.getElementById("spinner1").style.visibility = "hidden";
                                                    const blob = new Blob([response], { type: 'text/plain' })
                                                    const downloadUrl = URL.createObjectURL(blob)
                                                    const a = document.createElement("a")
                                                    a.href = downloadUrl
                                                    a.download = "batch_payments_export.BAC"
                                                    document.body.appendChild(a)
                                                    dialog.hide()
                                                    grid.hideSpinner()
                                                    a.click()
                                                    window.disabledGridEditing = false
                                                    var messageAfterExport = "";
                                                    messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                    dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                    document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                    var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                    var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                    dlgHeader.classList.add("prompt-dlg-header-template")
                                                    dlgContent.classList.add("dlg-content-template")
                                                    promptDialog.hide()
                                                    dialogAfterExport.show()
                                                    grid.hideSpinner()

                                                    //document.getElementById("step1").ej2_instances[0].disabled = true
                                                })

                                        }
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialog.hide()
                                            dialogAfterExport.hide()
                                        }
                                        document.getElementById("btnABACancel").onclick = function (e) {
                                            dialog.hide()
                                            grid.hideSpinner()
                                        }

                                        document.getElementById("btnShowIssues").onclick = function (e) {

                                            //var blob = new Blob([errorlist], { type: "text/plain;charset=utf-8" });
                                            //const downloadUrl = URL.createObjectURL(blob)
                                            //const a = document.createElement("a")
                                            //a.href = downloadUrl
                                            //a.download = "errors_batch_payments_export.aba"
                                            //document.body.appendChild(a)
                                            //a.click()
                                            //grid.hideSpinner()
                                            dialogViewErrorList = document.getElementById("dialogViewErrorList").ej2_instances[0]
                                            //document.getElementById("errorlist").innerHTML = errorlist
                                            var x = errorlist;
                                            //let list = document.getElementById("errorlist");

                                            //for (i = 0; i < errorlist.length; ++i) {
                                            //    let li = document.createElement('li');
                                            //    li.innerText = errorlist[i];
                                            //    list.appendChild(li);
                                            //}

                                            var dlgHeader = document.getElementById("dialogViewErrorList_dialog-header")
                                            var dlgContent = document.getElementById("dialogViewErrorList_dialog-content")

                                            dlgHeader.classList.add("error-dlg-header-template")
                                            dlgContent.classList.add("dlg-content-template")

                                            dialogViewErrorList.show()


                                        }
                                        document.getElementById("btnViewErrorList").onclick = function (e) {
                                            dialogViewErrorList.hide()
                                            //dialog.hide()
                                        }

                                    } else if (response.result == true) {
                                        document.getElementById("spinner1").style.visibility = "hidden";
                                        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]

                                        var dlgHeader = document.getElementById("prompProgressDialog_dialog-header")
                                        var dlgContent = document.getElementById("prompProgressDialog_dialog-content")

                                        dlgHeader.classList.add("prompt-dlg-header-template")
                                        dlgContent.classList.add("dlg-content-template")

                                        //dialogProgress.show()

                                        //document.getElementById("progressStatusOnly").innerHTML = "<span style='color:green;'><b>Status:</b>  Bank Account Selected...</span>";

                                        //var count = 65;
                                        //var exportToAbbaInterval = setInterval(function () {

                                        //    if (count <= 100) {
                                        //        document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%">' + count + '%</div>';
                                        //    } else {
                                        //        clearInterval(exportToAbbaInterval);
                                        //        return;
                                        //    }
                                        //    count += 1;
                                        //}, 100);

                                        fetch(API_ENDPOINTS.EXPORT_BACS, {
                                            body: JSON.stringify(exportToABA),
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json; charset=utf-8'
                                            },
                                        }).then(response => response.blob())
                                            .then(response => {
                                                document.getElementById("spinner1").style.visibility = "hidden";
                                                const blob = new Blob([response], { type: 'text/plain' })
                                                const downloadUrl = URL.createObjectURL(blob)
                                                const a = document.createElement("a")
                                                a.href = downloadUrl
                                                a.download = "batch_payments_export.BAC"
                                                document.body.appendChild(a)
                                                a.click()
                                                grid.hideSpinner()
                                                dialogProgress.hide()
                                                window.disabledGridEditing = false
                                                var messageAfterExport = "";
                                                messageAfterExport += "Please ensure the BatchPay file can be successfully imported in your banking application or portal, and then proceed to 'Mark as Paid'"

                                                dialogAfterExport = document.getElementById("dialogAfterExport").ej2_instances[0]
                                                document.getElementById("messageAfterExport").innerHTML = messageAfterExport
                                                var dlgHeader = document.getElementById("dialogAfterExport_dialog-header")
                                                var dlgContent = document.getElementById("dialogAfterExport_dialog-content")

                                                dlgHeader.classList.add("prompt-dlg-header-template")
                                                dlgContent.classList.add("dlg-content-template")
                                                promptDialog.hide()
                                                dialogAfterExport.show()
                                                grid.hideSpinner()
                                                //document.getElementById("step1").ej2_instances[0].disabled = true
                                            })
                                        document.getElementById("btnPromptOkayContainerAfterExport").onclick = function (e) {
                                            dialogAfterExport.hide()
                                        }

                                    }



                                })
                        }
                        else {
                            tenantNotConnected()
                            dialogProgress.hide()
                        }
                    }
                    document.getElementById("btnCancel").onclick = function (e) {
                        promptDialog.hide()
                        grid.hideSpinner()
                    }
                }
                document.getElementById("btnPromptCancelTransactionDate").onclick = () => {
                    var dialog = document.getElementById("promptInfoDialogTransactionDate").ej2_instances[0]
                    grid.hideSpinner()
                    dialog.hide()
                }
            }
        }
    },
    onFilterBillByDate: function (args) {
        let status = document.getElementById("billsStatusFilterDropDown").ej2_instances[0]

        var grid = document.getElementById("Grid").ej2_instances[0]
        grid.showSpinner()

        let payload = {
            status: status.itemData,
            startDate: new Date(args.startDate),
            endDate: new Date(args.endDate)
        }

        if (CheckIfConnectedToXero()) {
            var ajax = new ej.base.Ajax({
                url: API_ENDPOINTS.FILTER_BILLS,
                type: 'POST',
                data: JSON.stringify(payload),
                contentType: 'application/json',
                accept: 'application/json'
            })
            ajax.send()
            ajax.onSuccess = function (data) {
                console.log(data)
                var obj = JSON.parse(data)
                if (obj.isError) {
                    operations.errorHandling(obj)
                    return
                }
                grid.dataSource = obj.invoices
                grid.hideSpinner()
            }
        }
        else
            tenantNotConnected()

    },
    onGridLoad: function (args) {
        if (flag) {
            flag = false;
            updateTemplate();
            document.getElementById("Grid").ej2_instances[0].toolbarModule.element.overflowMode = 'MultiRow'
            // grid.toolbarModule.element.ej2_instances[0].overflowMode = 'MultiRow'; 
        }
   
        if (this.getSelectedRecords().length <= 0) {

            var textBtnIddiv = document.getElementById("defaultTextBtnId")
            document.getElementById("selectbillsId").style.display = "none"
            document.getElementById("defaultTextBtnId").style.display = "block"
        }

    },
    extractJson: function (str) {
        var firstOpen, firstClose, candidate;
        firstOpen = str.indexOf('{', firstOpen + 1);
        do {
            firstClose = str.lastIndexOf('}');
            if (firstClose <= firstOpen) {
                return null;
            }
            do {
                candidate = str.substring(firstOpen, firstClose + 1);
                try {
                    return JSON.parse(candidate);
                    //return [res, firstOpen, firstClose + 1];
                }
                catch (e) {
                    console.log('...failed');
                }
                firstClose = str.substr(0, firstClose).lastIndexOf('}');
            } while (firstClose > firstOpen);
            firstOpen = str.indexOf('{', firstOpen + 1);
        } while (firstOpen != -1);
    },
    errorFormat: function (errors) {
        var dialog = document.getElementById("errorDialog").ej2_instances[0]
        var errorContent = document.getElementById("errorContent")
        var dlgHeader = document.getElementById("errorDialog_dialog-header")
        var dlgContent = document.getElementById("errorDialog_dialog-content")

        if (errorContent.hasChildNodes()) {
            while (errorContent.firstChild) {
                errorContent.removeChild(errorContent.firstChild)
            }
        }

        dlgHeader.classList.add("error-dlg-header-template")
        dlgContent.classList.add("dlg-content-template")

        errors.errorDetail.forEach((error, index) => {
            let header = document.createElement("h4")
            let ul = document.createElement("ul")

            header.innerText = error.invoiceNumber == "" ? "<No-Invoice-Number>" : error.invoiceNumber
            error.errors.forEach((msg) => {
                let li = document.createElement("li")
                li.innerText = msg.Message
                ul.append(li)
            })

            errorContent.append(header, ul)
        })

        document.getElementById("btnCloseErrorDialog").onclick = function (e) {
            dialog.hide()
            grid.hideSpinner()
        }
        dialog.show()
    },
    onModalLoad: function () {
        dialogObj = this
        dialogObj.hide()
    },
    onRowDeselecting: function (args) {
        if (window.disabledGridEditing)
            args.cancel = true


        if (this.getSelectedRecords().length <= 0) {
            document.getElementById("step2").ej2_instances[0].disabled = false
            var textBtnIddiv = document.getElementById("defaultTextBtnId")
            document.getElementById("selectbillsId").style.display = "none"
            document.getElementById("defaultTextBtnId").style.display = "block"

        }

    },
    onBeginEdit: function (args) {
        if (window.disabledGridEditing)
            args.cancel = true
    },
    
    onSelectBills: function (args) {

        //var selectedRecords1 = this.getSelectedRecords();
        //var filteredSelection = selectedRecords1.filter(function (item) {
        //    return item.orgId === window.subscriptionID;
        //});
        var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
        var splitCode = getSubscriptionIDFromExpireOrganization(expireOrganization);
        var selectedRecords = []

        //console.log("filterBill data",window.newDataRecord)

        //// Convert existingSelection to a Map for quick lookups
        //const existingSelectionMap = new Map(existingSelection.map(record => [
        //    record.invoiceID + ":" + record.orgID, // Key is a combination of invoiceID and orgID
        //    true // Value can be true or anything to indicate existence
        //]));
        //// Filter window.newDataRecord based on existingSelection
        //const filteredNewDataRecord = window.newDataRecord.filter(record => {
        //    // Create the key for the current record
        //    const key = record.invoiceID + ":" + record.orgID;
        //    // Check if the key exists in the Map
        //    return existingSelectionMap.has(key);
        //});

        if (args.target != null) {
            var selectedRows = [];

            if (window.disabledGridEditing) {
                args.cancel = true;
            }
            console.log("orignal Record", window.newDataRecord);
            // Check if any rows are selected
            if (args.data && Array.isArray(args.data)) {
                // Add all selected rows to the existing selection
                // Multiple rows are selected
                args.data.forEach(row => {
                    if (row.invoiceID) {
                        // Push objects containing invoiceID into selectedRows
                        selectedRows.push({
                            invoiceID: row.invoiceID,
                            // Add other properties if necessary
                        });
                    }
                });
            } else if (args.rowIndex !== undefined) {
                // Single row is selected
                var gridInstance = document.getElementById('Grid').ej2_instances[0];
                var selectedData = gridInstance.getRowObjectFromUID(gridInstance.getRowByIndex(args.rowIndex).getAttribute('data-uid')).data;
                var InvoiceId = selectedData.invoiceID
                // Add the single selected row to the existing selection

                selectedRows.push({
                    invoiceID: InvoiceId,
                });
            }

            // Log the selectedRows to the console for debugging
            console.log(selectedRows);
            if (expireOrganization.length > 0) {

                var content = expireOrganization;
                var dataArray = content.split(",");
                //console.log(dataArray);
                //console.log(dataArray.join("\n"));
                dataArray.forEach(myFunction)
                function myFunction(item, index) {
                    var splitCode = item.split(":");
                    window.subscriptionID = splitCode[2];
                }

            }
            selectedRows.forEach(row => {
                row.orgId = window.subscriptionID; // Add new column with default value
            });

            // Save the updated selection to localStorage
            if (selectedRows.length > 0) {
                // Retrieve existing selection from localStorage (if any)
                var existingSelection = gridSelectionGetSelection(window.subscriptionID)

                // Add the newly selected rows to the existing selection
                existingSelection = existingSelection.concat(selectedRows);

                // Save the updated selection to localStorage
                window.gridSelection.saveSelection(existingSelection);
            }
        }

        // Filter existing selection to get only those records with orgID equal to subscriptionID
        const filteredExistingSelection = existingSelection.filter(record => record.orgId === splitCode);
        // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
        const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
        // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
        const filteredNewDataRecord = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));

        if (args.target != null) {
            selectedRecords = filteredNewDataRecord
        }
        else {

            if (existingSelection.length > 0) {
                selectedRecords = filteredNewDataRecord
                selectedPageSize = existingSelection.length;
            }
            else {
                selectedRecords = this.getSelectedRecords();
            }
        }


        //var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
        //var selectedRecords = this.getSelectedRecords();
        if (selectedRecords.length > 0) {
            document.getElementById("selectbillsId").style.display = "block";
            document.getElementById("defaultTextBtnId").style.display = "none";
        }

        if (args.isHeaderCheckboxClicked === true && args.data.length > 0 && args.isInteracted) {
            // Handle select all
            count = selectedRecords.length;
            document.getElementById("selectedBills").innerHTML = count;
            total = 0;

            selectedRecords.forEach((item) => {
                total += item.amountDueEditable;
            });
            if (countryCode == "GB") {
                document.getElementById("total").innerHTML = "£" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            else {
                document.getElementById("total").innerHTML = "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
           
        } else if (args.isHeaderCheckboxClicked === false && args.isInteracted) {
            // Handle deselect all
            count = selectedRecords.length;
            document.getElementById("selectedBills").innerHTML = count;
            total = 0;

            selectedRecords.forEach((item) => {
                total += item.amountDueEditable;
            });

            if (countryCode == "GB") {
                document.getElementById("total").innerHTML = "£" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            else {
                document.getElementById("total").innerHTML = "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
         else if (args.isHeaderCheckboxClicked === false && args.isInteracted == false) {
            // Handle deselect all
            count = selectedRecords.length;
            document.getElementById("selectedBills").innerHTML = count;
            total = 0;

            selectedRecords.forEach((item) => {
                total += item.amountDueEditable;
            });

            if (countryCode == "GB") {
                document.getElementById("total").innerHTML = "£" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            else {
                document.getElementById("total").innerHTML = "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
        

    },
    onRowSelecting: function (args) {

        //var selectedRows = [];

        //if (window.disabledGridEditing) {
        //    args.cancel = true;
        //}

        //// Check if any rows are selected
        //if (args.data && Array.isArray(args.data)) {
        //    // Add all selected rows to the existing selection
        //    selectedRows = selectedRows.concat(args.data);
        //} else if (args.rowIndex !== undefined) {
        //    // Single row is selected
        //    var gridInstance = document.getElementById('Grid').ej2_instances[0];
        //    var selectedData = gridInstance.getRowObjectFromUID(gridInstance.getRowByIndex(args.rowIndex).getAttribute('data-uid')).data;

        //    // Add the single selected row to the existing selection
        //    selectedRows.push(selectedData);
        //}

        //// Log the selectedRows to the console for debugging
        ////console.log(selectedRows);
        //if (expireOrganization.length > 0) {

        //    var content = expireOrganization;
        //    var dataArray = content.split(",");
        //    //console.log(dataArray);
        //    //console.log(dataArray.join("\n"));
        //    dataArray.forEach(myFunction)
        //    function myFunction(item, index) {
        //        var splitCode = item.split(":");
        //        subscriptionID = splitCode[2];
        //    }

        //}
        //selectedRows.forEach(row => {
        //    row.orgId = subscriptionID; // Add new column with default value
        //});

        //// Save the updated selection to localStorage
        //if (selectedRows.length > 0) {
        //    // Retrieve existing selection from localStorage (if any)
        //    var existingSelection = gridSelectionGetSelection(subscriptionID)

        //    // Add the newly selected rows to the existing selection
        //    existingSelection = existingSelection.concat(selectedRows);

        //    // Save the updated selection to localStorage
        //    window.gridSelection.saveSelection(existingSelection);
        //}

    },
    onDeselectBills: function (args) {
    

        try {
            // Retrieve existing selection from localStorage (if any)
            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];

            var filteredSelection = existingSelection.filter(function (item) {
                return item.orgId === window.subscriptionID;
            });
            //localStorage.removeItem(STORAGE_KEYS.SELECTED_DATA);
            // Handle deselect all
            existingSelection.forEach(function (item) {
                if (item.orgId === window.subscriptionID) {
                    if (args.isHeaderCheckboxClicked === true && args.isInteracted) {
                        var filteredSelection = existingSelection.filter(function (item) {
                            return item.orgId !== window.subscriptionID;
                        });
                        existingSelection = filteredSelection;
                    } else {
                        // Find the index of the deselected row in the existing selection
                        var deselectedIndex = existingSelection.findIndex(function (item) {
                            // Customize this comparison based on your data structure and unique identifier
                            return item.invoiceID === args.data.invoiceID; // Replace "id" with your unique identifier property
                        });

                        // If the deselected row is found, remove it from the existing selection
                        if (deselectedIndex !== -1) {
                            existingSelection.splice(deselectedIndex, 1);
                        }
                    }
                }
            })
            // Save the updated selection to localStorage
            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(existingSelection));

            console.log('Deselection removed:', args.data);
        } catch (error) {
            console.error('Error removing deselection:', error);
        }
        // billsSelected = this.getSelectedRecords()
        var splitCode = getSubscriptionIDFromExpireOrganization(expireOrganization);
        var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
        // Filter existing selection to get only those records with orgID equal to subscriptionID
        const filteredExistingSelection = existingSelection.filter(record => record.orgId === splitCode);
        // Create a Set of invoiceIDs from the filtered existing selection for quick lookups
        const invoiceIDSet = new Set(filteredExistingSelection.map(record => record.invoiceID));
        // Filter window.newDataRecord based on whether its invoiceID is in the invoiceIDSet
        billsSelected = window.newDataRecord.filter(record => invoiceIDSet.has(record.invoiceID));
        if (billsSelected.length <= 0) {
            //document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['MarkAsPaid'], false) 

            var textBtnIddiv = document.getElementById("defaultTextBtnId");
            textBtnIddiv.style.display = "block";


            document.getElementById("selectbillsId").style = "display: none !important"
        }


        if (args.isHeaderCheckboxClicked === true && billsSelected.length == 0 && args.isInteracted) {
            count = 0
            total = 0

            document.getElementById("selectedBills").innerHTML = count
            document.getElementById("total").innerHTML = "$" + total
        } else if (args.isHeaderCheckboxClicked === false && args.isInteracted) {
            document.getElementById("selectedBills").innerHTML = billsSelected.length

            total -= args.data.amountDueEditable
            total = isNaN(total) ? 0 : total
            if (countryCode == "GB") {
                document.getElementById("total").innerHTML = "£" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            else {
                document.getElementById("total").innerHTML = "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
        if (expireOrganization.length > 0) {

            var content = expireOrganization;
            var dataArray = content.split(",");
            console.log(dataArray);
            console.log(dataArray.join("\n"));
            dataArray.forEach(myFunction)
            function myFunction(item, index) {
                var splitCode = item.split(":");
                window.subscriptionID = splitCode[2];
            }

        }

        
    },
    onSelectBank: function (args) {

        if (args.value === null) {
            document.getElementById("messageBank").style.display = "block";
        } else {
            document.getElementById("messageBank").style.display = "none";
            bankAccount = args.value
            bankAccountName = args.itemData.name
            bankAccountCode = args.itemData.code
            bankAccountID = args.itemData.accountID
        }
        if (args.itemData.name.includes("Bendigo")) {
            document.getElementById("apcaId").style.visibility = "visible";
            document.getElementById("apcaId").style.display = "initial";
            document.getElementById("messageapcaId").style.display = "initial";
            document.getElementById("messageapcaId").innerHTML = '';
            document.getElementById("txtapcaId").style.visibility = "visible";
            document.getElementById("txtapcaId").style.display = "initial";
        }
        else {
            document.getElementById("apcaId").style.visibility = "hidden";
            document.getElementById("apcaId").style.display = "none";
            document.getElementById("messageapcaId").style.display = "none";
            document.getElementById("messageapcaId").style.visibility = "hidden";
            document.getElementById("txtapcaId").innerHTML = '';
        }
        //if (countryCode == 'AU') {

        //    $.ajax({
        //        url: '/Xero/CheckIfTenantBankAccountDeUserIDIsSetup/' + args.itemData.accountID,
        //        type: 'GET',
        //        headers: {
        //            'Accept': 'application/json; charset=utf-8'
        //        },
        //        success: (result) => {
        //            if (result.isError) {
        //                operations.errorHandling(result)
        //                return
        //            }
        //            else {

        //                if (result.hasDeUserID) {
        //                    document.getElementById("messageBankDeUserId").style.display = "none";
        //                    document.getElementById("messageBankDeUserId").style.visibility = "hidden";
                   
        //                } else {
        //                    document.getElementById("messageBankDeUserId").style.display = "block";
        //                    document.getElementById("messageBankDeUserId").style.visibility = "visible";
        //                }

                     
        //            }
        //        },
        //        error: (error) => {
        //            //document.getElementById("errorContentBank").innerHTML = [error.statusText, error.responseText].join(' ')
        //        }
        //    })
        //}

    },
  
    onSelectBankMp: function (args) {

        if (args.value === null) {
            document.getElementById("messageBankMp").style.display = "block";
        } else {
            document.getElementById("messageBankMp").style.display = "none";
            bankAccount = args.value
            bankAccountName = args.itemData.name
            bankAccountCode = args.itemData.code
            bankAccountID = args.itemData.accountID
        }

    },
    postContactsInvoices: async function (groupedInvoices, payments) {


        document.getElementById("progressStatus4ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Sending Remittances</div>";
        document.getElementById("progressStatus4Step2ss").innerHTML = "<span style='background: #f5f5f5;padding: 5px 10px;color: #b7adad;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -45px;white-space: normal;width: 90px;text-align: center;'>Remittances Status</div>";
        var gridSendingRemittances = document.getElementById("GridSendingRemittances").ej2_instances[0]
        var groupTotal = Object.keys(groupedInvoices).length
        var groupIndex = 0;
        var groupIndexSuccess = 0;
        var groupIndexError = 0;

        //for (var key in groupedInvoices) {
        //    if (groupedInvoices.hasOwnProperty(key)) {
        //        if (key !== "" && groupedInvoices[key].length > 0) {
        //            gridSendingRemittances.addRecord({ Status: key, Message: 'Pending' });
        //        } else {
        //            // Add record for cases where key is empty or no invoices are found
        //            gridSendingRemittances.addRecord({ Status: "No Contact", Message: 'failed' });
        //        }
        //    }
        //}
        for (var key in groupedInvoices) {
            if (key !== "" && groupedInvoices[key].length > 0) {
                if (groupedInvoices[key].length > 0) {
                    gridSendingRemittances.addRecord({ Status: key, Message: 'Pending' });
                } 
            }
        }
        //document.getElementById("progressBar").max = groupTotal
        //document.getElementById("progressBar").value = groupIndex
        for (var key in groupedInvoices) {
            if (groupedInvoices.hasOwnProperty(key)) {
                if (key !== "" && groupedInvoices[key].length > 0) {
                    console.log(groupedInvoices[key]);
                    //  gridSendingRemittances.addRecord({ Progress: 'Generating remittances -' + key })
                    //gridSendingRemittances.addRecord({ Status: key, Message: 'Pending' })

                    var count = 40;
                    let myInterval = setInterval(function () {

                        if (count <= 100) {
                            document.getElementById('Prog15').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            clearInterval(myInterval)
                            return;
                        }
                        count += 1;
                    }, 100);

                    //debugger
                    let payload = {
                        selectedInvoices: groupedInvoices[key],
                        payments: payments
                    }


                    const result = await $.ajax({
                        url: API_ENDPOINTS.SEND_REMITTANCE,
                        type: 'POST',
                        data: JSON.stringify(payload),   
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8'
                        },
                        beforeSend: function () {
                            if (groupIndex < 1) {

                                groupIndex++;
                                //document.getElementById("progressBar").value = groupIndex
                                var label = "Sending remittances " + groupIndex + ' of ' + groupTotal;
                                document.getElementById("progressLabel").innerHTML = label
                            }
                        },
                        success: (result) => {
                      
                            document.getElementById("progressStatus4ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>1</span> <span></span> <div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -5px;white-space: normal;width: 80px;'>Sending Remittances</div>";
                            document.getElementById("progressStatus4Step2ss").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>2</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -45px;white-space: normal;width: 90px;text-align: center;'>Remittances Status</div>";
                     
                            document.getElementById('Prog15').style.display = 'none';
                            document.getElementById('Prog15').style.visibility = 'hidden'
                            if (result.isError) {
                                gridSendingRemittances.addRecord({ Status: result.contactName, Message: result.message })
                                groupIndexError++;

                                if (groupIndex == groupTotal) {
                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").style.visibility = "visible";
                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").style.display = "initial";

                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").onclick = function (e) {
                                        var dialogSendingRemittance = document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").ej2_instances[0]
                                        dialogSendingRemittance.hide()
                                        document.getElementById("step3").ej2_instances[0].disabled = true
                                        var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                        // Clear Selected bills per organization
                                        var filteredSelection = existingSelection.filter(function (item) {
                                            // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                            return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                        });

                                        // Save the updated selection to localStorage
                                        localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                        return
                                    }
                               
                                    var labelSuccess = "Sent remittances " + groupIndexSuccess + ' of ' + groupTotal;
                                    document.getElementById("progressLabelResultSuccess").innerHTML = labelSuccess
                                    var labelErrors = "Failed remittances " + groupIndexError + ' of ' + groupTotal;
                                    document.getElementById("progressLabelResultErrors").innerHTML = labelErrors
                                }

                                if (groupIndex < groupTotal) {
                                    groupIndex++;
                                    //document.getElementById("progressBar").value = groupIndex
                                    var label = "Sending remittances " + groupIndex + ' of ' + groupTotal;
                                    document.getElementById("progressLabel").innerHTML = label
                                }
                            } else {

                                result.payments.forEach((item) => {
                                    // Backend returns { Invoices: { _Payments: [...] } } - no .result level
                                    window.markAsPaidResult.invoices._Payments.filter((item2) => item2.paymentID == item.paymentID).forEach((item3) => item3.details = item.details)
                                });


                                //Bug-893
                                const allData = gridSendingRemittances.dataSource;  // or gridSendingRemittances.dataSource if it's an array
                                for (let i = 0; i < allData.length; i++) {
                                    const rowData = allData[i];

                                    if (rowData.Status === result.contactName) {
                                        rowData.Message = result.message;
                                        gridSendingRemittances.updateRowValue(rowData.Status, rowData);
                                        break;
                                    }
                                }

                                //gridSendingRemittances.addRecord({ Status: result.contactName, Message: result.message })
                                groupIndexSuccess++;
                                document.getElementById('Prog15').style.display = 'none';
                                document.getElementById('Prog15').style.visibility = 'hidden'
                                if (groupIndex == groupTotal) {
                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").style.visibility = "visible";
                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").style.display = "initial";

                                    document.getElementById("btnPromptOkaySendingRemittanceProgress").onclick = function (e) {
                                        var dialogSendingRemittance = document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").ej2_instances[0]
                                        dialogSendingRemittance.hide()
                                        document.getElementById("step3").ej2_instances[0].disabled = true
                                        var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                        // Clear Selected bills per organization
                                        var filteredSelection = existingSelection.filter(function (item) {
                                            // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                            return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                        });

                                        // Save the updated selection to localStorage
                                        localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                        return
                                    }

                                    var labelSuccess = "Sent remittances " + groupIndexSuccess + ' of ' + groupTotal;
                                    document.getElementById("progressLabelResultSuccess").innerHTML = labelSuccess
                                    var labelErrors = "Failed remittances " + groupIndexError + ' of ' + groupTotal;
                                    document.getElementById("progressLabelResultErrors").innerHTML = labelErrors

                                    //var label = groupIndexSuccess + " Remittances successfully sent, " + groupIndexError + " Remittances were failed to be sent.";
                                    //document.getElementById("progressLabelResult").innerHTML = label
                                }

                                if (groupIndex < groupTotal) {
                                    groupIndex++;
                                    //document.getElementById("progressBar").value = groupIndex
                                    var label = "Sending remittances " + groupIndex + ' of ' + groupTotal;
                                    document.getElementById("progressLabel").innerHTML = label
                                }

                               
                            }
                        },
                        error: (error) => {
                            console.log(error);
                            gridSendingRemittances.addRecord({ Progress: 'Error - ' + error })
                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                            // Clear Selected bills per organization
                            var filteredSelection = existingSelection.filter(function (item) {
                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                            });

                            // Save the updated selection to localStorage
                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                        }
                    })
                }

            }
        }
    },
    onSendRemittanceAdvice: function (args, args1) {

        var dialogProgress = document.getElementById("prompProgressDialog").ej2_instances[0]
        var dialog = document.getElementById("promptInfoDialog").ej2_instances[0]
        var grid = document.getElementById("Grid").ej2_instances[0]
        dialog.hide()
        grid.hideSpinner()

        var dialogSendingRemittance = document.getElementById("promptInfoDialogContainerSendingRemittanceProgress").ej2_instances[0]
        var dlgHeader = document.getElementById("promptInfoDialogContainerSendingRemittanceProgress_dialog-header")
        var dlgContent = document.getElementById("promptInfoDialogContainerSendingRemittanceProgress_dialog-content")

        dlgHeader.classList.add("prompt-dlg-header-template")
        dlgContent.classList.add("dlg-content-template")
        document.getElementById("btnPromptOkaySendingRemittanceProgress").style.display = "none";

        dialogSendingRemittance.show()

        //group selectedInvoices by contact
        let selectedInvoices = args.filter(i => i.hasEmailAddress == true)


        let groupedInvoices = selectedInvoices.reduce((groups, invoice) => {

            //let contact = invoice.contact;

            //if (contact.contactID !== null && contact.contactID !== "" && contact.name !== null && contact.name !== "") {
            //    let key = contact.name;
            //    if (!groups[key]) {
            //        groups[key] = []
            //    }
            //    groups[key].push(invoice)
           
            //}
            //return groups


            let key = invoice.contact.name
            if (key != null) {
                if (!groups[key]) {
                    groups[key] = []
                }
                groups[key].push(invoice)
                return groups
            }
        }, {})

        //debugger

        let payload = {
            selectedInvoices: args.filter(i => i.hasEmailAddress == true),
            payments: args1.invoices
        }

        this.postContactsInvoices(groupedInvoices, args1.invoices)

    },
    ExportBatchPaymentReportConfirmationForNewTransaction: function (dialogProgress, dialog, result) {

        var dialog = document.getElementById("promptInfoDialogReport").ej2_instances[0]
        document.getElementById("promptContentReport").innerHTML = "Your BatchPay Report is ready to be exported"

        var dlgHeader = document.getElementById("promptInfoDialogReport_dialog-header")
        dlgHeader.classList.add("prompt-dlg-header-template")

        var dlgContent = document.getElementById("promptInfoDialogReport_dialog-content")
        dlgContent.classList.add("dlg-content-template")

        document.getElementById("progressStatus4").style.display = "none";
        document.getElementById("Prog4").style.display = "none";
        document.getElementById("btnPromptOkayExportReport").style.display = "initial";
        document.getElementById("btnPromptCancelExport").style.display = "none";

        dialogProgress.hide()
        dialog.hide()
        dialog.show()

        document.getElementById("btnPromptOkayExportReport").onclick = function (e) {
            operations.onGetBills()

            dialogProgress.hide()
            selectedInvoiceWithNoBankDetails = []
            dialog.hide()
            location.href = `/Xero/DownloadPDF/${result.fileName}/${result.filePath}`
            document.getElementById("step1").ej2_instances[0].disabled = false
            document.getElementById("step2").ej2_instances[0].disabled = false
            document.getElementById("step3").ej2_instances[0].disabled = true
            document.getElementById("step4").ej2_instances[0].disabled = true
            window.disabledGridEditing = false
            //window.location = "/Home/Index/"
       
        }

        document.getElementById("btnPromptCancelExport").onclick = function (e) {
            location.href = `/Xero/DownloadPDF/${result.fileName}/${result.filePath}`
            dialogProgress.hide()
            dialog.hide()
        }

    },
    UpdatePaymentHistory: function (payments, dialogProgress) {

        let payload = {
            payments: payments.invoices
        }

        if (CheckIfConnectedToXero()) {
            $.ajax({
                url: API_ENDPOINTS.UPDATE_PAYMENT_HISTORY,
                type: 'POST',
                data: JSON.stringify(payments.invoices),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept': 'application/json; charset=utf-8'
                },
                success: (result) => {
                    if (result.isError) {
                        //dialogProgress.hide()
                        operations.errorHandling(result)
                        return

                    } else {
                        document.getElementById('ProgOnly').style.display = 'none'
                        document.getElementById('ProgOnly').style.visibility = 'hidden'
                        document.getElementById("btnPromptOkayMarkAsPaid").style.visibility = "visible";
                        document.getElementById("btnPromptOkayMarkAsPaid").style.display = "initial";
                        document.getElementById("SuccessStatus").style.visibility = "visible";
                        document.getElementById("SuccessStatus").style.display = "initial";

                        document.getElementById("progressStatusOnly").innerHTML = "<span style='background: #44C7F4;padding: 5px 10px;color: #fafafa;font-size: 13px;font-weight: 500;border-radius: 50%;border: 3px solid #44C7F4;'>3</span> <span></span><div style='z-index: 9999;position: absolute;margin-top: 10px;margin-left: -25px;white-space: normal;width: 90px;'><div style='z-index: 9999;position: absolute;white-space: normal;width: 90px;'>Update Xero</div>";
                        // Backend returns { Invoices: { _Payments: [...] } } - no .result level
                        if (payments.invoices._Payments.length > 1) {
                            document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #b1f1797a !important;padding: 15px;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 2px;margin-right: 8px;"> <span class="e-icons e-circle-check" title="Success"></span></div> <div> <span style="color: rgba(0,0,0,.87);"> Bills have been marked as paid successfully </span></div></div>';
                        }
                        else {
                            document.getElementById('SuccessStatus').innerHTML = '<div class="msg_success" style="background: #b1f1797a !important;padding: 15px;border-radius: 5px;font-size: 15px;color: #4a934a !important;"> <div style="margin-top: 2px;margin-right: 8px;"> <span class="e-icons e-circle-check" title="Success"></span></div> <div> <span style="color: rgba(0,0,0,.87);"> Bill has been marked as paid successfully </span></div></div>';
                        }
                        var count = 80;
                        let myInterval = setInterval(function () {

                            if (count <= 100) {
                                //document.getElementById('ProgOnly').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            } else {
                                //dialogProgress.hide()
                                clearInterval(myInterval)
                                return;
                            }
                            count += 1;
                        }, 100);

                        document.getElementById("btnPromptOkayMarkAsPaid").onclick = function (e) {
                            dialogProgress.hide()
                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                            // Clear Selected bills per organization
                            var filteredSelection = existingSelection.filter(function (item) {
                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                return item.orgId == subscriptionID;
                            });
                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA_FOR_REMITTANCE, JSON.stringify(filteredSelection))
                            var filteredSelection = existingSelection.filter(function (item) {
                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                            });

                            // Save the updated selection to localStorage
                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                            //grid.hideSpinner()
                        }
                    }

                },
                error: (error) => {
                    let errorDetail = {
                        invoiceNumber: "",
                        errors: []
                    }
                    let errors = {
                        errorDetail: []
                    }

                    let payload = operations.extractJson(error.responseText)
                    payload.Elements.forEach((item) => {
                        errors.errorDetail.push({
                            invoiceNumber: item.InvoiceNumber,
                            errors: item.ValidationErrors
                        })
                    })

                    //operations.errorFormat(errors)
                    //grid.hideSpinner()
                }
            })
        } else {
            tenantNotConnected()
        }
    },
    errorHandling: function (result) {
        if (result.tokenExpired) {
            if (typeof window.showTokenExpiredDialog === 'function') {
                window.showTokenExpiredDialog(
                    result.tokenExpiredTitle || 'Your Xero connection has expired',
                    result.tokenExpiredMessage || 'For security reasons, your connection to Xero needs to be refreshed periodically. This is normal and your data is safe. Please click "Reconnect to Xero" to re-establish your connection.'
                );
            } else {
                alert('Your Xero connection has expired. Please log in again.');
                // Detect browser for Authorization route
                let userAgent = navigator.userAgent;
                let browser = "";
                if (userAgent.match(/edg/i)) {
                    browser = "edge";
                } else if (userAgent.match(/firefox|fxios/i)) {
                    browser = "firefox";
                } else if (userAgent.match(/opr\//i)) {
                    browser = "opera";
                } else if (userAgent.match(/chrome|chromium|crios/i)) {
                    browser = "chrome";
                } else if (userAgent.match(/safari/i)) {
                    browser = "safari";
                } else {
                    browser = "other";
                }
                window.location = `/Authorization/Index/${browser}`;
            }
            return;
        }

        var errorMsg = (result.exceptionMessage || result.message || result.innerMessage || '').toLowerCase();
        if (errorMsg.includes('token') && (errorMsg.includes('expired') || errorMsg.includes('invalid'))) {
            if (typeof window.showTokenExpiredDialog === 'function') {
                window.showTokenExpiredDialog(
                    'Your Xero connection has expired',
                    'For security reasons, your connection to Xero needs to be refreshed periodically. This is normal and your data is safe. Please click "Reconnect to Xero" to re-establish your connection.'
                );
            } else {
                alert('Your Xero connection has expired. Please log in again.');
                // Detect browser for Authorization route
                let userAgent = navigator.userAgent;
                let browser = "";
                if (userAgent.match(/edg/i)) {
                    browser = "edge";
                } else if (userAgent.match(/firefox|fxios/i)) {
                    browser = "firefox";
                } else if (userAgent.match(/opr\//i)) {
                    browser = "opera";
                } else if (userAgent.match(/chrome|chromium|crios/i)) {
                    browser = "chrome";
                } else if (userAgent.match(/safari/i)) {
                    browser = "safari";
                } else {
                    browser = "other";
                }
                window.location = `/Authorization/Index/${browser}`;
            }
            return;
        }

        if (result.errorCode == 1) {
            if (result.sessionTimeOut) {
                window.location = API_ENDPOINTS.HOME_INDEX
            }

            let payload = {
                ErrorCode: result.errorCode,
                ExceptionPath: result.exceptionPath,
                ExceptionMessage: result.exceptionMessage,
                Stacktrace: result.stacktrace
            }

            $.ajax({
                url: API_ENDPOINTS.ERROR_DISPLAY,
                type: 'POST',
                contentType: 'application/json',
                accept: 'application/json',
                data: JSON.stringify(payload),
                success: (result) => {
                    $("#BodyContent").html(result)
                    console.log(result)
                },
                error: (error) => {
                    console.log(error)
                }
            })

        }
        else {
            if (result.errorCode == 400) {
                let errors = {
                    errorDetail: []
                }

                try {
                    let payload = operations.extractJson(result.innerMessage)
                    
                    // Check if payload has Elements array (per-invoice errors)
                    if (payload && payload.Elements && Array.isArray(payload.Elements)) {
                        payload.Elements.forEach((item) => {
                            errors.errorDetail.push({
                                invoiceNumber: item.InvoiceNumber || "",
                                errors: item.ValidationErrors || []
                            })
                        })
                    }
                    // Check if payload has ValidationErrors at root level (batch-level errors like currency mismatch)
                    else if (payload && payload.ValidationErrors && Array.isArray(payload.ValidationErrors)) {
                        errors.errorDetail.push({
                            invoiceNumber: "Batch Payment Error",
                            errors: payload.ValidationErrors
                        })
                    }
                    // Fallback: show the raw error message
                    else {
                        let errorMessage = result.message || result.innerMessage || "An error occurred while processing the request"
                        errors.errorDetail.push({
                            invoiceNumber: "Error",
                            errors: [{ Message: errorMessage }]
                        })
                    }
                } catch (parseError) {
                    // If JSON parsing fails, show the raw error message
                    console.error("Error parsing error response:", parseError)
                    let errorMessage = result.message || result.innerMessage || "An error occurred while processing the request"
                    errors.errorDetail.push({
                        invoiceNumber: "Error",
                        errors: [{ Message: errorMessage }]
                    })
                }
                
                operations.errorFormat(errors)
                document.getElementById("Grid").ej2_instances[0].hideSpinner()
            }

            if (result.errorCode == 401 || result.errorCode == 503 || result.errorCode == 429) {

                let payload = {
                    ErrorCode: result.errorCode,
                    ExceptionPath: "Xero Response Error",
                    ExceptionMessage: result.innerMessage,
                    Stacktrace: result.message
                }

                $.ajax({
                    url: API_ENDPOINTS.ERROR_DISPLAY_REAUTH,
                    type: 'POST',
                    contentType: 'application/json',
                    accept: 'application/json',
                    data: JSON.stringify(payload),
                    success: (result) => {
                        $("#BodyContent").html(result)
                        console.log(result)
                    },
                    error: (error) => {
                        console.log(error)
                    }
                })
            }

            if (result.errorCode == 429) {

                let payload = {
                    ErrorCode: result.errorCode,
                    ExceptionPath: "Xero Response Error",
                    ExceptionMessage: result.innerMessage,
                    Stacktrace: result.message
                }

                $.ajax({
                    url: API_ENDPOINTS.ERROR_DISPLAY_REAUTH,
                    type: 'POST',
                    contentType: 'application/json',
                    accept: 'application/json',
                    data: JSON.stringify(payload),
                    success: (result) => {
                        $("#BodyContent").html(result)
                        console.log(result)
                    },
                    error: (error) => {
                        console.log(error)
                    }
                })
            }
        }
    },
    ExportBatchPaymentReport3: function (args, args1) {
        document.getElementById("prompProgressDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomRightRadius = "10px";

        document.getElementById("promptInfoDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomRightRadius = "10px";

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";
        document.getElementById("btnPromptOkayExportReport2").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport2").style.display = "none";
        document.getElementById("btnCancelExportReport").style.visibility = "hidden";
        document.getElementById("btnCancelExportReport").style.display = "none";

        document.getElementById("exportreport").style.visibility = "hidden";
        document.getElementById("exportreport").style.display = "none";
        var dialog = document.getElementById("promptInfoDialogReport").ej2_instances[0]
        var grid = document.getElementById("Grid").ej2_instances[0]

        var dialogProgressReport = document.getElementById("prompProgressDialogReport").ej2_instances[0]

        var dlgHeader = document.getElementById("prompProgressDialogReport_dialog-header")
        var dlgContent = document.getElementById("prompProgressDialogReport_dialog-content")

        dlgHeader.classList.add("prompt-dlg-header-template")
        dlgContent.classList.add("dlg-content-template")

        dialogProgressReport.show()

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";

        document.getElementById("btnPromptOkayExportReport2").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport2").style.display = "none";

        document.getElementById("btnCancelExportReport").style.visibility = "hidden";
        document.getElementById("btnCancelExportReport").style.display = "none";

        document.getElementById("exportreport").style.visibility = "hidden";
        document.getElementById("exportreport").style.display = "none";

        document.getElementById("promptContentReport1").style.visibility = "hidden";
        document.getElementById("promptContentReport1").style.display = "none";

        document.getElementById("progressStatusOnlyReport").innerHTML = "<span style='color: rgba(0,0,0,.87);'>Preparing your BatchPay report</span>";

        // Batching Configuration
        // Batching Configuration
        const batchSize = 1;  // Change this to adjust the batch size
        const allKeys = Object.keys(args).filter(key => key !== "" && args[key].length > 0);
        const totalBatches = Math.ceil(allKeys.length / batchSize);
        let currentBatch = 0;
        let processedCount = 0;

        // Accumulator for collecting all invoices across batches
        let accumulatedInvoices = [];
        let accumulatedPayments = [];

        // Function to process each batch sequentially
        function processNextBatch() {
            if (currentBatch < totalBatches) {
                const start = currentBatch * batchSize;
                const end = start + batchSize;
                const batchKeys = allKeys.slice(start, end);

                const selectedInvoices = batchKeys
                    .map(key => args[key])
                    .flat()
                    .filter(i => i.hasBankDetails === true);

                // Accumulate selectedInvoices for final report generation
                accumulatedInvoices.push(...selectedInvoices);

                const selectedInvoiceIds = selectedInvoices.map(inv => inv.invoiceID);

                const paymentsArray = Object.values(args1.invoices.result);
                const allPayments = paymentsArray.flat();
                const filteredPayments = allPayments.filter(payment =>
                    selectedInvoiceIds.includes(payment.invoice.invoiceID)
                );

                // Accumulate payments for final report generation
                accumulatedPayments.push(...filteredPayments);

                let payload = {
                    selectedInvoices: selectedInvoices,
                    payments: { _Payments: filteredPayments }
                };

                // Update progress bar BEFORE sending the request
                let progress = Math.max(1, Math.round((processedCount / allKeys.length) * 100));
                let progressBar = document.getElementById('ProgOnlyReport');
                progressBar.innerHTML = '';  // Clear to force repaint
                progressBar.innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="' + progress + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + progress + '%">' + progress + '%</div>';

                // Add client-side diagnostics logging
                console.log(`Sending batch with ${payload.selectedInvoices.length} invoices and ${payload.payments._Payments.length} payments`);
                
                // Add structure validation before sending
                let dataValidation = {
                    hasSelectedInvoices: payload.selectedInvoices && payload.selectedInvoices.length > 0,
                    hasPayments: payload.payments && payload.payments._Payments && payload.payments._Payments.length > 0,
                    invoiceCount: payload.selectedInvoices ? payload.selectedInvoices.length : 0,
                    paymentCount: payload.payments && payload.payments._Payments ? payload.payments._Payments.length : 0
                };
                console.log('Batch validation:', dataValidation);
                
                // Process the batch via AJAX with retry logic
                const ajaxWithRetry = typeof ApiClient !== 'undefined' ? ApiClient.ajaxWithRetry : null;
                const ajaxOptions = {
                    url: API_ENDPOINTS.PROCESS_BATCH_REPORT,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(payload),
                    timeout: 300000,
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'X-Batch-Diagnostics': JSON.stringify({
                            invoiceCount: payload.selectedInvoices.length,
                            paymentCount: payload.payments._Payments.length,
                            batchNumber: currentBatch,
                            totalBatches: totalBatches
                        })
                    },
                    beforeSend: function(xhr) {
                        console.log(`Sending batch ${currentBatch} of ${totalBatches}`);
                    }
                };

                const handleError = function(xhr, status, error) {
                    console.error('Error in ProcessBatchReport1:', status, error);
                    logToServer("error", "ProcessBatchReport1 AJAX failed", {
                        status: xhr ? xhr.status : 'unknown',
                        statusText: xhr ? xhr.statusText : 'unknown',
                        error: error,
                        batchNumber: currentBatch,
                        totalBatches: totalBatches
                    });
                    toastr.error(`Error processing report: ${error || "Unknown error"}. Please try again.`);
                };

                const handleSuccess = function(result) {
                    // Log success information for comparison with failures
                    console.log(`Batch ${currentBatch} completed successfully:`, {
                        hasResult: !!result,
                        isError: result ? result.isError : undefined,
                        message: result ? result.message : undefined,
                        filePathPDF: result ? result.filePathPDF : undefined,
                        filePathCSV: result ? result.filePathCSV : undefined
                    });
                    
                    // Check for error response
                    if (result && result.isError === true) {
                        console.error('Batch processing error:', result.message || 'Unknown error');
                        toastr.error(`Error: ${result.message || 'Unknown error'}`);
                        return;
                    }
                    processedCount += batchKeys.length;
                    currentBatch++;

                    // Update progress bar AFTER processing each batch
                    let progress = Math.round((processedCount / allKeys.length) * 100);
                    progressBar.innerHTML = '';  // Clear to force repaint
                    progressBar.innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="' + progress + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + progress + '%">' + progress + '%</div>';

                    // Continue with the next batch or finish
                    if (currentBatch < totalBatches) {
                        processNextBatch();
                    } else {
                        // All batches are done, now generate the report
                        let finalPayload = {
                            selectedInvoices: accumulatedInvoices,
                            payments: { _Payments: accumulatedPayments }
                        };

                        $.ajax({
                            url: API_ENDPOINTS.GENERATE_FINAL_REPORT,
                            type: 'POST',
                            contentType: "application/json; charset=utf-8",
                            data: JSON.stringify(finalPayload),
                            headers: {
                                'Content-Type': 'application/json; charset=utf-8'
                            },
                            success: (result) => {
                                // Show download options for the generated report
                                document.getElementById("promptContentReport1").innerHTML = "Your BatchPay Report is ready to be exported";

                                document.getElementById("btnPromptOkayExportReport1").style.visibility = "visible";
                                document.getElementById("btnPromptOkayExportReport1").style.display = "initial";

                                document.getElementById("btnPromptOkayExportReport2").style.visibility = "visible";
                                document.getElementById("btnPromptOkayExportReport2").style.display = "initial";

                                document.getElementById("btnPromptOkayExportReport1").onclick = function () {
                                    var downloadUrl = API_ENDPOINTS.DOWNLOAD_PDF + result.fileNamePDF + "/" + result.filePathPDF;
                                    window.open(downloadUrl, '_blank');
                                };

                                document.getElementById("btnPromptOkayExportReport2").onclick = function () {
                                    var downloadUrl = API_ENDPOINTS.DOWNLOAD_CSV + result.fileNameCSV + "/" + result.filePathCSV;
                                    window.open(downloadUrl, '_blank');
                                };

                                document.getElementById("btnCancelExportReport").onclick = function () {
                                    dialogProgressReport.hide();
                                    window.location = API_ENDPOINTS.HOME_INDEX;
                                };
                            },
                            error: (error) => {
                                console.log(error);
                                logToServer("error", "GenerateFinalReport AJAX failed", { error: error.statusText || error.message || "Unknown error" });
                                alert('An error occurred while generating the final report. Please try again.');
                            }
                        });
                    }
                };

                // Use ApiClient with retry logic if available, otherwise fallback to regular AJAX
                if (ajaxWithRetry) {
                    ajaxWithRetry(ajaxOptions)
                        .then(handleSuccess)
                        .catch(function(err) {
                            handleError(err.xhr, err.status, err.error);
                        });
                } else {
                    $.ajax({
                        ...ajaxOptions,
                        success: handleSuccess,
                        error: handleError
                    });
                }
            }
        }

        // Start processing the first batch
        processNextBatch();

    },

    ExportBatchPaymentReport: function (args, args1) {
        document.getElementById("prompProgressDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomRightRadius = "10px";
        
        document.getElementById("promptInfoDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomRightRadius = "10px";

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";
        document.getElementById("btnPromptOkayExportReport2").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport2").style.display = "none";
        document.getElementById("btnCancelExportReport").style.visibility = "hidden";
        document.getElementById("btnCancelExportReport").style.display = "none";

        document.getElementById("exportreport").style.visibility = "hidden";
        document.getElementById("exportreport").style.display = "none";
        var dialog = document.getElementById("promptInfoDialogReport").ej2_instances[0]
        var grid = document.getElementById("Grid").ej2_instances[0]
    
        var dialogProgressReport = document.getElementById("prompProgressDialogReport").ej2_instances[0]

        var dlgHeader = document.getElementById("prompProgressDialogReport_dialog-header")
        var dlgContent = document.getElementById("prompProgressDialogReport_dialog-content")

        dlgHeader.classList.add("prompt-dlg-header-template")
        dlgContent.classList.add("dlg-content-template")

        dialogProgressReport.show()

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";

        document.getElementById("btnPromptOkayExportReport2").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport2").style.display = "none";

        document.getElementById("btnCancelExportReport").style.visibility = "hidden";
        document.getElementById("btnCancelExportReport").style.display = "none";

        document.getElementById("exportreport").style.visibility = "hidden";
        document.getElementById("exportreport").style.display = "none";

        document.getElementById("promptContentReport1").style.visibility = "hidden";
        document.getElementById("promptContentReport1").style.display = "none";

        document.getElementById("progressStatusOnlyReport").innerHTML = "<span style='color: rgba(0,0,0,.87);'>Preparing your BatchPay report</span>";

        for (var key in args) {
            if (args.hasOwnProperty(key)) {
                if (key !== "" && args[key].length > 0) {
                    var count = 0;
                    var myInterval = setInterval(function () {

                        if (count <= 50) {
                            document.getElementById('ProgOnlyReport').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                            document.getElementById('ProgOnlyReportWaitMessage').innerHTML = '<div>Processing your request. This may take a moment.</div>';
                        } else {
                            clearInterval(myInterval)
                            return;
                        }
                        count += 1;

                    }, 100);

                    //debugger
                    let payload = {
                        selectedInvoices: Object.values(args)
                            .flat()
                            .filter(i => i.hasBankDetails === true), // Filters invoices with bank details
                        payments: args1.invoices
                    };
                    
                    // Add client-side diagnostics for troubleshooting
                    console.log(`Sending batch report request with ${payload.selectedInvoices.length} invoices and ${payload.payments._Payments.length} payments`);
                    
                    // Log structure validation info
                    let validationInfo = {
                        invoiceCount: payload.selectedInvoices.length,
                        paymentCount: payload.payments._Payments ? payload.payments._Payments.length : 0,
                        hasPayments: !!payload.payments,
                        hasPaymentsList: !!(payload.payments && payload.payments._Payments),
                        browser: navigator.userAgent,
                        timestamp: new Date().toISOString()
                    };
                    console.log('Batch validation:', validationInfo);

                    $.ajax({
                        url: API_ENDPOINTS.PROCESS_BATCH_REPORT,
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify(payload),
                        beforeSend: function (xhr) {
                            //dialog.hide()
                            //grid.showSpinner()
                            
                            // Add diagnostic info to the request
                            xhr.setRequestHeader('X-Batch-Diagnostics', JSON.stringify({
                                invoiceCount: payload.selectedInvoices.length,
                                paymentCount: payload.payments._Payments.length,
                                timestamp: new Date().toISOString()
                            }));
                        },
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8'
                        },
                        error: function(xhr, status, errorMsg) {
                            console.error('Error in ProcessBatchReport1:', status, errorMsg);
                            document.getElementById("ProgOnlyReportWaitMessage").style.visibility = "hidden";
                            document.getElementById("ProgOnlyReportWaitMessage").style.display = "none";
                            document.getElementById('ProgOnlyReportErrorMessage').innerHTML = '<div>Error processing report: ' + (errorMsg || "Unknown error") + '</div>';
                            toastr.error(`Error processing report: ${errorMsg || "Unknown error"}. Please try again.`);
                            
                            // Clear selected bills per organization on error
                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                            var filteredSelection = existingSelection.filter(function (item) {
                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                            });
                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                        },
                        success: (result) => {
                            // Log success information
                            console.log('BatchPay report generated successfully:', {
                                hasResult: !!result,
                                isError: result ? result.isError : undefined,
                                message: result ? result.message : undefined,
                                filePathPDF: result ? result.filePathPDF : undefined,
                                filePathCSV: result ? result.filePathCSV : undefined,
                                timestamp: new Date().toISOString()
                            });
                            
                            // Check if result exists
                            if (!result) {
                                document.getElementById("ProgOnlyReportWaitMessage").style.visibility = "hidden";
                                document.getElementById("ProgOnlyReportWaitMessage").style.display = "none";
                                document.getElementById('ProgOnlyReportErrorMessage').innerHTML = '<div>Error: Empty response received</div>';
                                console.error('Empty response from server');
                                return;
                            }

                            downloadInfo.fileNamePDF = result.fileNamePDF;
                            downloadInfo.filePathPDF = result.filePathPDF;
                            downloadInfo.fileNameCSV = result.fileNameCSV;
                            downloadInfo.filePathCSV = result.filePathCSV;

                            if (result.isError) {
                                document.getElementById("ProgOnlyReportWaitMessage").style.visibility = "hidden";
                                document.getElementById("ProgOnlyReportWaitMessage").style.display = "none";
                                document.getElementById('ProgOnlyReportErrorMessage').innerHTML = '<div >' + result.message+'</div>';
                                dialog.hide()
                                grid.hideSpinner()
                                operations.errorHandling(result)
                                return

                            } else {
                                document.getElementById("progressStatusOnlyReport").innerHTML = "<span style='color: rgba(0,0,0,.87);'>Preparing your BatchPay report</span>";

                                var count = 50;
                                var myInterval = setInterval(function () {

                                    if (count <= 100) {
                                        document.getElementById('ProgOnlyReport').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                                        document.getElementById('ProgOnlyReportWaitMessage').innerHTML = '<div>Processing your request. This may take a moment.</div>';
                                    } else {
                                        document.getElementById("ProgOnlyReportWaitMessage").style.visibility = "hidden";
                                        document.getElementById("ProgOnlyReportWaitMessage").style.display = "none";
                                        document.getElementById("ProgOnlyReportErrorMessage").style.display = "none";
                                        document.getElementById("ProgOnlyReport").style.visibility = "hidden";
                                        document.getElementById("ProgOnlyReport").style.display = "none";
                                        document.getElementById("progressStatusOnlyReport").style.visibility = "hidden";
                                        document.getElementById("progressStatusOnlyReport").style.display = "none";
                                        document.getElementById("promptContentReport1").style.visibility = "visible";
                                        document.getElementById("promptContentReport1").style.display = "initial";
                                        document.getElementById("promptContentReport1").innerHTML = "Your BatchPay Report is ready to be exported"
                                        //document.getElementById("btnPromptOkayExportReport1").style.visibility = "visible";
                                        // document.getElementById("btnPromptOkayExportReport1").style.display = "initial";
                                        //document.getElementById("btnPromptOkayExportReport2").style.visibility = "visible";
                                        // document.getElementById("btnPromptOkayExportReport2").style.display = "initial";
                                        document.getElementById("btnCancelExportReport").style.visibility = "visible";
                                        document.getElementById("btnCancelExportReport").style.display = "initial";

                                        document.getElementById("exportreport").style.visibility = "visible";
                                        document.getElementById("exportreport").style.display = "initial";
                                        document.getElementById("exportreport").style.paddingBottom = "7px";
                                        clearInterval(myInterval)
                                        //location.href = `/Xero/DownloadPDF/${result.fileName}/${result.filePath}`
                                        //operations.ExportBatchPaymentReportConfirmationForNewTransaction(dialogProgressReport, dialog, result)


                                        document.getElementById("btnPromptOkayExportReport1").onclick = function (e) {
                                            //operations.onGetBills()
                                            var downloadUrl = `/Xero/DownloadPDF/${result.fileNamePDF}/${result.filePathPDF}`
                                            //dialogProgress.hide()

                                            //setTimeout(function () {
                                            //    // Reload the page after the delay
                                            //    window.location = "/Home/Index/"
                                            //}, 2000);


                                            var checkDownloadStatus = function () {
                                                var xhr = new XMLHttpRequest();
                                                xhr.open("HEAD", downloadUrl, true);
                                                xhr.onreadystatechange = function () {
                                                    if (xhr.readyState === 4) {
                                                        // Check if the status code indicates a successful download
                                                        if (xhr.status === 200) {
                                                            // Reload the page once the download is completed
                                                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                                            // Clear Selected bills per organization
                                                            var filteredSelection = existingSelection.filter(function (item) {
                                                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                                            });

                                                            // Save the updated selection to localStorage
                                                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                                            window.location.reload();
                                                        } else {
                                                            // Retry after a delay (e.g., 1000 milliseconds or 1 second)
                                                            setTimeout(checkDownloadStatus, 1000);
                                                        }
                                                    }
                                                };
                                                xhr.send();
                                            };

                                            // Initiating the download
                                            location.href = downloadUrl;

                                            // Start checking for download completion after a delay (e.g., 2000 milliseconds or 2 seconds)
                                            setTimeout(checkDownloadStatus, 2000);

                                            selectedInvoiceWithNoBankDetails = []
                                            selectedInvoiceWithNoBankDetailsReportExport = []
                                            dialog.hide()
                                            //switch (countryCode) {
                                            //    case "AU":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['Export'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    case "NZ":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportCSV'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    case "GB":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportToBacs'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    default:
                                            //}
                                            //document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['MarkAsPaid', 'SendRemittances', 'ExportBatchPaymentReport'], false)

                                            document.getElementById("step1").ej2_instances[0].disabled = false
                                            document.getElementById("step2").ej2_instances[0].disabled = false
                                            document.getElementById("step3").ej2_instances[0].disabled = true
                                            document.getElementById("step4").ej2_instances[0].disabled = true
                                            window.disabledGridEditing = false

                                            //dialogProgressReport.hide()

                                        }
                                        //window.location = "/Home/Index/"
                                        document.getElementById("btnPromptCancelExport").onclick = function (e) {
                                            location.href = `/Xero/DownloadPDF/${result.fileNamePDF}/${result.filePathPDF}`
                                            dialogProgress.hide()
                                            dialog.hide()
                                        }


                                        document.getElementById("btnPromptOkayExportReport2").onclick = function (e) {
                                            //operations.onGetBills()
                                            var downloadUrl = `/Xero/DownloadCSV/${result.fileNameCSV}/${result.filePathCSV}`; // Change to CSV download URL
                                            //dialogProgress.hide()

                                            //setTimeout(function () {
                                            //    // Reload the page after the delay
                                            //    window.location = "/Home/Index/"
                                            //}, 2000);


                                            var checkDownloadStatus = function () {
                                                var xhr = new XMLHttpRequest();
                                                xhr.open("HEAD", downloadUrl, true);
                                                xhr.onreadystatechange = function () {
                                                    if (xhr.readyState === 4) {
                                                        // Check if the status code indicates a successful download
                                                        if (xhr.status === 200) {
                                                            // Reload the page once the download is completed
                                                            var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                                            // Clear Selected bills per organization
                                                            var filteredSelection = existingSelection.filter(function (item) {
                                                                // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                                                return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                                            });

                                                            // Save the updated selection to localStorage
                                                            localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                                            window.location.reload();
                                                        } else {
                                                            // Retry after a delay (e.g., 1000 milliseconds or 1 second)
                                                            setTimeout(checkDownloadStatus, 1000);
                                                        }
                                                    }
                                                };
                                                xhr.send();
                                            };

                                            // Initiating the download
                                            location.href = downloadUrl;

                                            // Start checking for download completion after a delay (e.g., 2000 milliseconds or 2 seconds)
                                            setTimeout(checkDownloadStatus, 2000);

                                            selectedInvoiceWithNoBankDetails = []
                                            selectedInvoiceWithNoBankDetailsReportExport = []
                                            dialog.hide()
                                            //switch (countryCode) {
                                            //    case "AU":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['Export'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    case "NZ":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportCSV'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    case "GB":
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportToBacs'], true)
                                            //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                            //        break;
                                            //    default:
                                            //}
                                            //document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['MarkAsPaid', 'SendRemittances', 'ExportBatchPaymentReport'], false)

                                            document.getElementById("step1").ej2_instances[0].disabled = false
                                            document.getElementById("step2").ej2_instances[0].disabled = false
                                            document.getElementById("step3").ej2_instances[0].disabled = true
                                            document.getElementById("step4").ej2_instances[0].disabled = true
                                            window.disabledGridEditing = false

                                            //dialogProgressReport.hide()

                                        }
                                        document.getElementById("btnCancelExportReport").onclick = function (e) {
                                            dialogProgressReport.hide();
                                            window.location = "/Home/Index/"
                                        }
                                        //window.location = "/Home/Index/"
                                        document.getElementById("btnPromptCancelExport").onclick = function (e) {
                                            location.href = `/Xero/DownloadCSV/${result.fileNameCSV}/${result.filePathCSV}`; // Change to CSV download URL
                                            dialogProgress.hide()
                                            dialog.hide()
                                        }
                                        return;
                                    }
                                    count += 1;

                                }, 100);
                                //grid.hideSpinner()
                            }
                        }
                    })
                }
            }
        }
    },
    enrichWithCreditNoteData: function (selectedInvoices) {
        if (!window.newDataRecord || window.newDataRecord.length === 0) {
            return selectedInvoices;
        }
        var lookup = {};
        for (var i = 0; i < window.newDataRecord.length; i++) {
            lookup[window.newDataRecord[i].invoiceID] = window.newDataRecord[i];
        }
        for (var j = 0; j < selectedInvoices.length; j++) {
            var original = lookup[selectedInvoices[j].invoiceID];
            if (original) {
                selectedInvoices[j].ListOfCreditNote = original.listOfCreditNote || null;
                selectedInvoices[j].ListOfPayments = original.listOfPayments || null;
                selectedInvoices[j].CreditNoteID = original.creditNoteID || '';
            }
        }
        return selectedInvoices;
    },
    ExportBatchPaymentReportCSV: function (args, args1) {
        document.getElementById("prompProgressDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("prompProgressDialogReport").style.borderBottomRightRadius = "10px";

        document.getElementById("promptInfoDialogReport").style.borderTopLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderTopRightRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomLeftRadius = "10px";
        document.getElementById("promptInfoDialogReport").style.borderBottomRightRadius = "10px";

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";

        var dialog = document.getElementById("promptInfoDialogReport").ej2_instances[0]
        var grid = document.getElementById("Grid").ej2_instances[0]

        var dialogProgressReport = document.getElementById("prompProgressDialogReport").ej2_instances[0]

        var dlgHeader = document.getElementById("prompProgressDialogReport_dialog-header")
        var dlgContent = document.getElementById("prompProgressDialogReport_dialog-content")

        dlgHeader.classList.add("prompt-dlg-header-template")
        dlgContent.classList.add("dlg-content-template")

        dialogProgressReport.show()

        document.getElementById("btnPromptOkayExportReport1").style.visibility = "hidden";
        document.getElementById("btnPromptOkayExportReport1").style.display = "none";
        document.getElementById("promptContentReport1").style.visibility = "hidden";
        document.getElementById("promptContentReport1").style.display = "none";

        document.getElementById("progressStatusOnlyReport").innerHTML = "<span style='color: rgba(0,0,0,.87);'>Preparing your BatchPay report</span>";

        var count = 0;
        var myInterval = setInterval(function () {

            if (count <= 50) {
                document.getElementById('ProgOnlyReport').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
            } else {
                clearInterval(myInterval)
                return;
            }
            count += 1;

        }, 100);

        //debugger
        let payload = {
            selectedInvoices: Object.values(args)
                .flat()
                .filter(i => i.hasBankDetails === true), // Filters invoices with bank details
            payments: args1.invoices.result
        }

        $.ajax({
            url: API_ENDPOINTS.PROCESS_BATCH_REPORT_CSV,
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(payload),
            beforeSend: function () {
                //dialog.hide()
                //grid.showSpinner()
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            success: (result) => {

                if (result.isError) {
                    dialog.hide()
                    grid.hideSpinner()
                    operations.errorHandling(result)
                    return

                } else {

                    document.getElementById("progressStatusOnlyReport").innerHTML = "<span style='color: rgba(0,0,0,.87);'>Preparing your BatchPay report</span>";

                    var count = 50;
                    var myInterval = setInterval(function () {

                        if (count <= 100) {
                            document.getElementById('ProgOnlyReport').innerHTML = '<div class="progress-bar progress-bar-striped bg-success-batchpay progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ' + count + '%"></div>';
                        } else {
                            document.getElementById("ProgOnlyReport").style.visibility = "hidden";
                            document.getElementById("ProgOnlyReport").style.display = "none";
                            document.getElementById("progressStatusOnlyReport").style.visibility = "hidden";
                            document.getElementById("progressStatusOnlyReport").style.display = "none";
                            document.getElementById("promptContentReport1").style.visibility = "visible";
                            document.getElementById("promptContentReport1").style.display = "initial";
                            document.getElementById("promptContentReport1").innerHTML = "Your BatchPay Report is ready to be exported"
                            document.getElementById("btnPromptOkayExportReport1").style.visibility = "visible";
                            document.getElementById("btnPromptOkayExportReport1").style.display = "initial";

                            clearInterval(myInterval)
                            //location.href = `/Xero/DownloadPDF/${result.fileName}/${result.filePath}`
                            //operations.ExportBatchPaymentReportConfirmationForNewTransaction(dialogProgressReport, dialog, result)
                            document.getElementById("btnPromptOkayExportReport1").onclick = function (e) {
                                //operations.onGetBills()
                                var downloadUrl = `/Xero/DownloadCSV/${result.fileNamePDF}/${result.filePathPDF}`; // Change to CSV download URL
                                //dialogProgress.hide()

                                //setTimeout(function () {
                                //    // Reload the page after the delay
                                //    window.location = "/Home/Index/"
                                //}, 2000);


                                var checkDownloadStatus = function () {
                                    var xhr = new XMLHttpRequest();
                                    xhr.open("HEAD", downloadUrl, true);
                                    xhr.onreadystatechange = function () {
                                        if (xhr.readyState === 4) {
                                            // Check if the status code indicates a successful download
                                            if (xhr.status === 200) {
                                                // Reload the page once the download is completed
                                                var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                                                // Clear Selected bills per organization
                                                var filteredSelection = existingSelection.filter(function (item) {
                                                    // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                                                    return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                                                });

                                                // Save the updated selection to localStorage
                                                localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));
                                                window.location.reload();
                                            } else {
                                                // Retry after a delay (e.g., 1000 milliseconds or 1 second)
                                                setTimeout(checkDownloadStatus, 1000);
                                            }
                                        }
                                    };
                                    xhr.send();
                                };

                                // Initiating the download
                                location.href = downloadUrl;

                                // Start checking for download completion after a delay (e.g., 2000 milliseconds or 2 seconds)
                                setTimeout(checkDownloadStatus, 2000);

                                selectedInvoiceWithNoBankDetails = []
                                selectedInvoiceWithNoBankDetailsReportExport = []
                                dialog.hide()
                                //switch (countryCode) {
                                //    case "AU":
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['Export'], true)
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                //        break;
                                //    case "NZ":
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportCSV'], true)
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                //        break;
                                //    case "GB":
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['ExportToBacs'], true)
                                //        document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['UpdateReference'], true)
                                //        break;
                                //    default:
                                //}
                                //document.getElementById("Grid").ej2_instances[0].toolbarModule.enableItems(['MarkAsPaid', 'SendRemittances', 'ExportBatchPaymentReport'], false)

                                document.getElementById("step1").ej2_instances[0].disabled = false
                                document.getElementById("step2").ej2_instances[0].disabled = false
                                document.getElementById("step3").ej2_instances[0].disabled = true
                                document.getElementById("step4").ej2_instances[0].disabled = true
                                window.disabledGridEditing = false

                                //dialogProgressReport.hide()

                            }
                            //window.location = "/Home/Index/"
                            document.getElementById("btnPromptCancelExport").onclick = function (e) {
                                location.href = `/Xero/DownloadCSV/${result.fileName}/${result.filePath}`; // Change to CSV download URL
                                dialogProgress.hide()
                                dialog.hide()
                            }
                            return;
                        }
                        count += 1;

                    }, 100);
                    //grid.hideSpinner()
                }
            },
            error: (error) => {
                console.log(error)
                var existingSelection = JSON.parse(localStorage.getItem(STORAGE_KEYS.SELECTED_DATA)) || [];
                // Clear Selected bills per organization
                var filteredSelection = existingSelection.filter(function (item) {
                    // Remove items that don't have an orgId or have an orgId matching the subscriptionID
                    return item.orgId !== undefined && item.orgId !== window.subscriptionID;
                });

                // Save the updated selection to localStorage
                localStorage.setItem(STORAGE_KEYS.SELECTED_DATA, JSON.stringify(filteredSelection));

            }
        })
    }

}

// Export and expose to window
export default operations;
window.operations = operations;
